webpackJsonp([1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _freeze = __webpack_require__(82);
	
	var _freeze2 = _interopRequireDefault(_freeze);
	
	var _promise = __webpack_require__(3);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _assign = __webpack_require__(85);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _regenerator = __webpack_require__(89);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	__webpack_require__(103);
	
	__webpack_require__(104);
	
	var _hashSum = __webpack_require__(105);
	
	var _hashSum2 = _interopRequireDefault(_hashSum);
	
	var _eventEmitter = __webpack_require__(67);
	
	var _eventEmitter2 = _interopRequireDefault(_eventEmitter);
	
	var _react = __webpack_require__(106);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(265);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRaf = __webpack_require__(266);
	
	var _reactRaf2 = _interopRequireDefault(_reactRaf);
	
	var _motionRadium = __webpack_require__(269);
	
	var _regenerator3 = __webpack_require__(270);
	
	var _regenerator4 = _interopRequireDefault(_regenerator3);
	
	__webpack_require__(271);
	
	__webpack_require__(272);
	
	__webpack_require__(301);
	
	__webpack_require__(304);
	
	var _internal = __webpack_require__(310);
	
	var _internal2 = _interopRequireDefault(_internal);
	
	var _motion = __webpack_require__(311);
	
	var _motion2 = _interopRequireDefault(_motion);
	
	var _createComponent = __webpack_require__(312);
	
	var _createComponent2 = _interopRequireDefault(_createComponent);
	
	var _range = __webpack_require__(340);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _iff = __webpack_require__(343);
	
	var _iff2 = _interopRequireDefault(_iff);
	
	var _router = __webpack_require__(344);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _requireFactory = __webpack_require__(353);
	
	var _requireFactory2 = _interopRequireDefault(_requireFactory);
	
	var _staticStyles = __webpack_require__(354);
	
	var _staticStyles2 = _interopRequireDefault(_staticStyles);
	
	var _safeRun = __webpack_require__(355);
	
	var _safeRun2 = _interopRequireDefault(_safeRun);
	
	var _reportError = __webpack_require__(305);
	
	var _reportError2 = _interopRequireDefault(_reportError);
	
	var _arrayDiff = __webpack_require__(356);
	
	var _arrayDiff2 = _interopRequireDefault(_arrayDiff);
	
	var _createElement = __webpack_require__(323);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _ErrorDefinedTwice = __webpack_require__(357);
	
	var _ErrorDefinedTwice2 = _interopRequireDefault(_ErrorDefinedTwice);
	
	var _NotFound = __webpack_require__(358);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _LastWorkingMain = __webpack_require__(359);
	
	var _LastWorkingMain2 = _interopRequireDefault(_LastWorkingMain);
	
	var _Main = __webpack_require__(360);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var folderFromFile = function folderFromFile(filePath) {
	  return filePath.indexOf('/') < 0 ? '' : filePath.substring(0, filePath.lastIndexOf('/'));
	};
	
	/*
	  Welcome to Motion!
	
	    This file deals mostly with setting up Motion,
	    loading views and files, rendering,
	    and exposing the public Motion functions
	*/
	
	var Motion = {
	  // set up motion shims
	
	  init: function init() {
	    var originalWarn = console.warn;
	    // filter radium warnings for now
	    console.warn = function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      if (args[0] && args[0].indexOf('Unsupported CSS property "display') == 0) return;
	      if (args[0] && args[0].indexOf('Radium:') == 0) return;
	      originalWarn.call.apply(originalWarn, [console].concat(args));
	    };
	
	    // prevent breaking when writing $ styles in auto-save mode
	    if (false) {
	      root.$ = null;
	    }
	
	    if (true) {
	      _reactRaf2.default.inject();
	    }
	
	    // shims
	    root.React = _react2.default;
	    root.ReactDOM = _reactDom2.default;
	    root.global = root; // for radium
	    root.regeneratorRuntime = _regenerator2.default;
	    root.on = on;
	    root.fetch.json = function (a, b, c) {
	      return fetch(a, b, c).then(function (res) {
	        return res.json();
	      });
	    };
	    root.require = (0, _requireFactory2.default)(root);
	  },
	
	
	  // run an app
	  run: function run(name, _opts, afterRenderCb) {
	    // default opts
	    var opts = (0, _assign2.default)({
	      node: '_motionapp'
	    }, _opts);
	
	    var ID = '' + Math.random();
	
	    // init require
	    root.require.setApp(name);
	
	    // init Internal
	    var Internal = _internal2.default.init(ID);
	    root._Motion = Internal;
	
	    // tools bridge
	    var Tools = root._DT;
	
	    if (false) {
	      // pass data from tools to internal
	      Tools.on('editor:state', function () {
	        Internal.editor = Tools.editor;
	      });
	    }
	
	    // setup shims that use Internal
	    (0, _motion2.default)(Internal, Tools);
	    var LastWorkingMain = (0, _LastWorkingMain2.default)(Internal);
	
	    var emitter = (0, _eventEmitter2.default)({});
	
	    //
	    // begin the motionception
	    //
	
	    var Motion = {
	      start: function start() {
	        _router2.default.init(ID, { onChange: Motion.render });
	        Motion.render();
	      },
	
	
	      views: {},
	
	      // beta
	      _onViewInstance: function _onViewInstance(name, decorator) {
	        return !decorator ? Internal.instanceDecorator.all = name : Internal.instanceDecorator[name] = decorator;
	      },
	
	      // decorate a view instance
	      decorateView: function decorateView(name, decorator) {
	        return !decorator ? Internal.viewDecorator.all = name : Internal.viewDecorator[name] = decorator;
	      },
	
	      keyframes: _motionRadium.keyframes,
	
	      router: _router2.default,
	
	      // async functions before loading app
	      preloaders: [],
	      preload: function preload(fn) {
	        Motion.preloaders.push(fn);
	      },
	      render: function render() {
	        if (Motion.preloaders.length) {
	          return _promise2.default.all(Motion.preloaders.map(function (loader) {
	            return typeof loader == 'function' ? loader() : loader;
	          })).then(run);
	        } else run();
	
	        function run() {
	          Internal.isRendering++;
	          if (Internal.isRendering > 3) return;
	
	          // find Main
	          var Main = Internal.views.Main && Internal.views.Main.component;
	          if (!Main && Internal.lastWorkingRenders.Main) Main = LastWorkingMain;
	          if (!Main) Main = _Main2.default;
	
	          // server render
	          if (!opts.node) {
	            Motion.renderedToString = _react2.default.renderToString(_react2.default.createElement(Main, null));
	            afterRenderCb && afterRenderCb(Motion.renderedToString);
	          }
	          // browser render
	          else {
	              if (window.__isDevingDevTools) opts.node = '_motiondevtools';
	
	              _reactDom2.default.render(_react2.default.createElement(
	                _motionRadium.StyleRoot,
	                { className: '__motionRoot' },
	                _react2.default.createElement(Main, null)
	              ), document.getElementById(opts.node));
	            }
	
	          Internal.lastWorkingViews.Main = Main;
	          emitter.emit('render:done');
	          Internal.isRendering = 0;
	        }
	      },
	
	
	      // motion events
	      on: function on(name, cb) {
	        emitter.on(name, cb);
	      },
	
	
	      // for use in jsx
	      debug: function debug() {
	        debugger;
	      },
	
	      view: function view(name, body) {
	        var comp = function comp(opts) {
	          return (0, _createComponent2.default)(Motion, Internal, name, body, opts);
	        };
	
	        if (true) return setView(name, comp());
	
	        var hash = (0, _hashSum2.default)(body);
	
	        function setView(name, component) {
	          Internal.views[name] = { hash: hash, component: component, file: Internal.currentHotFile };
	          Motion.views[name] = component;
	        }
	
	        // set view in cache
	        var viewsInFile = Internal.viewsInFile[Internal.currentHotFile];
	        if (viewsInFile) viewsInFile.push(name);
	
	        // if new
	        if (!Internal.views[name]) {
	          setView(name, comp({ hash: hash, changed: true }));
	          Internal.changedViews.push(name);
	          return;
	        }
	
	        // dev stuff
	        if (false) {
	          if (!Internal.mountedViews[name]) Internal.mountedViews[name] = [];
	
	          // not new
	          // if defined twice during first run
	          if (Internal.firstRender && !Internal.runtimeErrors) {
	            Internal.views[name] = (0, _ErrorDefinedTwice2.default)(name);
	            throw new Error('Defined a view twice: ' + name);
	          }
	
	          // if unchanged
	          if (Internal.views[name].hash == hash) {
	            setView(name, comp({ hash: hash, unchanged: true }));
	            return;
	          }
	
	          // changed
	          setView(name, comp({ hash: hash, changed: true }));
	          Internal.changedViews.push(name);
	
	          // this resets tool errors
	          window.onViewLoaded();
	        }
	      },
	      getView: function getView(name) {
	        return Motion.views[name] || (0, _NotFound2.default)(name);
	      },
	
	
	      //
	      //  private API (TODO move this)
	      //
	
	      // styles, TODO: move to Internal
	      staticStyles: _staticStyles2.default,
	      viewRoots: {},
	      styleClasses: {},
	      styleObjects: {},
	
	      // load a file
	      file: function file(_file, run) {
	        if (false) {
	          Internal.viewsInFile[_file] = [];
	          Internal.changedViews = [];
	          Internal.currentHotFile = _file;
	          Internal.caughtRuntimeErrors = 0;
	
	          // send runtime success before render
	          Tools && Tools.emitter.emit('runtime:success');
	          Internal.lastFileLoad = Date.now();
	        }
	
	        // set up require for file that resolves relative paths
	        var fileFolder = folderFromFile(_file);
	        var scopedRequire = function scopedRequire(pkg) {
	          return root.require(pkg, fileFolder);
	        };
	
	        // run file!
	        run(scopedRequire);
	
	        if (false) {
	          var cached = Internal.viewCache[_file] || Internal.viewsInFile[_file];
	          var views = Internal.viewsInFile[_file];
	          // views.map(view => {
	          //   Motion.timer.time(view, Motion.timer.lastMsgInfo)
	          // })
	
	          // remove Internal.viewsInFile that werent made
	          var removedViews = (0, _arrayDiff2.default)(cached, views);
	          removedViews.map(Internal.removeView);
	
	          Internal.currentHotFile = null;
	          Internal.viewCache[_file] = Internal.viewsInFile[_file];
	
	          if (Internal.firstRender) return;
	
	          var isNewFile = !cached.length;
	          var addedViews = (0, _arrayDiff2.default)(views, cached);
	
	          // safe re-render
	          if (isNewFile || removedViews.length || addedViews.length) return Motion.render();
	
	          // if outside of views the FILE changed, refresh all views in file
	          if (!Internal.changedViews.length && Internal.fileChanged[_file]) {
	            Internal.changedViews = Internal.viewsInFile[_file];
	          }
	
	          Internal.changedViews.forEach(function (name) {
	            if (!Internal.mountedViews[name]) return;
	
	            Internal.mountedViews[name] = Internal.mountedViews[name].map(function (view) {
	              if (view.isMounted()) {
	                view.forceUpdate();
	                return view;
	              }
	            }).filter(function (x) {
	              return !!x;
	            });
	
	            emitter.emit('render:done');
	            // views.map(view => Motion.timer.done(view))
	            // Motion.timer.lastMsgInfo = null
	          });
	        }
	      },
	      removeFile: function removeFile(file) {
	        var viewsFromFile = Internal.viewsInFile[file];
	        viewsFromFile.forEach(Internal.removeView);
	
	        delete Internal.viewCache[file];
	        delete Internal.viewsInFile[file];
	      },
	      deleteFile: function deleteFile(name) {
	        var viewsInFile = Internal.viewsInFile[name];
	
	        if (viewsInFile) {
	          Internal.viewsInFile[name].map(Internal.removeView);
	          delete Internal.viewsInFile[name];
	        }
	
	        delete Internal.viewCache[name];
	        Motion.render();
	      },
	      routeMatch: function routeMatch(path) {
	        _router2.default.add(path);
	        return _router2.default.isActive(path);
	      },
	      routeParams: function routeParams(path) {
	        return _router2.default.getParams(path);
	      },
	      inspect: function inspect(path, cb) {
	        Internal.inspector[path] = cb;
	        Internal.setInspector(path);
	      },
	
	
	      reportError: _reportError2.default,
	      range: _range2.default,
	      iff: _iff2.default,
	      noop: function noop() {}
	    };
	
	    // view shim (TODO freeze)
	    root.view = {
	      el: function el(info, props) {
	        if (typeof info[0] === 'string' && info[0].charAt(0).toUpperCase() === info[0].charAt(0)) {
	          return _react2.default.createElement(Motion.getView(info[0]), props);
	        }
	
	        for (var _len2 = arguments.length, children = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          children[_key2 - 2] = arguments[_key2];
	        }
	
	        return _react2.default.createElement.apply(_react2.default, [info[0], props].concat(children));
	      }
	    };
	
	    // prevent overwriting
	    (0, _freeze2.default)(Motion);
	
	    // if given an app, run it
	    if (name && root.exports[name]) {
	      var app = root.exports[name];
	      app(Motion, opts);
	    }
	
	    return Motion;
	  }
	};
	
	root.exports.motion = Motion;

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(83), __esModule: true };

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(84);
	module.exports = __webpack_require__(14).Object.freeze;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(39);
	
	__webpack_require__(63)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(it) : it;
	  };
	});

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(86), __esModule: true };

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(87);
	module.exports = __webpack_require__(14).Object.assign;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(12);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(88)});

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(19)
	  , toObject = __webpack_require__(62)
	  , IObject  = __webpack_require__(35);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(22)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(90);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	module.exports = { "default": module.exports, __esModule: true };


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	"use strict";
	
	var _Symbol = __webpack_require__(91)["default"];
	
	var _Object$create = __webpack_require__(98)["default"];
	
	var _Object$setPrototypeOf = __webpack_require__(100)["default"];
	
	var _Promise = __webpack_require__(3)["default"];
	
	!(function (global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof _Symbol === "function" ? _Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = _Object$create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function (method) {
	      prototype[method] = function (arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function (genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor ? ctor === GeneratorFunction ||
	    // For the native GeneratorFunction constructor, the best we can
	    // do is to check its .name property.
	    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
	  };
	
	  runtime.mark = function (genFun) {
	    if (_Object$setPrototypeOf) {
	      _Object$setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = _Object$create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function (arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return _Promise.resolve(value.arg).then(function (value) {
	            invoke("next", value, resolve, reject);
	          }, function (err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return _Promise.resolve(value).then(function (unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new _Promise(function (resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	      // If enqueue has been called before, then we want to wait until
	      // all previous Promises have been resolved before calling invoke,
	      // so that results are always delivered in the correct order. If
	      // enqueue has not been called before, then it is important to
	      // call invoke immediately, without waiting on a callback to fire,
	      // so that the async generator function has the opportunity to do
	      // any necessary setup in a predictable way. This predictability
	      // is why the Promise constructor synchronously invokes its
	      // executor callback, and why async functions synchronously
	      // execute code before the first await. Since we implement simple
	      // async functions in terms of async generators, it is especially
	      // important to get this right, even though it requires care.
	      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
	      // Avoid propagating failures to Promises returned by later
	      // invocations of the iterator.
	      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
	
	    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
	    : iter.next().then(function (result) {
	      return result.done ? result.value : iter.next();
	    });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" || method === "throw" && delegate.iterator[method] === undefined) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(delegate.iterator[method], delegate.iterator, arg);
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done ? GenStateCompleted : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function () {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function () {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function (object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1,
	            next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function reset(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function stop() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function dispatchException(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function abrupt(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function complete(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" || record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function finish(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function _catch(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	// Among the various tricks for obtaining a reference to the global
	// object, this seems to be the most reliable technique that does not
	// use indirect eval (which violates Content Security Policy).
	typeof global === "object" ? global : typeof window === "object" ? window : typeof self === "object" ? self : undefined);

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(92), __esModule: true };

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(93);
	__webpack_require__(5);
	module.exports = __webpack_require__(14).Symbol;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var $              = __webpack_require__(19)
	  , global         = __webpack_require__(13)
	  , has            = __webpack_require__(23)
	  , DESCRIPTORS    = __webpack_require__(21)
	  , $export        = __webpack_require__(12)
	  , redefine       = __webpack_require__(17)
	  , $fails         = __webpack_require__(22)
	  , shared         = __webpack_require__(28)
	  , setToStringTag = __webpack_require__(26)
	  , uid            = __webpack_require__(29)
	  , wks            = __webpack_require__(27)
	  , keyOf          = __webpack_require__(94)
	  , $names         = __webpack_require__(95)
	  , enumKeys       = __webpack_require__(96)
	  , isArray        = __webpack_require__(97)
	  , anObject       = __webpack_require__(40)
	  , toIObject      = __webpack_require__(34)
	  , createDesc     = __webpack_require__(20)
	  , getDesc        = $.getDesc
	  , setDesc        = $.setDesc
	  , _create        = $.create
	  , getNames       = $names.get
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , setter         = false
	  , HIDDEN         = wks('_hidden')
	  , isEnum         = $.isEnum
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , useNative      = typeof $Symbol == 'function'
	  , ObjectProto    = Object.prototype;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(setDesc({}, 'a', {
	    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = getDesc(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  setDesc(it, key, D);
	  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	} : setDesc;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol.prototype);
	  sym._k = tag;
	  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    }
	  });
	  return sym;
	};
	
	var isSymbol = function(it){
	  return typeof it == 'symbol';
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toIObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
	  return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	};
	var $stringify = function stringify(it){
	  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	  var args = [it]
	    , i    = 1
	    , $$   = arguments
	    , replacer, $replacer;
	  while($$.length > i)args.push($$[i++]);
	  replacer = args[1];
	  if(typeof replacer == 'function')$replacer = replacer;
	  if($replacer || !isArray(replacer))replacer = function(key, value){
	    if($replacer)value = $replacer.call(this, key, value);
	    if(!isSymbol(value))return value;
	  };
	  args[1] = replacer;
	  return _stringify.apply($JSON, args);
	};
	var buggyJSON = $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	});
	
	// 19.4.1.1 Symbol([description])
	if(!useNative){
	  $Symbol = function Symbol(){
	    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
	  };
	  redefine($Symbol.prototype, 'toString', function toString(){
	    return this._k;
	  });
	
	  isSymbol = function(it){
	    return it instanceof $Symbol;
	  };
	
	  $.create     = $create;
	  $.isEnum     = $propertyIsEnumerable;
	  $.getDesc    = $getOwnPropertyDescriptor;
	  $.setDesc    = $defineProperty;
	  $.setDescs   = $defineProperties;
	  $.getNames   = $names.get = $getOwnPropertyNames;
	  $.getSymbols = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(11)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	}
	
	var symbolStatics = {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	};
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	  'species,split,toPrimitive,toStringTag,unscopables'
	).split(','), function(it){
	  var sym = wks(it);
	  symbolStatics[it] = useNative ? sym : wrap(sym);
	});
	
	setter = true;
	
	$export($export.G + $export.W, {Symbol: $Symbol});
	
	$export($export.S, 'Symbol', symbolStatics);
	
	$export($export.S + $export.F * !useNative, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});
	
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(19)
	  , toIObject = __webpack_require__(34);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(34)
	  , getNames  = __webpack_require__(19).getNames
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.get = function getOwnPropertyNames(it){
	  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
	  return getNames(toIObject(it));
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(19);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(36);
	module.exports = Array.isArray || function(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(99), __esModule: true };

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(19);
	module.exports = function create(P, D){
	  return $.create(P, D);
	};

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(101), __esModule: true };

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(102);
	module.exports = __webpack_require__(14).Object.setPrototypeOf;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(12);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(47).set});

/***/ },
/* 103 */
/***/ function(module, exports) {

	(function() {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  var support = {
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob();
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = xhr.getAllResponseHeaders().trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this._initBody(bodyInit)
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers;
	  self.Request = Request;
	  self.Response = Response;
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return;
	      }
	
	      xhr.onload = function() {
	        var status = (xhr.status === 1223) ? 204 : xhr.status
	        if (status < 100 || status > 599) {
	          reject(new TypeError('Network request failed'))
	          return
	        }
	        var options = {
	          status: status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})();


/***/ },
/* 104 */
/***/ function(module, exports) {

	// adapted from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	
	if (!Object.assign) {
	  Object.defineProperty(Object, "assign", {
	    enumerable: false,
	    configurable: true,
	    writable: true,
	    value: function(target, firstSource) {
	      "use strict";
	      if (target === undefined || target === null)
	        throw new TypeError("Cannot convert first argument to object");
	
	      var to = Object(target);
	
	      var hasPendingException = false;
	      var pendingException;
	
	      for (var i = 1; i < arguments.length; i++) {
	        var nextSource = arguments[i];
	        if (nextSource === undefined || nextSource === null)
	          continue;
	
	        var keysArray = Object.keys(Object(nextSource));
	        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
	          var nextKey = keysArray[nextIndex];
	          try {
	            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	            if (desc !== undefined && desc.enumerable)
	              to[nextKey] = nextSource[nextKey];
	          } catch (e) {
	            if (!hasPendingException) {
	              hasPendingException = true;
	              pendingException = e;
	            }
	          }
	        }
	
	        if (hasPendingException)
	          throw pendingException;
	      }
	      return to;
	    }
	  });
	}

/***/ },
/* 105 */
/***/ function(module, exports) {

	'use strict';
	
	function pad (hash, len) {
	  while (hash.length < len) {
	    hash = '0' + hash;
	  }
	  return hash;
	}
	
	function fold (hash, text) {
	  var i;
	  var chr;
	  var len;
	  if (text.length === 0) {
	    return hash;
	  }
	  for (i = 0, len = text.length; i < len; i++) {
	    chr = text.charCodeAt(i);
	    hash = ((hash << 5) - hash) + chr;
	    hash |= 0;
	  }
	  return hash < 0 ? hash * -2 : hash;
	}
	
	function foldObject (hash, o, seen) {
	  return Object.keys(o).sort().reduce(foldKey, hash);
	  function foldKey (hash, key) {
	    return foldValue(hash, o[key], key, seen);
	  }
	}
	
	function foldValue (input, value, key, seen) {
	  var hash = fold(fold(fold(input, key), toString(value)), typeof value);
	  if (value === null) {
	    return fold(hash, 'null');
	  }
	  if (value === undefined) {
	    return fold(hash, 'undefined');
	  }
	  if (typeof value === 'object') {
	    if (seen.indexOf(value) !== -1) {
	      return fold(hash, '[Circular]' + key);
	    }
	    seen.push(value);
	    return foldObject(hash, value, seen);
	  }
	  return fold(hash, value.toString());
	}
	
	function toString (o) {
	  return Object.prototype.toString.call(o);
	}
	
	function sum (o) {
	  return pad(foldValue(0, o, '', []).toString(16), 8);
	}
	
	module.exports = sum;


/***/ },
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ReactUpdates = __webpack_require__(136);
	
	var _ReactUpdates2 = _interopRequireDefault(_ReactUpdates);
	
	var _raf = __webpack_require__(267);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tick = function tick() {
	  _ReactUpdates2.default.flushBatchedUpdates();
	  (0, _raf2.default)(tick);
	};
	
	var inject = function inject() {
	  _ReactUpdates2.default.injection.injectBatchingStrategy({
	    isBatchingUpdates: true,
	    batchedUpdates: function batchedUpdates(callback) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      callback.apply(undefined, args);
	    }
	  });
	  (0, _raf2.default)(tick);
	};
	
	exports.default = { inject: inject };

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var now = __webpack_require__(268)
	  , global = typeof window === 'undefined' ? {} : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = global['request' + suffix]
	  , caf = global['cancel' + suffix] || global['cancelRequest' + suffix]
	
	for(var i = 0; i < vendors.length && !raf; i++) {
	  raf = global[vendors[i] + 'Request' + suffix]
	  caf = global[vendors[i] + 'Cancel' + suffix]
	      || global[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(global, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(global, arguments)
	}


/***/ },
/* 268 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(106));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else if(typeof exports === 'object')
			exports["Radium"] = factory(require("react"));
		else
			root["Radium"] = factory(root["React"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _enhancer = __webpack_require__(1);
	
		var _enhancer2 = _interopRequireDefault(_enhancer);
	
		var _plugins = __webpack_require__(34);
	
		var _plugins2 = _interopRequireDefault(_plugins);
	
		var _style = __webpack_require__(45);
	
		var _style2 = _interopRequireDefault(_style);
	
		var _styleRoot = __webpack_require__(46);
	
		var _styleRoot2 = _interopRequireDefault(_styleRoot);
	
		var _getState = __webpack_require__(30);
	
		var _getState2 = _interopRequireDefault(_getState);
	
		var _keyframes = __webpack_require__(48);
	
		var _keyframes2 = _interopRequireDefault(_keyframes);
	
		var _resolveStyles = __webpack_require__(5);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function Radium(ComposedComponent) {
		  return (0, _enhancer2.default)(ComposedComponent);
		}
	
		Radium.Plugins = _plugins2.default;
		Radium.Style = _style2.default;
		Radium.StyleRoot = _styleRoot2.default;
		Radium.getState = _getState2.default;
		Radium.keyframes = _keyframes2.default;
		Radium.__clearStateForTests = _resolveStyles.__clearStateForTests;
	
		exports.default = Radium;
		module.exports = exports['default'];
	
	/***/ },
	/* 1 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		exports.default = enhanceWithRadium;
	
		var _react = __webpack_require__(3);
	
		var _styleKeeper = __webpack_require__(4);
	
		var _styleKeeper2 = _interopRequireDefault(_styleKeeper);
	
		var _resolveStyles = __webpack_require__(5);
	
		var _resolveStyles2 = _interopRequireDefault(_resolveStyles);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES = ['arguments', 'callee', 'caller', 'length', 'name', 'prototype', 'type'];
	
		function copyProperties(source, target) {
		  Object.getOwnPropertyNames(source).forEach(function (key) {
		    if (KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES.indexOf(key) < 0 && !target.hasOwnProperty(key)) {
		      var descriptor = Object.getOwnPropertyDescriptor(source, key);
		      Object.defineProperty(target, key, descriptor);
		    }
		  });
		}
	
		function enhanceWithRadium(configOrComposedComponent) {
		  var _class, _temp;
	
		  var config = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		  if (typeof configOrComposedComponent !== 'function') {
		    var _ret = function () {
		      var newConfig = _extends({}, config, configOrComposedComponent);
		      return {
		        v: function v(configOrComponent) {
		          return enhanceWithRadium(configOrComponent, newConfig);
		        }
		      };
		    }();
	
		    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
		  }
	
		  var component = configOrComposedComponent;
		  var ComposedComponent = component;
	
		  // Handle stateless components
		  if (!ComposedComponent.render && !ComposedComponent.prototype.render) {
		    ComposedComponent = function (_Component) {
		      _inherits(ComposedComponent, _Component);
	
		      function ComposedComponent() {
		        _classCallCheck(this, ComposedComponent);
	
		        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
		      }
	
		      ComposedComponent.prototype.render = function render() {
		        return component(this.props, this.context);
		      };
	
		      return ComposedComponent;
		    }(_react.Component);
		    ComposedComponent.displayName = component.displayName || component.name;
		  }
	
		  var RadiumEnhancer = (_temp = _class = function (_ComposedComponent) {
		    _inherits(RadiumEnhancer, _ComposedComponent);
	
		    function RadiumEnhancer() {
		      _classCallCheck(this, RadiumEnhancer);
	
		      var _this2 = _possibleConstructorReturn(this, _ComposedComponent.apply(this, arguments));
	
		      _this2.state = _this2.state || {};
		      _this2.state._radiumStyleState = {};
		      _this2._radiumIsMounted = true;
		      return _this2;
		    }
	
		    RadiumEnhancer.prototype.componentWillUnmount = function componentWillUnmount() {
		      if (_ComposedComponent.prototype.componentWillUnmount) {
		        _ComposedComponent.prototype.componentWillUnmount.call(this);
		      }
	
		      this._radiumIsMounted = false;
	
		      if (this._radiumMouseUpListener) {
		        this._radiumMouseUpListener.remove();
		      }
	
		      if (this._radiumMediaQueryListenersByQuery) {
		        Object.keys(this._radiumMediaQueryListenersByQuery).forEach(function (query) {
		          this._radiumMediaQueryListenersByQuery[query].remove();
		        }, this);
		      }
		    };
	
		    RadiumEnhancer.prototype.getChildContext = function getChildContext() {
		      var superChildContext = _ComposedComponent.prototype.getChildContext ? _ComposedComponent.prototype.getChildContext.call(this) : {};
	
		      if (!this.props.radiumConfig) {
		        return superChildContext;
		      }
	
		      var newContext = _extends({}, superChildContext);
	
		      if (this.props.radiumConfig) {
		        newContext._radiumConfig = this.props.radiumConfig;
		      }
	
		      return newContext;
		    };
	
		    RadiumEnhancer.prototype.render = function render() {
		      var renderedElement = _ComposedComponent.prototype.render.call(this);
		      var currentConfig = this.props.radiumConfig || this.context._radiumConfig || config;
	
		      if (config && currentConfig !== config) {
		        currentConfig = _extends({}, config, currentConfig);
		      }
	
		      return (0, _resolveStyles2.default)(this, renderedElement, currentConfig);
		    };
	
		    return RadiumEnhancer;
		  }(ComposedComponent), _class._isRadiumEnhanced = true, _temp);
	
		  // Class inheritance uses Object.create and because of __proto__ issues
		  // with IE <10 any static properties of the superclass aren't inherited and
		  // so need to be manually populated.
		  // See http://babeljs.io/docs/advanced/caveats/#classes-10-and-below-
	
		  copyProperties(component, RadiumEnhancer);
	
		  if (process.env.NODE_ENV !== 'production') {
		    // This also fixes React Hot Loader by exposing the original components top
		    // level prototype methods on the Radium enhanced prototype as discussed in
		    // https://github.com/FormidableLabs/radium/issues/219.
		    copyProperties(ComposedComponent.prototype, RadiumEnhancer.prototype);
		  }
	
		  if (RadiumEnhancer.propTypes && RadiumEnhancer.propTypes.style) {
		    RadiumEnhancer.propTypes = _extends({}, RadiumEnhancer.propTypes, {
		      style: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object])
		    });
		  }
	
		  RadiumEnhancer.displayName = component.displayName || component.name || 'Component';
	
		  RadiumEnhancer.contextTypes = _extends({}, RadiumEnhancer.contextTypes, {
		    _radiumConfig: _react.PropTypes.object,
		    _radiumStyleKeeper: _react.PropTypes.instanceOf(_styleKeeper2.default)
		  });
	
		  RadiumEnhancer.childContextTypes = _extends({}, RadiumEnhancer.childContextTypes, {
		    _radiumConfig: _react.PropTypes.object,
		    _radiumStyleKeeper: _react.PropTypes.instanceOf(_styleKeeper2.default)
		  });
	
		  return RadiumEnhancer;
		}
		module.exports = exports['default'];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))
	
	/***/ },
	/* 2 */
	/***/ function(module, exports) {
	
		'use strict';
	
		// shim for using process in browser
	
		var process = module.exports = {};
		var queue = [];
		var draining = false;
		var currentQueue;
		var queueIndex = -1;
	
		function cleanUpNextTick() {
		    draining = false;
		    if (currentQueue.length) {
		        queue = currentQueue.concat(queue);
		    } else {
		        queueIndex = -1;
		    }
		    if (queue.length) {
		        drainQueue();
		    }
		}
	
		function drainQueue() {
		    if (draining) {
		        return;
		    }
		    var timeout = setTimeout(cleanUpNextTick);
		    draining = true;
	
		    var len = queue.length;
		    while (len) {
		        currentQueue = queue;
		        queue = [];
		        while (++queueIndex < len) {
		            if (currentQueue) {
		                currentQueue[queueIndex].run();
		            }
		        }
		        queueIndex = -1;
		        len = queue.length;
		    }
		    currentQueue = null;
		    draining = false;
		    clearTimeout(timeout);
		}
	
		process.nextTick = function (fun) {
		    var args = new Array(arguments.length - 1);
		    if (arguments.length > 1) {
		        for (var i = 1; i < arguments.length; i++) {
		            args[i - 1] = arguments[i];
		        }
		    }
		    queue.push(new Item(fun, args));
		    if (queue.length === 1 && !draining) {
		        setTimeout(drainQueue, 0);
		    }
		};
	
		// v8 likes predictible objects
		function Item(fun, array) {
		    this.fun = fun;
		    this.array = array;
		}
		Item.prototype.run = function () {
		    this.fun.apply(null, this.array);
		};
		process.title = 'browser';
		process.browser = true;
		process.env = {};
		process.argv = [];
		process.version = ''; // empty string to avoid regexp issues
		process.versions = {};
	
		function noop() {}
	
		process.on = noop;
		process.addListener = noop;
		process.once = noop;
		process.off = noop;
		process.removeListener = noop;
		process.removeAllListeners = noop;
		process.emit = noop;
	
		process.binding = function (name) {
		    throw new Error('process.binding is not supported');
		};
	
		process.cwd = function () {
		    return '/';
		};
		process.chdir = function (dir) {
		    throw new Error('process.chdir is not supported');
		};
		process.umask = function () {
		    return 0;
		};
	
	/***/ },
	/* 3 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_3__;
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		var StyleKeeper = function () {
		  function StyleKeeper(userAgent) {
		    _classCallCheck(this, StyleKeeper);
	
		    this._userAgent = userAgent;
		    this._listeners = [];
		    this._cssSet = {};
		  }
	
		  StyleKeeper.prototype.subscribe = function subscribe(listener) {
		    var _this = this;
	
		    if (this._listeners.indexOf(listener) === -1) {
		      this._listeners.push(listener);
		    }
	
		    return {
		      // Must be fat arrow to capture `this`
		      remove: function remove() {
		        var listenerIndex = _this._listeners.indexOf(listener);
		        if (listenerIndex > -1) {
		          _this._listeners.splice(listenerIndex, 1);
		        }
		      }
		    };
		  };
	
		  StyleKeeper.prototype.addCSS = function addCSS(css) {
		    var _this2 = this;
	
		    if (!this._cssSet[css]) {
		      this._cssSet[css] = true;
		      this._emitChange();
		    }
	
		    return {
		      // Must be fat arrow to capture `this`
		      remove: function remove() {
		        delete _this2._cssSet[css];
		        _this2._emitChange();
		      }
		    };
		  };
	
		  StyleKeeper.prototype.getCSS = function getCSS() {
		    return Object.keys(this._cssSet).join('\n');
		  };
	
		  StyleKeeper.prototype._emitChange = function _emitChange() {
		    this._listeners.forEach(function (listener) {
		      return listener();
		    });
		  };
	
		  return StyleKeeper;
		}();
	
		exports.default = StyleKeeper;
		module.exports = exports['default'];
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		var _appendImportantToEachValue = __webpack_require__(6);
	
		var _appendImportantToEachValue2 = _interopRequireDefault(_appendImportantToEachValue);
	
		var _cssRuleSetToString = __webpack_require__(9);
	
		var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);
	
		var _getState = __webpack_require__(30);
	
		var _getState2 = _interopRequireDefault(_getState);
	
		var _getStateKey = __webpack_require__(31);
	
		var _getStateKey2 = _interopRequireDefault(_getStateKey);
	
		var _hash = __webpack_require__(32);
	
		var _hash2 = _interopRequireDefault(_hash);
	
		var _mergeStyles = __webpack_require__(33);
	
		var _plugins = __webpack_require__(34);
	
		var _plugins2 = _interopRequireDefault(_plugins);
	
		var _exenv = __webpack_require__(43);
	
		var _exenv2 = _interopRequireDefault(_exenv);
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var DEFAULT_CONFIG = {
		  plugins: [_plugins2.default.mergeStyleArray, _plugins2.default.checkProps, _plugins2.default.resolveMediaQueries, _plugins2.default.resolveInteractionStyles, _plugins2.default.keyframes, _plugins2.default.visited, _plugins2.default.prefix, _plugins2.default.checkProps]
		};
	
		// Gross
		var globalState = {};
	
		// Declare early for recursive helpers.
		var resolveStyles = null;
	
		var _shouldResolveStyles = function _shouldResolveStyles(component) {
		  return component.type && !component.type._isRadiumEnhanced;
		};
	
		var _resolveChildren = function _resolveChildren(_ref) {
		  var children = _ref.children;
		  var component = _ref.component;
		  var config = _ref.config;
		  var existingKeyMap = _ref.existingKeyMap;
	
		  if (!children) {
		    return children;
		  }
	
		  var childrenType = typeof children === 'undefined' ? 'undefined' : _typeof(children);
	
		  if (childrenType === 'string' || childrenType === 'number') {
		    // Don't do anything with a single primitive child
		    return children;
		  }
	
		  if (childrenType === 'function') {
		    // Wrap the function, resolving styles on the result
		    return function () {
		      var result = children.apply(this, arguments);
		      if (_react2.default.isValidElement(result)) {
		        return resolveStyles(component, result, config, existingKeyMap, true);
		      }
		      return result;
		    };
		  }
	
		  if (_react2.default.Children.count(children) === 1 && children.type) {
		    // If a React Element is an only child, don't wrap it in an array for
		    // React.Children.map() for React.Children.only() compatibility.
		    var onlyChild = _react2.default.Children.only(children);
		    return resolveStyles(component, onlyChild, config, existingKeyMap, true);
		  }
	
		  return _react2.default.Children.map(children, function (child) {
		    if (_react2.default.isValidElement(child)) {
		      return resolveStyles(component, child, config, existingKeyMap, true);
		    }
	
		    return child;
		  });
		};
	
		var _buildGetKey = function _buildGetKey(_ref2) {
		  var componentName = _ref2.componentName;
		  var existingKeyMap = _ref2.existingKeyMap;
		  var renderedElement = _ref2.renderedElement;
	
		  // We need a unique key to correlate state changes due to user interaction
		  // with the rendered element, so we know to apply the proper interactive
		  // styles.
		  var originalKey = typeof renderedElement.ref === 'string' ? renderedElement.ref : renderedElement.key;
		  var key = (0, _getStateKey2.default)(originalKey);
	
		  var alreadyGotKey = false;
		  var getKey = function getKey() {
		    if (alreadyGotKey) {
		      return key;
		    }
	
		    alreadyGotKey = true;
	
		    if (existingKeyMap[key]) {
		      var elementName = undefined;
		      if (typeof renderedElement.type === 'string') {
		        elementName = renderedElement.type;
		      } else if (renderedElement.type.constructor) {
		        elementName = renderedElement.type.constructor.displayName || renderedElement.type.constructor.name;
		      }
	
		      throw new Error('Radium requires each element with interactive styles to have a unique ' + 'key, set using either the ref or key prop. ' + (originalKey ? 'Key "' + originalKey + '" is a duplicate.' : 'Multiple elements have no key specified.') + ' ' + 'Component: "' + componentName + '". ' + (elementName ? 'Element: "' + elementName + '".' : ''));
		    }
	
		    existingKeyMap[key] = true;
	
		    return key;
		  };
	
		  return getKey;
		};
	
		var _setStyleState = function _setStyleState(component, key, stateKey, value) {
		  if (!component._radiumIsMounted) {
		    return;
		  }
	
		  var existing = component._lastRadiumState || component.state && component.state._radiumStyleState || {};
	
		  var state = { _radiumStyleState: _extends({}, existing) };
		  state._radiumStyleState[key] = _extends({}, state._radiumStyleState[key]);
		  state._radiumStyleState[key][stateKey] = value;
	
		  component._lastRadiumState = state._radiumStyleState;
		  component.setState(state);
		};
	
		var _runPlugins = function _runPlugins(_ref3) {
		  var component = _ref3.component;
		  var config = _ref3.config;
		  var existingKeyMap = _ref3.existingKeyMap;
		  var props = _ref3.props;
		  var renderedElement = _ref3.renderedElement;
	
		  // Don't run plugins if renderedElement is not a simple ReactDOMElement or has
		  // no style.
		  if (!_react2.default.isValidElement(renderedElement) || typeof renderedElement.type !== 'string' || !props.style) {
		    return props;
		  }
	
		  var newProps = props;
	
		  var plugins = config.plugins || DEFAULT_CONFIG.plugins;
	
		  var componentName = component.constructor.displayName || component.constructor.name;
		  var getKey = _buildGetKey({ renderedElement: renderedElement, existingKeyMap: existingKeyMap, componentName: componentName });
		  var getComponentField = function getComponentField(key) {
		    return component[key];
		  };
		  var getGlobalState = function getGlobalState(key) {
		    return globalState[key];
		  };
		  var componentGetState = function componentGetState(stateKey, elementKey) {
		    return (0, _getState2.default)(component.state, elementKey || getKey(), stateKey);
		  };
		  var setState = function setState(stateKey, value, elementKey) {
		    return _setStyleState(component, elementKey || getKey(), stateKey, value);
		  };
	
		  var addCSS = function addCSS(css) {
		    var styleKeeper = component._radiumStyleKeeper || component.context._radiumStyleKeeper;
		    if (!styleKeeper) {
		      throw new Error('To use plugins requiring `addCSS` (e.g. keyframes, media queries), ' + 'please wrap your application in the StyleRoot component. Component ' + 'name: `' + componentName + '`.');
		    }
	
		    return styleKeeper.addCSS(css);
		  };
	
		  var newStyle = props.style;
	
		  plugins.forEach(function (plugin) {
		    var result = plugin({
		      ExecutionEnvironment: _exenv2.default,
		      addCSS: addCSS,
		      appendImportantToEachValue: _appendImportantToEachValue2.default,
		      componentName: componentName,
		      config: config,
		      cssRuleSetToString: _cssRuleSetToString2.default,
		      getComponentField: getComponentField,
		      getGlobalState: getGlobalState,
		      getState: componentGetState,
		      hash: _hash2.default,
		      mergeStyles: _mergeStyles.mergeStyles,
		      props: newProps,
		      setState: setState,
		      isNestedStyle: _mergeStyles.isNestedStyle,
		      style: newStyle
		    }) || {};
	
		    newStyle = result.style || newStyle;
	
		    newProps = result.props && Object.keys(result.props).length ? _extends({}, newProps, result.props) : newProps;
	
		    var newComponentFields = result.componentFields || {};
		    Object.keys(newComponentFields).forEach(function (fieldName) {
		      component[fieldName] = newComponentFields[fieldName];
		    });
	
		    var newGlobalState = result.globalState || {};
		    Object.keys(newGlobalState).forEach(function (key) {
		      globalState[key] = newGlobalState[key];
		    });
		  });
	
		  if (newStyle !== props.style) {
		    newProps = _extends({}, newProps, { style: newStyle });
		  }
	
		  return newProps;
		};
	
		// Wrapper around React.cloneElement. To avoid processing the same element
		// twice, whenever we clone an element add a special prop to make sure we don't
		// process this element again.
		var _cloneElement = function _cloneElement(renderedElement, newProps, newChildren) {
		  // Only add flag if this is a normal DOM element
		  if (typeof renderedElement.type === 'string') {
		    newProps = _extends({}, newProps, { _radiumDidResolveStyles: true });
		  }
	
		  return _react2.default.cloneElement(renderedElement, newProps, newChildren);
		};
	
		//
		// The nucleus of Radium. resolveStyles is called on the rendered elements
		// before they are returned in render. It iterates over the elements and
		// children, rewriting props to add event handlers required to capture user
		// interactions (e.g. mouse over). It also replaces the style prop because it
		// adds in the various interaction styles (e.g. :hover).
		//
		resolveStyles = function resolveStyles(component, // ReactComponent, flow+eslint complaining
		renderedElement) {
		  var // ReactElement
		  config = arguments.length <= 2 || arguments[2] === undefined ? DEFAULT_CONFIG : arguments[2];
		  var existingKeyMap = arguments[3];
		  var shouldCheckBeforeResolve = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];
		  // ReactElement
		  existingKeyMap = existingKeyMap || {};
		  if (!renderedElement ||
		  // Bail if we've already processed this element. This ensures that only the
		  // owner of an element processes that element, since the owner's render
		  // function will be called first (which will always be the case, since you
		  // can't know what else to render until you render the parent component).
		  renderedElement.props && renderedElement.props._radiumDidResolveStyles ||
	
		  // Bail if this element is a radium enhanced element, because if it is,
		  // then it will take care of resolving its own styles.
		  shouldCheckBeforeResolve && !_shouldResolveStyles(renderedElement)) {
		    return renderedElement;
		  }
	
		  var newChildren = _resolveChildren({
		    children: renderedElement.props.children,
		    component: component,
		    config: config,
		    existingKeyMap: existingKeyMap
		  });
	
		  var newProps = renderedElement.props;
	
		  newProps = _runPlugins({
		    component: component,
		    config: config,
		    existingKeyMap: existingKeyMap,
		    props: newProps,
		    renderedElement: renderedElement
		  });
	
		  // If nothing changed, don't bother cloning the element. Might be a bit
		  // wasteful, as we add the sentinal to stop double-processing when we clone.
		  // Assume benign double-processing is better than unneeded cloning.
		  if (newChildren === renderedElement.props.children && newProps === renderedElement.props) {
		    return renderedElement;
		  }
	
		  return _cloneElement(renderedElement, newProps !== renderedElement.props ? newProps : {}, newChildren);
		};
	
		// Only for use by tests
		resolveStyles.__clearStateForTests = function () {
		  globalState = {};
		};
	
		exports.default = resolveStyles;
		module.exports = exports['default'];
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = appendImportantToEachValue;
	
		var _appendPxIfNeeded = __webpack_require__(7);
	
		var _appendPxIfNeeded2 = _interopRequireDefault(_appendPxIfNeeded);
	
		var _mapObject = __webpack_require__(8);
	
		var _mapObject2 = _interopRequireDefault(_mapObject);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function appendImportantToEachValue(style) {
		  return (0, _mapObject2.default)(style, function (result, key) {
		    return (0, _appendPxIfNeeded2.default)(key, style[key]) + ' !important';
		  });
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = appendPxIfNeeded;
	
	
		// Copied from https://github.com/facebook/react/blob/
		// 102cd291899f9942a76c40a0e78920a6fe544dc1/
		// src/renderers/dom/shared/CSSProperty.js
		var isUnitlessNumber = {
		  animationIterationCount: true,
		  boxFlex: true,
		  boxFlexGroup: true,
		  boxOrdinalGroup: true,
		  columnCount: true,
		  flex: true,
		  flexGrow: true,
		  flexPositive: true,
		  flexShrink: true,
		  flexNegative: true,
		  flexOrder: true,
		  gridRow: true,
		  gridColumn: true,
		  fontWeight: true,
		  lineClamp: true,
		  lineHeight: true,
		  opacity: true,
		  order: true,
		  orphans: true,
		  tabSize: true,
		  widows: true,
		  zIndex: true,
		  zoom: true,
	
		  // SVG-related properties
		  fillOpacity: true,
		  stopOpacity: true,
		  strokeDashoffset: true,
		  strokeOpacity: true,
		  strokeWidth: true
		};
	
		function appendPxIfNeeded(propertyName, value) {
		  var needsPxSuffix = !isUnitlessNumber[propertyName] && typeof value === 'number' && value !== 0;
		  return needsPxSuffix ? value + 'px' : value;
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = mapObject;
		function mapObject(object, mapper) {
		  return Object.keys(object).reduce(function (result, key) {
		    result[key] = mapper(object[key], key);
		    return result;
		  }, {});
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = cssRuleSetToString;
	
		var _appendPxIfNeeded = __webpack_require__(7);
	
		var _appendPxIfNeeded2 = _interopRequireDefault(_appendPxIfNeeded);
	
		var _camelCasePropsToDashCase = __webpack_require__(10);
	
		var _camelCasePropsToDashCase2 = _interopRequireDefault(_camelCasePropsToDashCase);
	
		var _mapObject = __webpack_require__(8);
	
		var _mapObject2 = _interopRequireDefault(_mapObject);
	
		var _prefixer = __webpack_require__(11);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function createMarkupForStyles(style) {
		  return Object.keys(style).map(function (property) {
		    return property + ': ' + style[property] + ';';
		  }).join('\n');
		}
	
		function cssRuleSetToString(selector, rules, userAgent) {
		  if (!rules) {
		    return '';
		  }
	
		  var rulesWithPx = (0, _mapObject2.default)(rules, function (value, key) {
		    return (0, _appendPxIfNeeded2.default)(key, value);
		  });
		  var prefixedRules = (0, _prefixer.getPrefixedStyle)(rulesWithPx, userAgent);
		  var cssPrefixedRules = (0, _camelCasePropsToDashCase2.default)(prefixedRules);
		  var serializedRules = createMarkupForStyles(cssPrefixedRules);
	
		  return selector + '{' + serializedRules + '}';
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 10 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
	
		var _camelCaseRegex = /([a-z])?([A-Z])/g;
	
		var _camelCaseReplacer = function _camelCaseReplacer(match, p1, p2) {
		  return (p1 || '') + '-' + p2.toLowerCase();
		};
	
		var _camelCaseToDashCase = function _camelCaseToDashCase(s) {
		  return s.replace(_camelCaseRegex, _camelCaseReplacer);
		};
	
		var camelCasePropsToDashCase = function camelCasePropsToDashCase(prefixedStyle) {
		  // Since prefix is expected to work on inline style objects, we must
		  // translate the keys to dash case for rendering to CSS.
		  return Object.keys(prefixedStyle).reduce(function (result, key) {
		    var dashCaseKey = _camelCaseToDashCase(key);
	
		    // Fix IE vendor prefix
		    if (/^ms-/.test(dashCaseKey)) {
		      dashCaseKey = '-' + dashCaseKey;
		    }
	
		    result[dashCaseKey] = prefixedStyle[key];
		    return result;
		  }, {});
		};
	
		exports.default = camelCasePropsToDashCase;
		module.exports = exports['default'];
	
	/***/ },
	/* 11 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(global, process) {'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; }; /**
		                                                                                                                                                                                                                                                   * Based on https://github.com/jsstyles/css-vendor, but without having to
		                                                                                                                                                                                                                                                   * convert between different cases all the time.
		                                                                                                                                                                                                                                                   *
		                                                                                                                                                                                                                                                   * 
		                                                                                                                                                                                                                                                   */
	
		exports.getPrefixedKeyframes = getPrefixedKeyframes;
		exports.getPrefixedStyle = getPrefixedStyle;
	
		var _inlineStylePrefixer = __webpack_require__(12);
	
		var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function transformValues(style) {
		  return Object.keys(style).reduce(function (newStyle, key) {
		    var value = style[key];
		    if (Array.isArray(value)) {
		      value = value.join(';' + key + ':');
		    } else if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.toString === 'function') {
		      value = value.toString();
		    }
	
		    newStyle[key] = value;
		    return newStyle;
		  }, {});
		}
	
		var _hasWarnedAboutUserAgent = false;
		var _lastUserAgent = undefined;
		var _cachedPrefixer = undefined;
	
		function getPrefixer(userAgent) {
		  var actualUserAgent = userAgent || global && global.navigator && global.navigator.userAgent;
	
		  if (process.env.NODE_ENV !== 'production') {
		    if (!actualUserAgent && !_hasWarnedAboutUserAgent) {
		      /* eslint-disable no-console */
		      console.warn('Radium: userAgent should be supplied for server-side rendering. See ' + 'https://github.com/FormidableLabs/radium/tree/master/docs/api#radium ' + 'for more information.');
		      /* eslint-enable no-console */
		      _hasWarnedAboutUserAgent = true;
		    }
		  }
	
		  if (!_cachedPrefixer || actualUserAgent !== _lastUserAgent) {
		    if (actualUserAgent === 'all') {
		      _cachedPrefixer = {
		        prefix: _inlineStylePrefixer2.default.prefixAll,
		        prefixedKeyframes: 'keyframes'
		      };
		    } else {
		      _cachedPrefixer = new _inlineStylePrefixer2.default({ userAgent: actualUserAgent });
		    }
		    _lastUserAgent = actualUserAgent;
		  }
		  return _cachedPrefixer;
		}
	
		function getPrefixedKeyframes(userAgent) {
		  return getPrefixer(userAgent).prefixedKeyframes;
		}
	
		// Returns a new style object with vendor prefixes added to property names
		// and values.
		function getPrefixedStyle(style, userAgent) {
		  var styleWithFallbacks = transformValues(style);
		  var prefixer = getPrefixer(userAgent);
		  var prefixedStyle = prefixer.prefix(styleWithFallbacks);
		  return prefixedStyle;
		}
		/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(2)))
	
	/***/ },
	/* 12 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		var _extends = Object.assign || function (target) {
		  for (var i = 1; i < arguments.length; i++) {
		    var source = arguments[i];for (var key in source) {
		      if (Object.prototype.hasOwnProperty.call(source, key)) {
		        target[key] = source[key];
		      }
		    }
		  }return target;
		};
	
		var _createClass = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
		    }
		  }return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
		  };
		}();
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _defineProperty(obj, key, value) {
		  if (key in obj) {
		    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
		  } else {
		    obj[key] = value;
		  }return obj;
		}
	
		function _classCallCheck(instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError('Cannot call a class as a function');
		  }
		}
	
		var _utilsGetBrowserInformation = __webpack_require__(13);
	
		var _utilsGetBrowserInformation2 = _interopRequireDefault(_utilsGetBrowserInformation);
	
		var _utilsGetPrefixedKeyframes = __webpack_require__(15);
	
		var _utilsGetPrefixedKeyframes2 = _interopRequireDefault(_utilsGetPrefixedKeyframes);
	
		var _utilsCapitalizeString = __webpack_require__(16);
	
		var _utilsCapitalizeString2 = _interopRequireDefault(_utilsCapitalizeString);
	
		var _utilsAssign = __webpack_require__(17);
	
		var _utilsAssign2 = _interopRequireDefault(_utilsAssign);
	
		var _utilsWarn = __webpack_require__(18);
	
		var _utilsWarn2 = _interopRequireDefault(_utilsWarn);
	
		var _caniuseData = __webpack_require__(19);
	
		var _caniuseData2 = _interopRequireDefault(_caniuseData);
	
		var _Plugins = __webpack_require__(20);
	
		var _Plugins2 = _interopRequireDefault(_Plugins);
	
		var browserWhitelist = ['phantom'];
	
		var Prefixer = function () {
		  /**
		   * Instantiante a new prefixer
		   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
		   * @param {string} keepUnprefixed - keeps unprefixed properties and values
		   */
	
		  function Prefixer() {
		    var _this = this;
	
		    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
		    _classCallCheck(this, Prefixer);
	
		    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
		    this._userAgent = options.userAgent || defaultUserAgent;
		    this._keepUnprefixed = options.keepUnprefixed || false;
	
		    this._browserInfo = (0, _utilsGetBrowserInformation2['default'])(this._userAgent);
	
		    // Checks if the userAgent was resolved correctly
		    if (this._browserInfo && this._browserInfo.prefix) {
		      // set additional prefix information
		      this.cssPrefix = this._browserInfo.prefix.css;
		      this.jsPrefix = this._browserInfo.prefix.inline;
		      this.prefixedKeyframes = (0, _utilsGetPrefixedKeyframes2['default'])(this._browserInfo);
		    } else {
		      this._hasPropsRequiringPrefix = false;
		      (0, _utilsWarn2['default'])('Either the global navigator was undefined or an invalid userAgent was provided.', 'Using a valid userAgent? Please let us know and create an issue at https://github.com/rofrischmann/inline-style-prefixer/issues');
		      return false;
		    }
	
		    var data = this._browserInfo.browser && _caniuseData2['default'][this._browserInfo.browser];
		    if (data) {
		      this._requiresPrefix = Object.keys(data).filter(function (key) {
		        return data[key] >= _this._browserInfo.version;
		      }).reduce(function (result, name) {
		        return _extends({}, result, _defineProperty({}, name, true));
		      }, {});
		      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
		    } else {
		      // check for whitelisted browsers
		      browserWhitelist.forEach(function (browser) {
		        if (_this._browserInfo[browser]) {
		          _this._isWhitelisted = true;
		        }
		      });
		      this._hasPropsRequiringPrefix = false;
	
		      // Do not throw a warning if whitelisted
		      if (this._isWhitelisted) {
		        return true;
		      }
		      (0, _utilsWarn2['default'])('Your userAgent seems to be not supported by inline-style-prefixer. Feel free to open an issue.');
		      return false;
		    }
		  }
	
		  /**
		   * Returns a prefixed version of the style object
		   * @param {Object} styles - Style object that gets prefixed properties added
		   * @returns {Object} - Style object with prefixed properties and values
		   */
	
		  _createClass(Prefixer, [{
		    key: 'prefix',
		    value: function prefix(styles) {
		      var _this2 = this;
	
		      // only add prefixes if needed
		      if (!this._hasPropsRequiringPrefix) {
		        return styles;
		      }
	
		      styles = (0, _utilsAssign2['default'])({}, styles);
	
		      Object.keys(styles).forEach(function (property) {
		        var value = styles[property];
		        if (value instanceof Object) {
		          // recurse through nested style objects
		          styles[property] = _this2.prefix(value);
		        } else {
		          // add prefixes if needed
		          if (_this2._requiresPrefix[property]) {
		            styles[_this2.jsPrefix + (0, _utilsCapitalizeString2['default'])(property)] = value;
		            if (!_this2._keepUnprefixed) {
		              delete styles[property];
		            }
		          }
	
		          // resolve plugins
		          _Plugins2['default'].forEach(function (plugin) {
		            // generates a new plugin interface with current data
		            var resolvedStyles = plugin({
		              property: property,
		              value: value,
		              styles: styles,
		              browserInfo: _this2._browserInfo,
		              prefix: {
		                js: _this2.jsPrefix,
		                css: _this2.cssPrefix,
		                keyframes: _this2.prefixedKeyframes
		              },
		              keepUnprefixed: _this2._keepUnprefixed,
		              requiresPrefix: _this2._requiresPrefix,
		              forceRun: false
		            });
		            (0, _utilsAssign2['default'])(styles, resolvedStyles);
		          });
		        }
		      });
	
		      return styles;
		    }
	
		    /**
		     * Returns a prefixed version of the style object using all vendor prefixes
		     * @param {Object} styles - Style object that gets prefixed properties added
		     * @returns {Object} - Style object with prefixed properties and values
		     */
		  }], [{
		    key: 'prefixAll',
		    value: function prefixAll(styles) {
		      var prefixes = {};
		      var browserInfo = (0, _utilsGetBrowserInformation2['default'])('*');
	
		      browserInfo.browsers.forEach(function (browser) {
		        var data = _caniuseData2['default'][browser];
		        if (data) {
		          (0, _utilsAssign2['default'])(prefixes, data);
		        }
		      });
	
		      // there should always be at least one prefixed style, but just incase
		      if (!Object.keys(prefixes).length > 0) {
		        return styles;
		      }
	
		      styles = (0, _utilsAssign2['default'])({}, styles);
	
		      Object.keys(styles).forEach(function (property) {
		        var value = styles[property];
		        if (value instanceof Object) {
		          // recurse through nested style objects
		          styles[property] = Prefixer.prefixAll(value);
		        } else {
		          var browsers = Object.keys(browserInfo.prefixes);
		          browsers.forEach(function (browser) {
		            var style = browserInfo.prefixes[browser];
		            // add prefixes if needed
		            if (prefixes[property]) {
		              styles[style.inline + (0, _utilsCapitalizeString2['default'])(property)] = value;
		            }
	
		            // resolve plugins for each browser
		            _Plugins2['default'].forEach(function (plugin) {
		              var resolvedStyles = plugin({
		                property: property,
		                value: value,
		                styles: styles,
		                browserInfo: {
		                  name: browser,
		                  prefix: style,
		                  version: 0 // assume lowest
		                },
		                prefix: {},
		                keepUnprefixed: true,
		                requiresPrefix: prefixes,
		                forceRun: true
		              });
		              (0, _utilsAssign2['default'])(styles, resolvedStyles);
		            });
		          });
		        }
		      });
	
		      return styles;
		    }
		  }]);
	
		  return Prefixer;
		}();
	
		exports['default'] = Prefixer;
		module.exports = exports['default'];
	
	/***/ },
	/* 13 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		var _bowser = __webpack_require__(14);
	
		var _bowser2 = _interopRequireDefault(_bowser);
	
		var vendorPrefixes = {
		  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen'],
		  Moz: ['firefox', 'seamonkey', 'sailfish'],
		  ms: ['msie', 'msedge']
		};
	
		var browsers = {
		  chrome: [['chrome']],
		  safari: [['safari']],
		  firefox: [['firefox']],
		  ie: [['msie']],
		  edge: [['msedge']],
		  opera: [['opera']],
		  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
		  ie_mob: [['windowsphone', 'mobile', 'msie'], ['windowsphone', 'tablet', 'msie'], ['windowsphone', 'mobile', 'msedge'], ['windowsphone', 'tablet', 'msedge']],
		  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
		  and_uc: [['android', 'mobile'], ['android', 'tablet']],
		  android: [['android', 'mobile'], ['android', 'tablet']]
		};
	
		/**
		 * Returns an object containing prefix data associated with a browser
		 * @param {string} browser - browser to find a prefix for
		 */
		var getPrefixes = function getPrefixes(browser) {
		  var prefixKeys = undefined;
		  var prefix = undefined;
		  var vendors = undefined;
		  var conditions = undefined;
		  var prefixVendor = undefined;
		  var browserVendors = undefined;
	
		  // Find the prefix for this browser (if any)
		  prefixKeys = Object.keys(vendorPrefixes);
		  for (var i = 0; i < prefixKeys.length; i++) {
		    prefix = prefixKeys[i];
	
		    // Find a matching vendor
		    vendors = vendorPrefixes[prefix];
		    conditions = browsers[browser];
	
		    for (var j = 0; j < vendors.length; j++) {
		      prefixVendor = vendors[j];
	
		      for (var k = 0; k < conditions.length; k++) {
		        browserVendors = conditions[k];
	
		        if (browserVendors.indexOf(prefixVendor) !== -1) {
		          return {
		            inline: prefix,
		            css: '-' + prefix.toLowerCase() + '-'
		          };
		        }
		      }
		    }
		  }
	
		  // No prefix found for this browser
		  return { inline: '', css: '' };
		};
	
		/**
		 * Uses bowser to get default browser information such as version and name
		 * Evaluates bowser info and adds vendorPrefix information
		 * @param {string} userAgent - userAgent that gets evaluated
		 */
	
		exports['default'] = function (userAgent) {
		  if (!userAgent) {
		    return false;
		  }
	
		  var info = {};
	
		  // Special user agent, return all supported prefixes
		  // instead of returning a string browser name and a prefix object
		  // we return an array of browser names and map of prefixes for each browser
		  if (userAgent === '*') {
		    // Return an array of supported browsers
		    info.browsers = Object.keys(browsers);
	
		    // Return prefixes associated by browser
		    info.prefixes = {};
	
		    // Iterate browser list, assign prefix to each
		    info.browsers.forEach(function (browser) {
		      info.prefixes[browser] = getPrefixes(browser);
		    });
	
		    return info;
		  }
	
		  // Normal user agent, detect browser
		  info = _bowser2['default']._detect(userAgent);
	
		  Object.keys(vendorPrefixes).forEach(function (prefix) {
		    vendorPrefixes[prefix].forEach(function (browser) {
		      if (info[browser]) {
		        info.prefix = {
		          inline: prefix,
		          css: '-' + prefix.toLowerCase() + '-'
		        };
		      }
		    });
		  });
	
		  var name = '';
		  Object.keys(browsers).forEach(function (browser) {
		    browsers[browser].forEach(function (condition) {
		      var match = 0;
		      condition.forEach(function (single) {
		        if (info[single]) {
		          match += 1;
		        }
		      });
		      if (condition.length === match) {
		        name = browser;
		      }
		    });
		  });
	
		  info.browser = name;
		  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
		  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
	
		  // seperate native android chrome
		  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
		  if (info.browser === 'android' && info.chrome && info.version > 37) {
		    info.browser = 'and_chr';
		  }
		  info.version = parseFloat(info.version);
		  info.osversion = parseFloat(info.osversion);
		  // For android < 4.4 we want to check the osversion
		  // not the chrome version, see issue #26
		  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
		  if (info.browser === 'android' && info.osversion < 5) {
		    info.version = info.osversion;
		  }
	
		  return info;
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 14 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
		/*!
		  * Bowser - a browser detector
		  * https://github.com/ded/bowser
		  * MIT License | (c) Dustin Diaz 2015
		  */
	
		!function (name, definition) {
		  if (typeof module != 'undefined' && module.exports) module.exports = definition();else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else this[name] = definition();
		}('bowser', function () {
		  /**
		    * See useragents.js for examples of navigator.userAgent
		    */
	
		  var t = true;
	
		  function detect(ua) {
	
		    function getFirstMatch(regex) {
		      var match = ua.match(regex);
		      return match && match.length > 1 && match[1] || '';
		    }
	
		    function getSecondMatch(regex) {
		      var match = ua.match(regex);
		      return match && match.length > 1 && match[2] || '';
		    }
	
		    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase(),
		        likeAndroid = /like android/i.test(ua),
		        android = !likeAndroid && /android/i.test(ua),
		        chromeBook = /CrOS/.test(ua),
		        edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i),
		        versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i),
		        tablet = /tablet/i.test(ua),
		        mobile = !tablet && /[^-]mobi/i.test(ua),
		        result;
	
		    if (/opera|opr/i.test(ua)) {
		      result = {
		        name: 'Opera',
		        opera: t,
		        version: versionIdentifier || getFirstMatch(/(?:opera|opr)[\s\/](\d+(\.\d+)?)/i)
		      };
		    } else if (/yabrowser/i.test(ua)) {
		      result = {
		        name: 'Yandex Browser',
		        yandexbrowser: t,
		        version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
		      };
		    } else if (/windows phone/i.test(ua)) {
		      result = {
		        name: 'Windows Phone',
		        windowsphone: t
		      };
		      if (edgeVersion) {
		        result.msedge = t;
		        result.version = edgeVersion;
		      } else {
		        result.msie = t;
		        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i);
		      }
		    } else if (/msie|trident/i.test(ua)) {
		      result = {
		        name: 'Internet Explorer',
		        msie: t,
		        version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
		      };
		    } else if (chromeBook) {
		      result = {
		        name: 'Chrome',
		        chromeBook: t,
		        chrome: t,
		        version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
		      };
		    } else if (/chrome.+? edge/i.test(ua)) {
		      result = {
		        name: 'Microsoft Edge',
		        msedge: t,
		        version: edgeVersion
		      };
		    } else if (/chrome|crios|crmo/i.test(ua)) {
		      result = {
		        name: 'Chrome',
		        chrome: t,
		        version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
		      };
		    } else if (iosdevice) {
		      result = {
		        name: iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
		      };
		      // WTF: version is not part of user agent in web apps
		      if (versionIdentifier) {
		        result.version = versionIdentifier;
		      }
		    } else if (/sailfish/i.test(ua)) {
		      result = {
		        name: 'Sailfish',
		        sailfish: t,
		        version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
		      };
		    } else if (/seamonkey\//i.test(ua)) {
		      result = {
		        name: 'SeaMonkey',
		        seamonkey: t,
		        version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
		      };
		    } else if (/firefox|iceweasel/i.test(ua)) {
		      result = {
		        name: 'Firefox',
		        firefox: t,
		        version: getFirstMatch(/(?:firefox|iceweasel)[ \/](\d+(\.\d+)?)/i)
		      };
		      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
		        result.firefoxos = t;
		      }
		    } else if (/silk/i.test(ua)) {
		      result = {
		        name: 'Amazon Silk',
		        silk: t,
		        version: getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
		      };
		    } else if (android) {
		      result = {
		        name: 'Android',
		        version: versionIdentifier
		      };
		    } else if (/phantom/i.test(ua)) {
		      result = {
		        name: 'PhantomJS',
		        phantom: t,
		        version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
		      };
		    } else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
		      result = {
		        name: 'BlackBerry',
		        blackberry: t,
		        version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
		      };
		    } else if (/(web|hpw)os/i.test(ua)) {
		      result = {
		        name: 'WebOS',
		        webos: t,
		        version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
		      };
		      /touchpad\//i.test(ua) && (result.touchpad = t);
		    } else if (/bada/i.test(ua)) {
		      result = {
		        name: 'Bada',
		        bada: t,
		        version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
		      };
		    } else if (/tizen/i.test(ua)) {
		      result = {
		        name: 'Tizen',
		        tizen: t,
		        version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
		      };
		    } else if (/safari/i.test(ua)) {
		      result = {
		        name: 'Safari',
		        safari: t,
		        version: versionIdentifier
		      };
		    } else {
		      result = {
		        name: getFirstMatch(/^(.*)\/(.*) /),
		        version: getSecondMatch(/^(.*)\/(.*) /)
		      };
		    }
	
		    // set webkit or gecko flag for browsers based on these engines
		    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
		      result.name = result.name || "Webkit";
		      result.webkit = t;
		      if (!result.version && versionIdentifier) {
		        result.version = versionIdentifier;
		      }
		    } else if (!result.opera && /gecko\//i.test(ua)) {
		      result.name = result.name || "Gecko";
		      result.gecko = t;
		      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i);
		    }
	
		    // set OS flags for platforms that have multiple browsers
		    if (!result.msedge && (android || result.silk)) {
		      result.android = t;
		    } else if (iosdevice) {
		      result[iosdevice] = t;
		      result.ios = t;
		    }
	
		    // OS version extraction
		    var osVersion = '';
		    if (result.windowsphone) {
		      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
		    } else if (iosdevice) {
		      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
		      osVersion = osVersion.replace(/[_\s]/g, '.');
		    } else if (android) {
		      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
		    } else if (result.webos) {
		      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
		    } else if (result.blackberry) {
		      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
		    } else if (result.bada) {
		      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
		    } else if (result.tizen) {
		      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
		    }
		    if (osVersion) {
		      result.osversion = osVersion;
		    }
	
		    // device type extraction
		    var osMajorVersion = osVersion.split('.')[0];
		    if (tablet || iosdevice == 'ipad' || android && (osMajorVersion == 3 || osMajorVersion == 4 && !mobile) || result.silk) {
		      result.tablet = t;
		    } else if (mobile || iosdevice == 'iphone' || iosdevice == 'ipod' || android || result.blackberry || result.webos || result.bada) {
		      result.mobile = t;
		    }
	
		    // Graded Browser Support
		    // http://developer.yahoo.com/yui/articles/gbs
		    if (result.msedge || result.msie && result.version >= 10 || result.yandexbrowser && result.version >= 15 || result.chrome && result.version >= 20 || result.firefox && result.version >= 20.0 || result.safari && result.version >= 6 || result.opera && result.version >= 10.0 || result.ios && result.osversion && result.osversion.split(".")[0] >= 6 || result.blackberry && result.version >= 10.1) {
		      result.a = t;
		    } else if (result.msie && result.version < 10 || result.chrome && result.version < 20 || result.firefox && result.version < 20.0 || result.safari && result.version < 6 || result.opera && result.version < 10.0 || result.ios && result.osversion && result.osversion.split(".")[0] < 6) {
		      result.c = t;
		    } else result.x = t;
	
		    return result;
		  }
	
		  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent : '');
	
		  bowser.test = function (browserList) {
		    for (var i = 0; i < browserList.length; ++i) {
		      var browserItem = browserList[i];
		      if (typeof browserItem === 'string') {
		        if (browserItem in bowser) {
		          return true;
		        }
		      }
		    }
		    return false;
		  };
	
		  /*
		   * Set our detect method to the main bowser object so we can
		   * reuse it to test other user agents.
		   * This is needed to implement future tests.
		   */
		  bowser._detect = detect;
	
		  return bowser;
		});
	
	/***/ },
	/* 15 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (_ref) {
		  var browser = _ref.browser;
		  var version = _ref.version;
		  var prefix = _ref.prefix;
	
		  var prefixedKeyframes = 'keyframes';
	
		  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
		    prefixedKeyframes = prefix.css + prefixedKeyframes;
		  }
		  return prefixedKeyframes;
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 16 */
	/***/ function(module, exports) {
	
		// helper to capitalize strings
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		exports["default"] = function (str) {
		  return str.charAt(0).toUpperCase() + str.slice(1);
		};
	
		module.exports = exports["default"];
	
	/***/ },
	/* 17 */
	/***/ function(module, exports) {
	
		// leight polyfill for Object.assign
		"use strict";
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		exports["default"] = function (base) {
		  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		  Object.keys(extend).forEach(function (key) {
		    return base[key] = extend[key];
		  });
		  return base;
		};
	
		module.exports = exports["default"];
	
	/***/ },
	/* 18 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {// only throw warnings if devmode is enabled
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function () {
		  if (process.env.NODE_ENV !== 'production') {
		    console.warn.apply(console, arguments);
		  }
		};
	
		module.exports = exports['default'];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))
	
	/***/ },
	/* 19 */
	/***/ function(module, exports) {
	
		"use strict";
	
		var caniuseData = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 50, "userSelect": 50, "fontKerning": 32, "textEmphasisPosition": 50, "textEmphasis": 50, "textEmphasisStyle": 50, "textEmphasisColor": 50, "boxDecorationBreak": 50, "clipPath": 50, "maskImage": 50, "maskMode": 50, "maskRepeat": 50, "maskPosition": 50, "maskClip": 50, "maskOrigin": 50, "maskSize": 50, "maskComposite": 50, "mask": 50, "maskBorderSource": 50, "maskBorderMode": 50, "maskBorderSlice": 50, "maskBorderWidth": 50, "maskBorderOutset": 50, "maskBorderRepeat": 50, "maskBorder": 50, "maskType": 50, "textDecorationStyle": 50, "textDecorationSkip": 50, "textDecorationLine": 50, "textDecorationColor": 50, "filter": 50, "fontFeatureSettings": 47, "breakAfter": 50, "breakBefore": 50, "breakInside": 50, "columnCount": 50, "columnFill": 50, "columnGap": 50, "columnRule": 50, "columnRuleColor": 50, "columnRuleStyle": 50, "columnRuleWidth": 50, "columns": 50, "columnSpan": 50, "columnWidth": 50 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 9.1, "userSelect": 9.1, "backdropFilter": 9.1, "fontKerning": 9.1, "scrollSnapType": 9.1, "scrollSnapPointsX": 9.1, "scrollSnapPointsY": 9.1, "scrollSnapDestination": 9.1, "scrollSnapCoordinate": 9.1, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 9.1, "clipPath": 9.1, "maskImage": 9.1, "maskMode": 9.1, "maskRepeat": 9.1, "maskPosition": 9.1, "maskClip": 9.1, "maskOrigin": 9.1, "maskSize": 9.1, "maskComposite": 9.1, "mask": 9.1, "maskBorderSource": 9.1, "maskBorderMode": 9.1, "maskBorderSlice": 9.1, "maskBorderWidth": 9.1, "maskBorderOutset": 9.1, "maskBorderRepeat": 9.1, "maskBorder": 9.1, "maskType": 9.1, "textDecorationStyle": 9.1, "textDecorationSkip": 9.1, "textDecorationLine": 9.1, "textDecorationColor": 9.1, "shapeImageThreshold": 9.1, "shapeImageMargin": 9.1, "shapeImageOutside": 9.1, "filter": 9, "hyphens": 9.1, "flowInto": 9.1, "flowFrom": 9.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 9.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 46, "userSelect": 46, "boxSizing": 28, "textAlignLast": 46, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 46, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 46, "breakBefore": 46, "breakInside": 46, "columnCount": 46, "columnFill": 46, "columnGap": 46, "columnRule": 46, "columnRuleColor": 46, "columnRuleStyle": 46, "columnRuleWidth": 46, "columns": 46, "columnSpan": 46, "columnWidth": 46 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 36, "userSelect": 36, "fontKerning": 19, "textEmphasisPosition": 36, "textEmphasis": 36, "textEmphasisStyle": 36, "textEmphasisColor": 36, "boxDecorationBreak": 36, "clipPath": 36, "maskImage": 36, "maskMode": 36, "maskRepeat": 36, "maskPosition": 36, "maskClip": 36, "maskOrigin": 36, "maskSize": 36, "maskComposite": 36, "mask": 36, "maskBorderSource": 36, "maskBorderMode": 36, "maskBorderSlice": 36, "maskBorderWidth": 36, "maskBorderOutset": 36, "maskBorderRepeat": 36, "maskBorder": 36, "maskType": 36, "filter": 36, "fontFeatureSettings": 36, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "gridArea": 11, "gridGap": 11, "gridColumnStart": 11, "userSelect": 11, "grid": 11, "breakInside": 11, "hyphens": 11, "gridTemplateAreas": 11, "breakAfter": 11, "scrollSnapCoordinate": 11, "gridRowStart": 11, "gridAutoFlow": 11, "scrollSnapDestination": 11, "gridTemplate": 11, "gridTemplateColumns": 11, "transformOrigin": 9, "gridAutoRows": 11, "gridColumnEnd": 11, "transformOriginY": 9, "scrollSnapPointsY": 11, "breakBefore": 11, "gridRowGap": 11, "scrollSnapPointsX": 11, "regionFragment": 11, "flexWrap": 10, "wrapFlow": 11, "gridRowEnd": 11, "flex": 10, "flexDirection": 10, "flowInto": 11, "touchAction": 10, "gridColumn": 11, "transform": 9, "gridTemplateRows": 11, "flexFlow": 10, "transformOriginX": 9, "flowFrom": 11, "scrollSnapType": 11, "wrapMargin": 11, "gridColumnGap": 11, "gridRow": 11, "wrapThrough": 11, "gridAutoColumns": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 46, "userSelect": 46, "fontKerning": 4.4, "textEmphasisPosition": 46, "textEmphasis": 46, "textEmphasisStyle": 46, "textEmphasisColor": 46, "boxDecorationBreak": 46, "clipPath": 46, "maskImage": 46, "maskMode": 46, "maskRepeat": 46, "maskPosition": 46, "maskClip": 46, "maskOrigin": 46, "maskSize": 46, "maskComposite": 46, "mask": 46, "maskBorderSource": 46, "maskBorderMode": 46, "maskBorderSlice": 46, "maskBorderWidth": 46, "maskBorderOutset": 46, "maskBorderRepeat": 46, "maskBorder": 46, "maskType": 46, "filter": 46, "fontFeatureSettings": 46, "breakAfter": 46, "breakBefore": 46, "breakInside": 46, "columnCount": 46, "columnFill": 46, "columnGap": 46, "columnRule": 46, "columnRuleColor": 46, "columnRuleStyle": 46, "columnRuleWidth": 46, "columns": 46, "columnSpan": 46, "columnWidth": 46 }, "and_chr": { "appearance": 47, "userSelect": 47, "textEmphasisPosition": 47, "textEmphasis": 47, "textEmphasisStyle": 47, "textEmphasisColor": 47, "boxDecorationBreak": 47, "clipPath": 47, "maskImage": 47, "maskMode": 47, "maskRepeat": 47, "maskPosition": 47, "maskClip": 47, "maskOrigin": 47, "maskSize": 47, "maskComposite": 47, "mask": 47, "maskBorderSource": 47, "maskBorderMode": 47, "maskBorderSlice": 47, "maskBorderWidth": 47, "maskBorderOutset": 47, "maskBorderRepeat": 47, "maskBorder": 47, "maskType": 47, "textDecorationStyle": 47, "textDecorationSkip": 47, "textDecorationLine": 47, "textDecorationColor": 47, "filter": 47, "fontFeatureSettings": 47, "breakAfter": 47, "breakBefore": 47, "breakInside": 47, "columnCount": 47, "columnFill": 47, "columnGap": 47, "columnRule": 47, "columnRuleColor": 47, "columnRuleStyle": 47, "columnRuleWidth": 47, "columns": 47, "columnSpan": 47, "columnWidth": 47 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": { "borderImage": 5, "borderImageOutset": 5, "borderImageRepeat": 5, "borderImageSlice": 5, "borderImageSource": 5, "borderImageWidth": 5, "tabSize": 5, "objectFit": 5, "objectPosition": 5 } };module.exports = caniuseData;
	
	/***/ },
	/* 20 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		var _pluginsCalc = __webpack_require__(21);
	
		var _pluginsCalc2 = _interopRequireDefault(_pluginsCalc);
	
		var _pluginsCursor = __webpack_require__(22);
	
		var _pluginsCursor2 = _interopRequireDefault(_pluginsCursor);
	
		var _pluginsFlex = __webpack_require__(23);
	
		var _pluginsFlex2 = _interopRequireDefault(_pluginsFlex);
	
		var _pluginsSizing = __webpack_require__(24);
	
		var _pluginsSizing2 = _interopRequireDefault(_pluginsSizing);
	
		var _pluginsGradient = __webpack_require__(25);
	
		var _pluginsGradient2 = _interopRequireDefault(_pluginsGradient);
	
		var _pluginsTransition = __webpack_require__(26);
	
		var _pluginsTransition2 = _interopRequireDefault(_pluginsTransition);
	
		// special flexbox specifications
	
		var _pluginsFlexboxIE = __webpack_require__(28);
	
		var _pluginsFlexboxIE2 = _interopRequireDefault(_pluginsFlexboxIE);
	
		var _pluginsFlexboxOld = __webpack_require__(29);
	
		var _pluginsFlexboxOld2 = _interopRequireDefault(_pluginsFlexboxOld);
	
		exports['default'] = [_pluginsCalc2['default'], _pluginsCursor2['default'], _pluginsSizing2['default'], _pluginsGradient2['default'], _pluginsTransition2['default'], _pluginsFlexboxIE2['default'], _pluginsFlexboxOld2['default'],
		// this must be run AFTER the flexbox specs
		_pluginsFlex2['default']];
		module.exports = exports['default'];
	
	/***/ },
	/* 21 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		exports['default'] = calc;
	
		function _defineProperty(obj, key, value) {
		  if (key in obj) {
		    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
		  } else {
		    obj[key] = value;
		  }return obj;
		}
	
		function calc(pluginInterface) {
		  var property = pluginInterface.property;
		  var value = pluginInterface.value;
		  var browserInfo = pluginInterface.browserInfo;
		  var prefix = pluginInterface.prefix;
		  var keepUnprefixed = pluginInterface.keepUnprefixed;
		  var forceRun = pluginInterface.forceRun;
		  var browser = browserInfo.browser;
		  var version = browserInfo.version;
	
		  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (forceRun || browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
		    var newValue = forceRun ?
		    // prefix all
		    ['-webkit-', '-moz-'].map(function (prefix) {
		      return value.replace(/calc\(/g, prefix + 'calc(');
		    }).join(';' + property + ':') :
		    // default
		    value.replace(/calc\(/g, prefix.css + 'calc(');
		    return _defineProperty({}, property, newValue + (keepUnprefixed ? ';' + property + ':' + value : ''));
		  }
		}
	
		module.exports = exports['default'];
	
	/***/ },
	/* 22 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		exports['default'] = cursor;
		var values = {
		  'zoom-in': true,
		  'zoom-out': true,
		  grab: true,
		  grabbing: true
		};
	
		function cursor(pluginInterface) {
		  var property = pluginInterface.property;
		  var value = pluginInterface.value;
		  var browserInfo = pluginInterface.browserInfo;
		  var prefix = pluginInterface.prefix;
		  var keepUnprefixed = pluginInterface.keepUnprefixed;
		  var forceRun = pluginInterface.forceRun;
		  var browser = browserInfo.browser;
		  var version = browserInfo.version;
	
		  if (property === 'cursor' && values[value] && (forceRun || browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
		    var newValue = forceRun ?
		    // prefix all
		    ['-webkit-', '-moz-'].map(function (prefix) {
		      return prefix + value;
		    }).join(';' + property + ':') :
		    // default
		    prefix.css + value;
		    return {
		      cursor: newValue + (keepUnprefixed ? ';' + property + ':' + value : '')
		    };
		  }
		}
	
		module.exports = exports['default'];
	
	/***/ },
	/* 23 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		exports['default'] = flex;
		var values = { flex: true, 'inline-flex': true };
	
		function flex(pluginInterface) {
		  var property = pluginInterface.property;
		  var value = pluginInterface.value;
		  var browserInfo = pluginInterface.browserInfo;
		  var prefix = pluginInterface.prefix;
		  var keepUnprefixed = pluginInterface.keepUnprefixed;
		  var forceRun = pluginInterface.forceRun;
		  var browser = browserInfo.browser;
		  var version = browserInfo.version;
	
		  if (property === 'display' && values[value] && (forceRun || browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
		    var newValue = forceRun ?
		    // prefix all
		    ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value].join(';' + property + ':') :
		    // default
		    '-webkit-' + value;
		    return {
		      display: newValue + (keepUnprefixed ? ';' + property + ':' + value : '')
		    };
		  }
		}
	
		module.exports = exports['default'];
	
	/***/ },
	/* 24 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		exports['default'] = sizing;
	
		function _defineProperty(obj, key, value) {
		  if (key in obj) {
		    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
		  } else {
		    obj[key] = value;
		  }return obj;
		}
	
		var properties = {
		  maxHeight: true,
		  maxWidth: true,
		  width: true,
		  height: true,
		  columnWidth: true,
		  minWidth: true,
		  minHeight: true
		};
		var values = {
		  'min-content': true,
		  'max-content': true,
		  'fill-available': true,
		  'fit-content': true,
		  'contain-floats': true
		};
	
		function sizing(pluginInterface) {
		  var property = pluginInterface.property;
		  var value = pluginInterface.value;
		  var browserInfo = pluginInterface.browserInfo;
		  var prefix = pluginInterface.prefix;
		  var keepUnprefixed = pluginInterface.keepUnprefixed;
		  var forceRun = pluginInterface.forceRun;
		  var browser = browserInfo.browser;
		  var version = browserInfo.version;
	
		  // This might change in the future
		  // Keep an eye on it
		  if (properties[property] && values[value]) {
		    var newValue = forceRun ?
		    // prefix all
		    ['-webkit-', '-moz-'].map(function (prefix) {
		      return prefix + value;
		    }).join(';' + property + ':') :
		    // default
		    prefix.css + value;
		    return _defineProperty({}, property, newValue + (keepUnprefixed ? ';' + property + ':' + value : ''));
		  }
		}
	
		module.exports = exports['default'];
	
	/***/ },
	/* 25 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		exports['default'] = gradient;
	
		function _defineProperty(obj, key, value) {
		  if (key in obj) {
		    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
		  } else {
		    obj[key] = value;
		  }return obj;
		}
	
		var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
		function gradient(pluginInterface) {
		  var property = pluginInterface.property;
		  var value = pluginInterface.value;
		  var browserInfo = pluginInterface.browserInfo;
		  var prefix = pluginInterface.prefix;
		  var keepUnprefixed = pluginInterface.keepUnprefixed;
		  var forceRun = pluginInterface.forceRun;
		  var browser = browserInfo.browser;
		  var version = browserInfo.version;
	
		  if (typeof value === 'string' && value.match(values) !== null && (forceRun || browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
		    var newValue = forceRun ?
		    // prefix all
		    ['-webkit-', '-moz-'].map(function (prefix) {
		      return prefix + value;
		    }).join(';' + property + ':') :
		    // default
		    prefix.css + value;
		    return _defineProperty({}, property, newValue + (keepUnprefixed ? ';' + property + ':' + value : ''));
		  }
		}
	
		module.exports = exports['default'];
	
	/***/ },
	/* 26 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
		exports['default'] = calc;
	
		function _interopRequireDefault(obj) {
		  return obj && obj.__esModule ? obj : { 'default': obj };
		}
	
		function _defineProperty(obj, key, value) {
		  if (key in obj) {
		    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
		  } else {
		    obj[key] = value;
		  }return obj;
		}
	
		var _utilsCamelToDashCase = __webpack_require__(27);
	
		var _utilsCamelToDashCase2 = _interopRequireDefault(_utilsCamelToDashCase);
	
		var _utilsCapitalizeString = __webpack_require__(16);
	
		var _utilsCapitalizeString2 = _interopRequireDefault(_utilsCapitalizeString);
	
		function calc(pluginInterface) {
		  var property = pluginInterface.property;
		  var value = pluginInterface.value;
		  var browserInfo = pluginInterface.browserInfo;
		  var prefix = pluginInterface.prefix;
		  var keepUnprefixed = pluginInterface.keepUnprefixed;
		  var forceRun = pluginInterface.forceRun;
		  var requiresPrefix = pluginInterface.requiresPrefix;
		  var browser = browserInfo.browser;
		  var version = browserInfo.version;
	
		  if (
		  // also check for already prefixed transitions
		  typeof value === 'string' && (property.toLowerCase().indexOf('transition') > -1 || property.toLowerCase().indexOf('transitionproperty') > -1)) {
		    var _ref;
	
		    var _ret = function () {
		      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (property) {
		        return (0, _utilsCamelToDashCase2['default'])(property);
		      });
		      var newValue = value;
	
		      // only split multi values, not cubic beziers
		      var multipleValues = newValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
		      requiresPrefixDashCased.forEach(function (property) {
		        multipleValues.forEach(function (val, index) {
		          if (val.indexOf(property) > -1) {
		            var newVal = forceRun ?
		            // prefix all
		            ['-webkit-', '-moz-', '-ms-'].map(function (prefix) {
		              return val.replace(property, prefix + property);
		            }).join(',') :
		            // default
		            val.replace(property, prefix.css + property);
		            multipleValues[index] = newVal + (keepUnprefixed ? ',' + val : '');
		          }
		        });
		      });
		      var outputValue = multipleValues.join(',');
		      if (forceRun) {
		        return {
		          v: (_ref = {}, _defineProperty(_ref, 'Webkit' + (0, _utilsCapitalizeString2['default'])(property), outputValue), _defineProperty(_ref, 'Moz' + (0, _utilsCapitalizeString2['default'])(property), outputValue), _defineProperty(_ref, 'ms' + (0, _utilsCapitalizeString2['default'])(property), outputValue), _defineProperty(_ref, property, outputValue), _ref)
		        };
		      }
		      return {
		        v: _defineProperty({}, property, outputValue)
		      };
		    }();
	
		    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === 'object') return _ret.v;
		  }
		}
	
		module.exports = exports['default'];
	
	/***/ },
	/* 27 */
	/***/ function(module, exports) {
	
		/**
		 * Converts a camel-case string to a dash-case string
		 * @param {string} str - str that gets converted to dash-case
		 */
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		exports['default'] = function (str) {
		  return str.replace(/([a-z]|^)([A-Z])/g, function (match, p1, p2) {
		    return p1 + '-' + p2.toLowerCase();
		  }).replace('ms-', '-ms-');
		};
	
		module.exports = exports['default'];
	
	/***/ },
	/* 28 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		var _extends = Object.assign || function (target) {
		  for (var i = 1; i < arguments.length; i++) {
		    var source = arguments[i];for (var key in source) {
		      if (Object.prototype.hasOwnProperty.call(source, key)) {
		        target[key] = source[key];
		      }
		    }
		  }return target;
		};
	
		exports['default'] = flexboxIE;
	
		function _defineProperty(obj, key, value) {
		  if (key in obj) {
		    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
		  } else {
		    obj[key] = value;
		  }return obj;
		}
	
		var alternativeValues = {
		  'space-around': 'distribute',
		  'space-between': 'justify',
		  'flex-start': 'start',
		  'flex-end': 'end',
		  flex: '-ms-flexbox',
		  'inline-flex': '-ms-inline-flexbox'
		};
		var alternativeProps = {
		  alignContent: 'msFlexLinePack',
		  alignSelf: 'msFlexItemAlign',
		  alignItems: 'msFlexAlign',
		  justifyContent: 'msFlexPack',
		  order: 'msFlexOrder',
		  flexGrow: 'msFlexPositive',
		  flexShrink: 'msFlexNegative',
		  flexBasis: 'msPreferredSize'
		};
	
		var properties = Object.keys(alternativeProps).concat('display').reduce(function (result, prop) {
		  return _extends({}, result, _defineProperty({}, prop, true));
		}, {});
	
		function flexboxIE(pluginInterface) {
		  var property = pluginInterface.property;
		  var value = pluginInterface.value;
		  var styles = pluginInterface.styles;
		  var browserInfo = pluginInterface.browserInfo;
		  var prefix = pluginInterface.prefix;
		  var keepUnprefixed = pluginInterface.keepUnprefixed;
		  var forceRun = pluginInterface.forceRun;
		  var browser = browserInfo.browser;
		  var version = browserInfo.version;
	
		  if (properties[property] && (forceRun || (browser === 'ie_mob' || browser === 'ie') && version == 10)) {
		    if (!keepUnprefixed) {
		      delete styles[property];
		    }
	
		    if (alternativeProps[property]) {
		      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
		    }
		    if (alternativeValues[value]) {
		      return _defineProperty({}, property, alternativeValues[value] + (keepUnprefixed ? ';' + property + ':' + value : ''));
		    }
		  }
		}
	
		module.exports = exports['default'];
	
	/***/ },
	/* 29 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, '__esModule', {
		  value: true
		});
	
		var _extends = Object.assign || function (target) {
		  for (var i = 1; i < arguments.length; i++) {
		    var source = arguments[i];for (var key in source) {
		      if (Object.prototype.hasOwnProperty.call(source, key)) {
		        target[key] = source[key];
		      }
		    }
		  }return target;
		};
	
		exports['default'] = flexboxOld;
	
		function _defineProperty(obj, key, value) {
		  if (key in obj) {
		    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
		  } else {
		    obj[key] = value;
		  }return obj;
		}
	
		var alternativeValues = {
		  'space-around': 'justify',
		  'space-between': 'justify',
		  'flex-start': 'start',
		  'flex-end': 'end',
		  'wrap-reverse': 'multiple',
		  wrap: 'multiple',
		  flex: 'box',
		  'inline-flex': 'inline-box'
		};
	
		var alternativeProps = {
		  alignItems: 'WebkitBoxAlign',
		  justifyContent: 'WebkitBoxPack',
		  flexWrap: 'WebkitBoxLines'
		};
	
		var properties = Object.keys(alternativeProps).concat(['alignContent', 'alignSelf', 'display', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection']).reduce(function (result, prop) {
		  return _extends({}, result, _defineProperty({}, prop, true));
		}, {});
	
		function flexboxOld(pluginInterface) {
		  var property = pluginInterface.property;
		  var value = pluginInterface.value;
		  var styles = pluginInterface.styles;
		  var browserInfo = pluginInterface.browserInfo;
		  var prefix = pluginInterface.prefix;
		  var keepUnprefixed = pluginInterface.keepUnprefixed;
		  var forceRun = pluginInterface.forceRun;
		  var browser = browserInfo.browser;
		  var version = browserInfo.version;
	
		  if (properties[property] && (forceRun || browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
		    if (!keepUnprefixed) {
		      delete styles[property];
		    }
		    if (property === 'flexDirection') {
		      return {
		        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
		        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
		      };
		    }
		    if (property === 'display' && alternativeValues[value]) {
		      return {
		        display: prefix.css + alternativeValues[value] + (keepUnprefixed ? ';' + property + ':' + value : '')
		      };
		    }
		    if (alternativeProps[property]) {
		      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
		    }
		    if (alternativeValues[value]) {
		      return _defineProperty({}, property, alternativeValues[value] + (keepUnprefixed ? ';' + property + ':' + value : ''));
		    }
		  }
		}
	
		module.exports = exports['default'];
	
	/***/ },
	/* 30 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _getStateKey = __webpack_require__(31);
	
		var _getStateKey2 = _interopRequireDefault(_getStateKey);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var getState = function getState(state, elementKey, value) {
		  var key = (0, _getStateKey2.default)(elementKey);
	
		  return !!state && !!state._radiumStyleState && !!state._radiumStyleState[key] && state._radiumStyleState[key][value];
		};
	
		exports.default = getState;
		module.exports = exports['default'];
	
	/***/ },
	/* 31 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
	
		var getStateKey = function getStateKey(elementKey) {
		  return elementKey === null || elementKey === undefined ? 'main' : elementKey.toString();
		};
	
		exports.default = getStateKey;
		module.exports = exports['default'];
	
	/***/ },
	/* 32 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = hash;
	
	
		// a simple djb2 hash based on hash-string:
		// https://github.com/MatthewBarker/hash-string/blob/master/source/hash-string.js
		// returns a hex-encoded hash
		function hash(text) {
		  if (!text) {
		    return '';
		  }
	
		  var hashValue = 5381;
		  var index = text.length - 1;
	
		  while (index) {
		    hashValue = hashValue * 33 ^ text.charCodeAt(index);
		    index -= 1;
		  }
	
		  return (hashValue >>> 0).toString(16);
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 33 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		exports.isNestedStyle = isNestedStyle;
		exports.mergeStyles = mergeStyles;
		function isNestedStyle(value) {
		  // Don't merge objects overriding toString, since they should be converted
		  // to string values.
		  return value && value.constructor === Object && value.toString === Object.prototype.toString;
		}
	
		// Merge style objects. Deep merge plain object values.
		function mergeStyles(styles) {
		  var result = {};
	
		  styles.forEach(function (style) {
		    if (!style || (typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') {
		      return;
		    }
	
		    if (Array.isArray(style)) {
		      style = mergeStyles(style);
		    }
	
		    Object.keys(style).forEach(function (key) {
		      // Simple case, nothing nested
		      if (!isNestedStyle(style[key]) || !isNestedStyle(result[key])) {
		        result[key] = style[key];
		        return;
		      }
	
		      // If nested media, don't merge the nested styles, append a space to the
		      // end (benign when converted to CSS). This way we don't end up merging
		      // media queries that appear later in the chain with those that appear
		      // earlier.
		      if (key.indexOf('@media') === 0) {
		        var newKey = key;
		        while (true) {
		          // eslint-disable-line no-constant-condition
		          newKey += ' ';
		          if (!result[newKey]) {
		            result[newKey] = style[key];
		            return;
		          }
		        }
		      }
	
		      // Merge all other nested styles recursively
		      result[key] = mergeStyles([result[key], style[key]]);
		    });
		  });
	
		  return result;
		}
	
	/***/ },
	/* 34 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _checkPropsPlugin = __webpack_require__(35);
	
		var _checkPropsPlugin2 = _interopRequireDefault(_checkPropsPlugin);
	
		var _keyframesPlugin = __webpack_require__(36);
	
		var _keyframesPlugin2 = _interopRequireDefault(_keyframesPlugin);
	
		var _mergeStyleArrayPlugin = __webpack_require__(37);
	
		var _mergeStyleArrayPlugin2 = _interopRequireDefault(_mergeStyleArrayPlugin);
	
		var _prefixPlugin = __webpack_require__(38);
	
		var _prefixPlugin2 = _interopRequireDefault(_prefixPlugin);
	
		var _resolveInteractionStylesPlugin = __webpack_require__(39);
	
		var _resolveInteractionStylesPlugin2 = _interopRequireDefault(_resolveInteractionStylesPlugin);
	
		var _resolveMediaQueriesPlugin = __webpack_require__(41);
	
		var _resolveMediaQueriesPlugin2 = _interopRequireDefault(_resolveMediaQueriesPlugin);
	
		var _visitedPlugin = __webpack_require__(42);
	
		var _visitedPlugin2 = _interopRequireDefault(_visitedPlugin);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		/* eslint-disable block-scoped-const */
	
		exports.default = {
		  checkProps: _checkPropsPlugin2.default,
		  keyframes: _keyframesPlugin2.default,
		  mergeStyleArray: _mergeStyleArrayPlugin2.default,
		  prefix: _prefixPlugin2.default,
		  resolveInteractionStyles: _resolveInteractionStylesPlugin2.default,
		  resolveMediaQueries: _resolveMediaQueriesPlugin2.default,
		  visited: _visitedPlugin2.default
		};
		module.exports = exports['default'];
	
	/***/ },
	/* 35 */
	/***/ function(module, exports, __webpack_require__) {
	
		/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		var _checkProps = function checkProps() {};
	
		if (process.env.NODE_ENV !== 'production') {
		  (function () {
		    // Warn if you use longhand and shorthand properties in the same style
		    // object.
		    // https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties
	
		    var shorthandPropertyExpansions = {
		      'background': ['backgroundAttachment', 'backgroundBlendMode', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPosition', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundRepeatX', 'backgroundRepeatY', 'backgroundSize'],
		      'border': ['borderBottom', 'borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderColor', 'borderLeft', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRight', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderStyle', 'borderTop', 'borderTopColor', 'borderTopStyle', 'borderTopWidth', 'borderWidth'],
		      'borderImage': ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
		      'borderRadius': ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
		      'font': ['fontFamily', 'fontKerning', 'fontSize', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantLigatures', 'fontWeight', 'lineHeight'],
		      'listStyle': ['listStyleImage', 'listStylePosition', 'listStyleType'],
		      'margin': ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
		      'padding': ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
		      'transition': ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction']
		    };
	
		    _checkProps = function checkProps(config) {
		      var componentName = config.componentName;
		      var style = config.style;
	
		      if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object' || !style) {
		        return;
		      }
	
		      var styleKeys = Object.keys(style);
		      styleKeys.forEach(function (styleKey) {
		        if (Array.isArray(shorthandPropertyExpansions[styleKey]) && shorthandPropertyExpansions[styleKey].some(function (sp) {
		          return styleKeys.indexOf(sp) !== -1;
		        })) {
		          if (process.env.NODE_ENV !== 'production') {
		            /* eslint-disable no-console */
		            console.warn('Radium: property "' + styleKey + '" in style object', style, ': do not mix longhand and ' + 'shorthand properties in the same style object. Check the render ' + 'method of ' + componentName + '.', 'See https://github.com/FormidableLabs/radium/issues/95 for more ' + 'information.');
		            /* eslint-enable no-console */
		          }
		        }
		      });
	
		      styleKeys.forEach(function (k) {
		        return _checkProps(_extends({}, config, { style: style[k] }));
		      });
		      return;
		    };
		  })();
		}
	
		exports.default = _checkProps;
		module.exports = exports['default'];
		/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))
	
	/***/ },
	/* 36 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = keyframesPlugin;
		function keyframesPlugin(_ref // eslint-disable-line no-shadow
		) {
		  var addCSS = _ref.addCSS;
		  var config = _ref.config;
		  var style = _ref.style;
	
		  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
		    var value = style[key];
		    if (key === 'animationName' && value && value.__radiumKeyframes) {
		      var keyframesValue = value;
	
		      var _keyframesValue$__pro = keyframesValue.__process(config.userAgent);
	
		      var animationName = _keyframesValue$__pro.animationName;
		      var css = _keyframesValue$__pro.css;
	
		      addCSS(css);
		      value = animationName;
		    }
	
		    newStyleInProgress[key] = value;
		    return newStyleInProgress;
		  }, {});
		  return { style: newStyle };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 37 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
	
		// Convenient syntax for multiple styles: `style={[style1, style2, etc]}`
		// Ignores non-objects, so you can do `this.state.isCool && styles.cool`.
		var mergeStyleArrayPlugin = function mergeStyleArrayPlugin(_ref) {
		  var style = _ref.style;
		  var mergeStyles = _ref.mergeStyles;
		  // eslint-disable-line no-shadow
		  var newStyle = Array.isArray(style) ? mergeStyles(style) : style;
		  return { style: newStyle };
		};
	
		exports.default = mergeStyleArrayPlugin;
		module.exports = exports['default'];
	
	/***/ },
	/* 38 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = prefixPlugin;
	
		var _prefixer = __webpack_require__(11);
	
		function prefixPlugin(_ref // eslint-disable-line no-shadow
		) {
		  var config = _ref.config;
		  var style = _ref.style;
	
		  var newStyle = (0, _prefixer.getPrefixedStyle)(style, config.userAgent);
		  return { style: newStyle };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 39 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _mouseUpListener = __webpack_require__(40);
	
		var _mouseUpListener2 = _interopRequireDefault(_mouseUpListener);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var _isInteractiveStyleField = function _isInteractiveStyleField(styleFieldName) {
		  return styleFieldName === ':hover' || styleFieldName === ':active' || styleFieldName === ':focus';
		};
	
		var resolveInteractionStyles = function resolveInteractionStyles(config) {
		  var ExecutionEnvironment = config.ExecutionEnvironment;
		  var getComponentField = config.getComponentField;
		  var getState = config.getState;
		  var mergeStyles = config.mergeStyles;
		  var props = config.props;
		  var setState = config.setState;
		  var style = config.style;
	
	
		  var newComponentFields = {};
		  var newProps = {};
	
		  // Only add handlers if necessary
		  if (style[':hover']) {
		    (function () {
		      // Always call the existing handler if one is already defined.
		      // This code, and the very similar ones below, could be abstracted a bit
		      // more, but it hurts readability IMO.
		      var existingOnMouseEnter = props.onMouseEnter;
		      newProps.onMouseEnter = function (e) {
		        existingOnMouseEnter && existingOnMouseEnter(e);
		        setState(':hover', true);
		      };
	
		      var existingOnMouseLeave = props.onMouseLeave;
		      newProps.onMouseLeave = function (e) {
		        existingOnMouseLeave && existingOnMouseLeave(e);
		        setState(':hover', false);
		      };
		    })();
		  }
	
		  if (style[':active']) {
		    (function () {
		      var existingOnMouseDown = props.onMouseDown;
		      newProps.onMouseDown = function (e) {
		        existingOnMouseDown && existingOnMouseDown(e);
		        newComponentFields._lastMouseDown = Date.now();
		        setState(':active', 'viamousedown');
		      };
	
		      var existingOnKeyDown = props.onKeyDown;
		      newProps.onKeyDown = function (e) {
		        existingOnKeyDown && existingOnKeyDown(e);
		        if (e.key === ' ' || e.key === 'Enter') {
		          setState(':active', 'viakeydown');
		        }
		      };
	
		      var existingOnKeyUp = props.onKeyUp;
		      newProps.onKeyUp = function (e) {
		        existingOnKeyUp && existingOnKeyUp(e);
		        if (e.key === ' ' || e.key === 'Enter') {
		          setState(':active', false);
		        }
		      };
		    })();
		  }
	
		  if (style[':focus']) {
		    (function () {
		      var existingOnFocus = props.onFocus;
		      newProps.onFocus = function (e) {
		        existingOnFocus && existingOnFocus(e);
		        setState(':focus', true);
		      };
	
		      var existingOnBlur = props.onBlur;
		      newProps.onBlur = function (e) {
		        existingOnBlur && existingOnBlur(e);
		        setState(':focus', false);
		      };
		    })();
		  }
	
		  if (style[':active'] && !getComponentField('_radiumMouseUpListener') && ExecutionEnvironment.canUseEventListeners) {
		    newComponentFields._radiumMouseUpListener = _mouseUpListener2.default.subscribe(function () {
		      Object.keys(getComponentField('state')._radiumStyleState).forEach(function (key) {
		        if (getState(':active', key) === 'viamousedown') {
		          setState(':active', false, key);
		        }
		      });
		    });
		  }
	
		  // Merge the styles in the order they were defined
		  var interactionStyles = Object.keys(style).filter(function (name) {
		    return _isInteractiveStyleField(name) && getState(name);
		  }).map(function (name) {
		    return style[name];
		  });
	
		  var newStyle = mergeStyles([style].concat(interactionStyles));
	
		  // Remove interactive styles
		  newStyle = Object.keys(newStyle).reduce(function (styleWithoutInteractions, name) {
		    if (!_isInteractiveStyleField(name)) {
		      styleWithoutInteractions[name] = newStyle[name];
		    }
		    return styleWithoutInteractions;
		  }, {});
	
		  return {
		    componentFields: newComponentFields,
		    props: newProps,
		    style: newStyle
		  };
		};
	
		exports.default = resolveInteractionStyles;
		module.exports = exports['default'];
	
	/***/ },
	/* 40 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
	
		var _callbacks = [];
		var _mouseUpListenerIsActive = false;
	
		function _handleMouseUp() {
		  _callbacks.forEach(function (callback) {
		    callback();
		  });
		}
	
		var subscribe = function subscribe(callback) {
		  if (_callbacks.indexOf(callback) === -1) {
		    _callbacks.push(callback);
		  }
	
		  if (!_mouseUpListenerIsActive) {
		    window.addEventListener('mouseup', _handleMouseUp);
		    _mouseUpListenerIsActive = true;
		  }
	
		  return {
		    remove: function remove() {
		      var index = _callbacks.indexOf(callback);
		      _callbacks.splice(index, 1);
	
		      if (_callbacks.length === 0 && _mouseUpListenerIsActive) {
		        window.removeEventListener('mouseup', _handleMouseUp);
		        _mouseUpListenerIsActive = false;
		      }
		    }
		  };
		};
	
		exports.default = {
		  subscribe: subscribe,
		  __triggerForTests: _handleMouseUp
		};
		module.exports = exports['default'];
	
	/***/ },
	/* 41 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
		exports.default = resolveMediaQueries;
	
	
		var _windowMatchMedia = undefined;
		function _getWindowMatchMedia(ExecutionEnvironment) {
		  if (_windowMatchMedia === undefined) {
		    _windowMatchMedia = !!ExecutionEnvironment.canUseDOM && !!window && !!window.matchMedia && function (mediaQueryString) {
		      return window.matchMedia(mediaQueryString);
		    } || null;
		  }
		  return _windowMatchMedia;
		}
	
		function _filterObject(obj, predicate) {
		  return Object.keys(obj).filter(function (key) {
		    return predicate(obj[key], key);
		  }).reduce(function (result, key) {
		    result[key] = obj[key];
		    return result;
		  }, {});
		}
	
		function _removeMediaQueries(style) {
		  return Object.keys(style).reduce(function (styleWithoutMedia, key) {
		    if (key.indexOf('@media') !== 0) {
		      styleWithoutMedia[key] = style[key];
		    }
		    return styleWithoutMedia;
		  }, {});
		}
	
		function _topLevelRulesToCSS(_ref) {
		  var addCSS = _ref.addCSS;
		  var appendImportantToEachValue = _ref.appendImportantToEachValue;
		  var cssRuleSetToString = _ref.cssRuleSetToString;
		  var hash = _ref.hash;
		  var isNestedStyle = _ref.isNestedStyle;
		  var style = _ref.style;
		  var userAgent = _ref.userAgent;
	
		  var className = '';
		  Object.keys(style).filter(function (name) {
		    return name.indexOf('@media') === 0;
		  }).map(function (query) {
		    var topLevelRules = appendImportantToEachValue(_filterObject(style[query], function (value) {
		      return !isNestedStyle(value);
		    }));
	
		    if (!Object.keys(topLevelRules).length) {
		      return;
		    }
	
		    var ruleCSS = cssRuleSetToString('', topLevelRules, userAgent);
	
		    // CSS classes cannot start with a number
		    var mediaQueryClassName = 'rmq-' + hash(query + ruleCSS);
		    var css = query + '{ .' + mediaQueryClassName + ruleCSS + '}';
	
		    addCSS(css);
	
		    className += (className ? ' ' : '') + mediaQueryClassName;
		  });
		  return className;
		}
	
		function _subscribeToMediaQuery(_ref2) {
		  var listener = _ref2.listener;
		  var listenersByQuery = _ref2.listenersByQuery;
		  var matchMedia = _ref2.matchMedia;
		  var mediaQueryListsByQuery = _ref2.mediaQueryListsByQuery;
		  var query = _ref2.query;
	
		  query = query.replace('@media ', '');
	
		  var mql = mediaQueryListsByQuery[query];
		  if (!mql && matchMedia) {
		    mediaQueryListsByQuery[query] = mql = matchMedia(query);
		  }
	
		  if (!listenersByQuery || !listenersByQuery[query]) {
		    mql.addListener(listener);
	
		    listenersByQuery[query] = {
		      remove: function remove() {
		        mql.removeListener(listener);
		      }
		    };
		  }
		  return mql;
		}
	
		function resolveMediaQueries(_ref3) {
		  var ExecutionEnvironment = _ref3.ExecutionEnvironment;
		  var addCSS = _ref3.addCSS;
		  var appendImportantToEachValue = _ref3.appendImportantToEachValue;
		  var config = _ref3.config;
		  var cssRuleSetToString = _ref3.cssRuleSetToString;
		  var getComponentField = _ref3.getComponentField;
		  var getGlobalState = _ref3.getGlobalState;
		  var hash = _ref3.hash;
		  var isNestedStyle = _ref3.isNestedStyle;
		  var mergeStyles = _ref3.mergeStyles;
		  var props = _ref3.props;
		  var setState = _ref3.setState;
		  var style = _ref3.style;
		  // eslint-disable-line no-shadow
		  var newStyle = _removeMediaQueries(style);
		  var mediaQueryClassNames = _topLevelRulesToCSS({
		    addCSS: addCSS,
		    appendImportantToEachValue: appendImportantToEachValue,
		    cssRuleSetToString: cssRuleSetToString,
		    hash: hash,
		    isNestedStyle: isNestedStyle,
		    style: style,
		    userAgent: config.userAgent
		  });
	
		  var newProps = mediaQueryClassNames ? {
		    className: mediaQueryClassNames + (props.className ? ' ' + props.className : '')
		  } : null;
	
		  var matchMedia = config.matchMedia || _getWindowMatchMedia(ExecutionEnvironment);
	
		  if (!matchMedia) {
		    return {
		      props: newProps,
		      style: newStyle
		    };
		  }
	
		  var listenersByQuery = _extends({}, getComponentField('_radiumMediaQueryListenersByQuery'));
		  var mediaQueryListsByQuery = getGlobalState('mediaQueryListsByQuery') || {};
	
		  Object.keys(style).filter(function (name) {
		    return name.indexOf('@media') === 0;
		  }).map(function (query) {
		    var nestedRules = _filterObject(style[query], isNestedStyle);
	
		    if (!Object.keys(nestedRules).length) {
		      return;
		    }
	
		    var mql = _subscribeToMediaQuery({
		      listener: function listener() {
		        return setState(query, mql.matches, '_all');
		      },
		      listenersByQuery: listenersByQuery,
		      matchMedia: matchMedia,
		      mediaQueryListsByQuery: mediaQueryListsByQuery,
		      query: query
		    });
	
		    // Apply media query states
		    if (mql.matches) {
		      newStyle = mergeStyles([newStyle, nestedRules]);
		    }
		  });
	
		  return {
		    componentFields: {
		      _radiumMediaQueryListenersByQuery: listenersByQuery
		    },
		    globalState: { mediaQueryListsByQuery: mediaQueryListsByQuery },
		    props: newProps,
		    style: newStyle
		  };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 42 */
	/***/ function(module, exports) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = visited;
		function visited(_ref) {
		  var addCSS = _ref.addCSS;
		  var appendImportantToEachValue = _ref.appendImportantToEachValue;
		  var config = _ref.config;
		  var cssRuleSetToString = _ref.cssRuleSetToString;
		  var hash = _ref.hash;
		  var props = _ref.props;
		  var style = _ref.style;
		  // eslint-disable-line no-shadow
		  var className = props.className;
	
		  var newStyle = Object.keys(style).reduce(function (newStyleInProgress, key) {
		    var value = style[key];
		    if (key === ':visited') {
		      value = appendImportantToEachValue(value);
		      var ruleCSS = cssRuleSetToString('', value, config.userAgent);
		      var visitedClassName = 'rad-' + hash(ruleCSS);
		      var css = '.' + visitedClassName + ':visited' + ruleCSS;
	
		      addCSS(css);
		      className = (className ? className + ' ' : '') + visitedClassName;
		    } else {
		      newStyleInProgress[key] = value;
		    }
	
		    return newStyleInProgress;
		  }, {});
	
		  return {
		    props: className === props.className ? null : { className: className },
		    style: newStyle
		  };
		}
		module.exports = exports['default'];
	
	/***/ },
	/* 43 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
		var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
		/*!
		  Copyright (c) 2015 Jed Watson.
		  Based on code that is Copyright 2013-2015, Facebook, Inc.
		  All rights reserved.
		*/
	
		(function () {
			'use strict';
	
			var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
			var ExecutionEnvironment = {
	
				canUseDOM: canUseDOM,
	
				canUseWorkers: typeof Worker !== 'undefined',
	
				canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
				canUseViewport: canUseDOM && !!window.screen
	
			};
	
			if ("function" === 'function' && _typeof(__webpack_require__(44)) === 'object' && __webpack_require__(44)) {
				!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
					return ExecutionEnvironment;
				}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			} else if (typeof module !== 'undefined' && module.exports) {
				module.exports = ExecutionEnvironment;
			} else {
				window.ExecutionEnvironment = ExecutionEnvironment;
			}
		})();
	
	/***/ },
	/* 44 */
	/***/ function(module, exports) {
	
		/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
		/* WEBPACK VAR INJECTION */}.call(exports, {}))
	
	/***/ },
	/* 45 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _cssRuleSetToString = __webpack_require__(9);
	
		var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		var Style = _react2.default.createClass({
		  displayName: 'Style',
	
		  propTypes: {
		    radiumConfig: _react.PropTypes.object,
		    rules: _react.PropTypes.object,
		    scopeSelector: _react.PropTypes.string
		  },
	
		  contextTypes: {
		    _radiumConfig: _react.PropTypes.object
		  },
	
		  getDefaultProps: function getDefaultProps() {
		    return {
		      scopeSelector: ''
		    };
		  },
		  _buildStyles: function _buildStyles(styles) {
		    var _this = this;
	
		    var userAgent = this.props.radiumConfig && this.props.radiumConfig.userAgent || this.context && this.context._radiumConfig && this.context._radiumConfig.userAgent;
	
		    return Object.keys(styles).reduce(function (accumulator, selector) {
		      var scopeSelector = _this.props.scopeSelector;
	
		      var rules = styles[selector];
	
		      if (selector === 'mediaQueries') {
		        accumulator += _this._buildMediaQueryString(rules);
		      } else {
		        var completeSelector = scopeSelector ? selector.split(',').map(function (part) {
		          return scopeSelector + ' ' + part.trim();
		        }).join(',') : selector;
	
		        accumulator += (0, _cssRuleSetToString2.default)(completeSelector, rules, userAgent);
		      }
	
		      return accumulator;
		    }, '');
		  },
		  _buildMediaQueryString: function _buildMediaQueryString(stylesByMediaQuery) {
		    var _this2 = this;
	
		    var contextMediaQueries = this._getContextMediaQueries();
		    var mediaQueryString = '';
	
		    Object.keys(stylesByMediaQuery).forEach(function (query) {
		      var completeQuery = contextMediaQueries[query] ? contextMediaQueries[query] : query;
		      mediaQueryString += '@media ' + completeQuery + '{' + _this2._buildStyles(stylesByMediaQuery[query]) + '}';
		    });
	
		    return mediaQueryString;
		  },
		  _getContextMediaQueries: function _getContextMediaQueries() {
		    var _this3 = this;
	
		    var contextMediaQueries = {};
		    if (this.context && this.context.mediaQueries) {
		      Object.keys(this.context.mediaQueries).forEach(function (query) {
		        contextMediaQueries[query] = _this3.context.mediaQueries[query].media;
		      });
		    }
	
		    return contextMediaQueries;
		  },
		  render: function render() {
		    if (!this.props.rules) {
		      return null;
		    }
	
		    var styles = this._buildStyles(this.props.rules);
	
		    return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: styles } });
		  }
		});
	
		exports.default = Style;
		module.exports = exports['default'];
	
	/***/ },
	/* 46 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _enhancer = __webpack_require__(1);
	
		var _enhancer2 = _interopRequireDefault(_enhancer);
	
		var _styleKeeper = __webpack_require__(4);
	
		var _styleKeeper2 = _interopRequireDefault(_styleKeeper);
	
		var _styleSheet = __webpack_require__(47);
	
		var _styleSheet2 = _interopRequireDefault(_styleSheet);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		function _getStyleKeeper(instance) {
		  if (!instance._radiumStyleKeeper) {
		    var userAgent = instance.props.radiumConfig && instance.props.radiumConfig.userAgent || instance.context._radiumConfig && instance.context._radiumConfig.userAgent;
		    instance._radiumStyleKeeper = new _styleKeeper2.default(userAgent);
		  }
	
		  return instance._radiumStyleKeeper;
		}
	
		var StyleRoot = function (_Component) {
		  _inherits(StyleRoot, _Component);
	
		  function StyleRoot() {
		    _classCallCheck(this, StyleRoot);
	
		    var _this = _possibleConstructorReturn(this, _Component.apply(this, arguments));
	
		    _getStyleKeeper(_this);
		    return _this;
		  }
	
		  StyleRoot.prototype.getChildContext = function getChildContext() {
		    return { _radiumStyleKeeper: _getStyleKeeper(this) };
		  };
	
		  StyleRoot.prototype.render = function render() {
		    return _react2.default.createElement(
		      'div',
		      this.props,
		      this.props.children,
		      _react2.default.createElement(_styleSheet2.default, null)
		    );
		  };
	
		  return StyleRoot;
		}(_react.Component);
	
		StyleRoot.contextTypes = {
		  _radiumConfig: _react.PropTypes.object,
		  _radiumStyleKeeper: _react.PropTypes.instanceOf(_styleKeeper2.default)
		};
	
		StyleRoot.childContextTypes = {
		  _radiumStyleKeeper: _react.PropTypes.instanceOf(_styleKeeper2.default)
		};
	
		StyleRoot = (0, _enhancer2.default)(StyleRoot);
	
		exports.default = StyleRoot;
		module.exports = exports['default'];
	
	/***/ },
	/* 47 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = undefined;
	
		var _class, _temp;
	
		var _react = __webpack_require__(3);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _styleKeeper = __webpack_require__(4);
	
		var _styleKeeper2 = _interopRequireDefault(_styleKeeper);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var StyleSheet = (_temp = _class = function (_Component) {
		  _inherits(StyleSheet, _Component);
	
		  function StyleSheet() {
		    _classCallCheck(this, StyleSheet);
	
		    var _this = _possibleConstructorReturn(this, _Component.apply(this, arguments));
	
		    _this.state = _this._getCSSState();
	
		    _this._onChange = _this._onChange.bind(_this);
		    return _this;
		  }
	
		  StyleSheet.prototype.componentDidMount = function componentDidMount() {
		    this._isMounted = true;
		    this._subscription = this.context._radiumStyleKeeper.subscribe(this._onChange);
		    this._onChange();
		  };
	
		  StyleSheet.prototype.componentWillUnmount = function componentWillUnmount() {
		    this._isMounted = false;
		    if (this._subscription) {
		      this._subscription.remove();
		    }
		  };
	
		  StyleSheet.prototype._getCSSState = function _getCSSState() {
		    return { css: this.context._radiumStyleKeeper.getCSS() };
		  };
	
		  StyleSheet.prototype._onChange = function _onChange() {
		    var _this2 = this;
	
		    setTimeout(function () {
		      _this2._isMounted && _this2.setState(_this2._getCSSState());
		    }, 0);
		  };
	
		  StyleSheet.prototype.render = function render() {
		    return _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: this.state.css } });
		  };
	
		  return StyleSheet;
		}(_react.Component), _class.contextTypes = {
		  _radiumStyleKeeper: _react2.default.PropTypes.instanceOf(_styleKeeper2.default)
		}, _temp);
		exports.default = StyleSheet;
		module.exports = exports['default'];
	
	/***/ },
	/* 48 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		exports.default = keyframes;
	
		var _cssRuleSetToString = __webpack_require__(9);
	
		var _cssRuleSetToString2 = _interopRequireDefault(_cssRuleSetToString);
	
		var _hash = __webpack_require__(32);
	
		var _hash2 = _interopRequireDefault(_hash);
	
		var _prefixer = __webpack_require__(11);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function keyframes(keyframeRules, name) {
		  return {
		    __radiumKeyframes: true,
		    __process: function __process(userAgent) {
		      var keyframesPrefixed = (0, _prefixer.getPrefixedKeyframes)(userAgent);
		      var rules = Object.keys(keyframeRules).map(function (percentage) {
		        return (0, _cssRuleSetToString2.default)(percentage, keyframeRules[percentage], userAgent);
		      }).join('\n');
		      var animationName = (name ? name + '-' : '') + 'radium-animation-' + (0, _hash2.default)(rules);
		      var css = '@' + keyframesPrefixed + ' ' + animationName + ' {\n' + rules + '\n}\n';
		      return { css: css, animationName: animationName };
		    }
		  };
		}
		module.exports = exports['default'];
	
	/***/ }
	/******/ ])
	});
	;

/***/ },
/* 270 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);

/***/ },
/* 271 */
/***/ function(module, exports) {

	'use strict';
	
	var inBrowser = typeof window != 'undefined';
	var root = inBrowser ? window : global;
	
	// set root variable
	if (inBrowser) window.root = window;else global.root = global;
	
	if (!inBrowser) {
	  // for isomorphic help
	  root.document = {};
	}

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactDom = __webpack_require__(265);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _react = __webpack_require__(106);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _history = __webpack_require__(273);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _motionRadium = __webpack_require__(269);
	
	var _motionRadium2 = _interopRequireDefault(_motionRadium);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// exports
	root.exports = root.exports || {};
	root.exports.history = _history2.default;
	root.exports.React = _react2.default;
	root.exports.ReactDOM = _reactDom2.default;
	root.exports.radium = _motionRadium2.default;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(274);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _createLocation2 = __webpack_require__(276);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _createBrowserHistory = __webpack_require__(280);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	exports.createHistory = _createBrowserHistory2['default'];
	
	var _createHashHistory2 = __webpack_require__(292);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	exports.createHashHistory = _createHashHistory3['default'];
	
	var _createMemoryHistory2 = __webpack_require__(293);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	exports.createMemoryHistory = _createMemoryHistory3['default'];
	
	var _useBasename2 = __webpack_require__(294);
	
	var _useBasename3 = _interopRequireDefault(_useBasename2);
	
	exports.useBasename = _useBasename3['default'];
	
	var _useBeforeUnload2 = __webpack_require__(295);
	
	var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);
	
	exports.useBeforeUnload = _useBeforeUnload3['default'];
	
	var _useQueries2 = __webpack_require__(296);
	
	var _useQueries3 = _interopRequireDefault(_useQueries2);
	
	exports.useQueries = _useQueries3['default'];
	
	var _Actions2 = __webpack_require__(277);
	
	var _Actions3 = _interopRequireDefault(_Actions2);
	
	exports.Actions = _Actions3['default'];
	
	// deprecated
	
	var _enableBeforeUnload2 = __webpack_require__(299);
	
	var _enableBeforeUnload3 = _interopRequireDefault(_enableBeforeUnload2);
	
	exports.enableBeforeUnload = _enableBeforeUnload3['default'];
	
	var _enableQueries2 = __webpack_require__(300);
	
	var _enableQueries3 = _interopRequireDefault(_enableQueries2);
	
	exports.enableQueries = _enableQueries3['default'];
	var createLocation = _deprecate2['default'](_createLocation3['default'], 'Using createLocation without a history instance is deprecated; please use history.createLocation instead');
	exports.createLocation = createLocation;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(275);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(275);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(277);
	
	var _parsePath = __webpack_require__(278);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _parsePath2['default'](location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 277 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(275);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _extractPath = __webpack_require__(279);
	
	var _extractPath2 = _interopRequireDefault(_extractPath);
	
	function parsePath(path) {
	  var pathname = _extractPath2['default'](path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}
	
	exports['default'] = parsePath;
	module.exports = exports['default'];

/***/ },
/* 279 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	exports["default"] = extractPath;
	module.exports = exports["default"];

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(281);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(277);
	
	var _ExecutionEnvironment = __webpack_require__(282);
	
	var _DOMUtils = __webpack_require__(283);
	
	var _DOMStateStorage = __webpack_require__(284);
	
	var _createDOMHistory = __webpack_require__(285);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	var _parsePath = __webpack_require__(278);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    historyState = historyState || window.history.state || {};
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null, path);
	    }
	
	    var location = _parsePath2['default'](path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 282 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 283 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  // FIXME: Work around our browser history not working correctly on Chrome
	  // iOS: https://github.com/rackt/react-router/issues/2565
	  if (ua.indexOf('CriOS') !== -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(275);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededError = 'QuotaExceededError';
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (error.name === QuotaExceededError && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(281);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(282);
	
	var _DOMUtils = __webpack_require__(283);
	
	var _createHistory = __webpack_require__(286);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(275);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(287);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _AsyncUtils = __webpack_require__(290);
	
	var _Actions = __webpack_require__(277);
	
	var _createLocation2 = __webpack_require__(276);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(291);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _parsePath = __webpack_require__(278);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	var _deprecate = __webpack_require__(274);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var keyLength = options.keyLength;
	  var getUserConfirmation = options.getUserConfirmation;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _parsePath2['default'](location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _parsePath2['default'](path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _parsePath2['default'](path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(288);
	var isArguments = __webpack_require__(289);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 288 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 289 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 290 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0;
	  var isDone = false;
	
	  function done() {
	    isDone = true;
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) return;
	
	    if (currentTurn < turns) {
	      work.call(this, currentTurn++, next, done);
	    } else {
	      done.apply(this, arguments);
	    }
	  }
	
	  next();
	}

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(275);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(275);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(281);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(277);
	
	var _ExecutionEnvironment = __webpack_require__(282);
	
	var _DOMUtils = __webpack_require__(283);
	
	var _DOMStateStorage = __webpack_require__(284);
	
	var _createDOMHistory = __webpack_require__(285);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	var _parsePath = __webpack_require__(278);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _parsePath2['default'](path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(275);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(281);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(277);
	
	var _createHistory = __webpack_require__(286);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _parsePath = __webpack_require__(278);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var key = entry.key;
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var state = undefined;
	    if (key) {
	      state = readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	      entry.key = key;
	    }
	
	    var location = _parsePath2['default'](path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _ExecutionEnvironment = __webpack_require__(282);
	
	var _runTransitionHook = __webpack_require__(291);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _extractPath = __webpack_require__(279);
	
	var _extractPath2 = _interopRequireDefault(_extractPath);
	
	var _parsePath = __webpack_require__(278);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	var _deprecate = __webpack_require__(274);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var basename = options.basename;
	
	    var historyOptions = _objectWithoutProperties(options, ['basename']);
	
	    var history = createHistory(historyOptions);
	
	    // Automatically use the value of <base href> in HTML
	    // documents as basename if it's not explicitly given.
	    if (basename == null && _ExecutionEnvironment.canUseDOM) {
	      var base = document.getElementsByTagName('base')[0];
	
	      if (base) basename = _extractPath2['default'](base.href);
	    }
	
	    function addBasename(location) {
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _parsePath2['default'](location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation() {
	      return addBasename(history.createLocation.apply(history, arguments));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(275);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(282);
	
	var _DOMUtils = __webpack_require__(283);
	
	var _deprecate = __webpack_require__(274);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function startBeforeUnloadListener(getBeforeUnloadPromptMessage) {
	  function listener(event) {
	    var message = getBeforeUnloadPromptMessage();
	
	    if (typeof message === 'string') {
	      (event || window.event).returnValue = message;
	      return message;
	    }
	  }
	
	  _DOMUtils.addEventListener(window, 'beforeunload', listener);
	
	  return function () {
	    _DOMUtils.removeEventListener(window, 'beforeunload', listener);
	  };
	}
	
	/**
	 * Returns a new createHistory function that can be used to create
	 * history objects that know how to use the beforeunload event in web
	 * browsers to cancel navigation.
	 */
	function useBeforeUnload(createHistory) {
	  return function (options) {
	    var history = createHistory(options);
	
	    var stopBeforeUnloadListener = undefined;
	    var beforeUnloadHooks = [];
	
	    function getBeforeUnloadPromptMessage() {
	      var message = undefined;
	
	      for (var i = 0, len = beforeUnloadHooks.length; message == null && i < len; ++i) {
	        message = beforeUnloadHooks[i].call();
	      }return message;
	    }
	
	    function listenBeforeUnload(hook) {
	      beforeUnloadHooks.push(hook);
	
	      if (beforeUnloadHooks.length === 1) {
	        if (_ExecutionEnvironment.canUseDOM) {
	          stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
	        } else {
	           false ? _warning2['default'](false, 'listenBeforeUnload only works in DOM environments') : undefined;
	        }
	      }
	
	      return function () {
	        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (beforeUnloadHooks.length === 0 && stopBeforeUnloadListener) {
	          stopBeforeUnloadListener();
	          stopBeforeUnloadListener = null;
	        }
	      };
	    }
	
	    // deprecated
	    function registerBeforeUnloadHook(hook) {
	      if (_ExecutionEnvironment.canUseDOM && beforeUnloadHooks.indexOf(hook) === -1) {
	        beforeUnloadHooks.push(hook);
	
	        if (beforeUnloadHooks.length === 1) stopBeforeUnloadListener = startBeforeUnloadListener(getBeforeUnloadPromptMessage);
	      }
	    }
	
	    // deprecated
	    function unregisterBeforeUnloadHook(hook) {
	      if (beforeUnloadHooks.length > 0) {
	        beforeUnloadHooks = beforeUnloadHooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (beforeUnloadHooks.length === 0) stopBeforeUnloadListener();
	      }
	    }
	
	    return _extends({}, history, {
	      listenBeforeUnload: listenBeforeUnload,
	
	      registerBeforeUnloadHook: _deprecate2['default'](registerBeforeUnloadHook, 'registerBeforeUnloadHook is deprecated; use listenBeforeUnload instead'),
	      unregisterBeforeUnloadHook: _deprecate2['default'](unregisterBeforeUnloadHook, 'unregisterBeforeUnloadHook is deprecated; use the callback returned from listenBeforeUnload instead')
	    });
	  };
	}
	
	exports['default'] = useBeforeUnload;
	module.exports = exports['default'];

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _warning = __webpack_require__(275);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(297);
	
	var _runTransitionHook = __webpack_require__(291);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _parsePath = __webpack_require__(278);
	
	var _parsePath2 = _interopRequireDefault(_parsePath);
	
	var _deprecate = __webpack_require__(274);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (object.hasOwnProperty(p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    var historyOptions = _objectWithoutProperties(options, ['stringifyQuery', 'parseQueryString']);
	
	    var history = createHistory(historyOptions);
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var queryString = undefined;
	      if (!query || (queryString = stringifyQuery(query)) === '') return location;
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _parsePath2['default'](location);
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase + (searchBase ? '&' : '?') + queryString;
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation() {
	      return addQuery(history.createLocation.apply(history, arguments));
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _parsePath2['default'](path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(298);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 298 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(274);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _useBeforeUnload = __webpack_require__(295);
	
	var _useBeforeUnload2 = _interopRequireDefault(_useBeforeUnload);
	
	exports['default'] = _deprecate2['default'](_useBeforeUnload2['default'], 'enableBeforeUnload is deprecated, use useBeforeUnload instead');
	module.exports = exports['default'];

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _deprecate = __webpack_require__(274);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var _useQueries = __webpack_require__(296);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	exports['default'] = _deprecate2['default'](_useQueries2['default'], 'enableQueries is deprecated, use useQueries instead');
	module.exports = exports['default'];

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(59);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(302);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(3);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _typeof2 = __webpack_require__(303);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _reactDom = __webpack_require__(265);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// ok delayed attempt to make sense of this
	// this file needs refactor love
	// start from bottom and read to top:
	// function On()
	//   => this.run
	//   => finish
	//   => onEventInit
	//   => addListener
	
	var viewEvents = ['mount', 'unmount', 'change', 'render', 'props'];
	
	// starts a listener
	// returns the off event to remove the listener
	// TODO split this into individual functions for each type
	function addListener(_ref) {
	  var rootNode = _ref.rootNode;
	  var scope = _ref.scope;
	  var name = _ref.name;
	  var number = _ref.number;
	  var cb = _ref.cb;
	  var uid = _ref.uid;
	
	  if (name == 'delay') {
	    var _ret = function () {
	      // on('delay', 400, cb)
	      var timer = setTimeout(cb, number);
	      return {
	        v: function v() {
	          return clearTimeout(timer);
	        }
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
	  }
	
	  if (name == 'every') {
	    var _ret2 = function () {
	      // on('every', 20, cb)
	      var interval = setInterval(cb, number);
	      return {
	        v: function v() {
	          return clearInterval(interval);
	        }
	      };
	    }();
	
	    if ((typeof _ret2 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret2)) === "object") return _ret2.v;
	  }
	
	  if (name == 'frame') {
	    var _ret3 = function () {
	      var active = true;
	      var loop = function loop() {
	        return requestAnimationFrame(function () {
	          cb();
	          if (active) loop();
	        });
	      };
	      loop();
	      return {
	        v: function v() {
	          return active = false;
	        }
	      };
	    }();
	
	    if ((typeof _ret3 === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret3)) === "object") return _ret3.v;
	  }
	
	  var target = scope || rootNode || window;
	
	  // this will pass data automatically for custom on.event
	  var smartCb = function smartCb(e) {
	    var isCustom = (typeof e === 'undefined' ? 'undefined' : (0, _typeof3.default)(e)) == 'object' && (0, _typeof3.default)(e.detail) == 'object';
	    cb(isCustom ? e.detail : e);
	  };
	
	  target.addEventListener(name, smartCb);
	
	  // return off event
	  return function () {
	    return target.removeEventListener(name, smartCb);
	  };
	}
	
	function onEventInit(_ref2) {
	  var view = _ref2.view;
	  var scope = _ref2.scope;
	  var name = _ref2.name;
	  var number = _ref2.number;
	  var cb = _ref2.cb;
	
	  var finish = function finish() {
	    return cb && cb.apply(undefined, arguments);
	  };
	  var events = view && view.events;
	
	  if (events && viewEvents.indexOf(name) >= 0) {
	    if (events && events[name] != 'undefined') {
	      ensureQueue(events, name);
	      events[name].push(finish);
	      return;
	    }
	  }
	
	  // if not in view
	  if (!hasEvents(events)) {
	    return addListener({ scope: scope, name: name, cb: finish });
	  }
	
	  // if inside view
	  ensureQueue(events, 'mount', 'unmount');
	  // to return
	  var result = undefined;
	
	  var eventFn = function eventFn(uid) {
	    var rootNode = getRoot(view);
	    removeByUids[uid] = addListener({ scope: scope, rootNode: rootNode, name: name, number: number, cb: finish });
	    return removeByUids[uid];
	  };
	
	  // attach to mount depending
	  if (view.mounted) result = eventFn();else {
	    (function () {
	      var uid = getUid();
	      events.mount.push(function () {
	        return eventFn(uid);
	      });
	      result = unlistenFromUid(uid);
	    })();
	  }
	
	  // unmount push
	  events.unmount.push(result);
	
	  return result;
	}
	
	function On(view) {
	  this.run = function (name, scope, cb) {
	    // delay/every
	    if (name == 'delay' || name == 'every') {
	      var number = scope;
	      return finish({ view: view, name: name, number: number, cb: cb });
	    }
	
	    // callback with no scope
	    else if (typeof scope == 'function') {
	        cb = scope;
	        scope = null;
	      }
	
	    if (typeof name != 'string') throw new Error("When using on(), you must pass a name, like on('scroll')");
	
	    return finish({ scope: scope, name: name, cb: cb, view: view });
	  };
	
	  function finish(opts) {
	    return opts.cb ? onEventInit(opts) : new _promise2.default(function (resolve) {
	      return onEventInit((0, _extends3.default)({}, opts, { cb: resolve }));
	    });
	  }
	}
	
	// TODO not on global
	root.On = On;
	
	var proto = function proto(name) {
	  On.prototype[name] = function (scope, cb, number) {
	    return this.run(name, scope, cb, number);
	  };
	};
	
	// custom events
	On.prototype.event = function (name, scope, cb, number) {
	  // firing
	  if (typeof scope == 'undefined' || (typeof scope === 'undefined' ? 'undefined' : (0, _typeof3.default)(scope)) == 'object') {
	    var event = new CustomEvent(name, scope ? { detail: scope } : null);
	    return window.dispatchEvent(event);
	  }
	
	  // firing on custom scope
	  if (typeof scope != 'function' && typeof cb == 'function') {
	    console.error('we need to implement custom scoped events still :)');
	    return;
	  }
	
	  // listening
	  if (typeof scope == 'function') {
	    return this.run(name, window, scope);
	  }
	
	  throw new Error("You called an event without name or scope!");
	};
	
	// motion
	proto('delay');
	proto('every');
	proto('frame');
	
	proto('mount');
	proto('unmount');
	proto('change');
	proto('render');
	proto('props');
	
	// DOM level 2 at most
	
	// mouse
	proto('click');
	proto('mousedown');
	proto('mouseenter');
	proto('mouseleave');
	proto('mousemove');
	proto('mouseover');
	proto('mouseout');
	proto('mouseup');
	
	// touch
	proto('touchdown');
	proto('touchenter');
	proto('touchleave');
	proto('touchmove');
	proto('touchout');
	proto('touchup');
	
	// keyboard
	proto('keydown');
	proto('keypress');
	proto('keyup');
	
	// frame/object
	proto('abort');
	proto('beforeunload');
	proto('error');
	proto('load');
	proto('resize');
	proto('scroll');
	proto('unload');
	
	// form
	proto('blur');
	proto('change');
	proto('focus');
	proto('reset');
	proto('select');
	proto('submit');
	
	var on = new On();
	
	// TODO shim this outside this file
	root.on = on;
	
	exports.default = on;
	
	// helpers
	
	var removeByUids = {};
	var uid = 0;
	function getUid() {
	  return uid++ % Number.MAX_VALUE;
	}
	function unlistenFromUid(uid) {
	  return function () {
	    if (removeByUids[uid]) {
	      removeByUids[uid]();
	    }
	    delete removeByUids[uid];
	  };
	}
	
	function ensureQueue(where) {
	  for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    names[_key - 1] = arguments[_key];
	  }
	
	  names.forEach(function (name) {
	    where[name] = where[name] || [];
	  });
	}
	
	function getRoot(scope) {
	  return _reactDom2.default.findDOMNode(scope);
	}
	
	function hasEvents(events) {
	  return events && (0, _keys2.default)(events).length;
	}

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$assign = __webpack_require__(85)["default"];
	
	exports["default"] = _Object$assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Symbol = __webpack_require__(91)["default"];
	
	exports["default"] = function (obj) {
	  return obj && obj.constructor === _Symbol ? "symbol" : typeof obj;
	};
	
	exports.__esModule = true;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reportError = __webpack_require__(305);
	
	var _reportError2 = _interopRequireDefault(_reportError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (typeof window == 'undefined') {
	  process.on("unhandledRejection", function (reason, promise) {
	    (0, _reportError2.default)(reason);
	    throw reason;
	  });
	} else {
	  window.addEventListener("unhandledrejection", function (e) {
	    e.preventDefault();
	    var reason = e.detail.reason;
	    (0, _reportError2.default)(reason);
	    throw reason;
	  });
	}

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(306);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _typeof2 = __webpack_require__(303);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = reportError;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function reportError() {
	  var _root;
	
	  if (true) return;
	  if (!root.motionRuntimeError) return;
	
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var err = args;
	
	  // if coming from catch
	  if ((0, _typeof3.default)(args[0]) == 'object') {
	    var lines = undefined;
	
	    if (args[0].stack) lines = args[0].stack.split("\n");
	
	    err = [args[0].message, lines && lines[1] || args[0].fileName || '', 0, 0, args[0].stack];
	  }
	
	  (_root = root).motionRuntimeError.apply(_root, (0, _toConsumableArray3.default)(err));
	}

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _from = __webpack_require__(307);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};
	
	exports.__esModule = true;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(308), __esModule: true };

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(6);
	__webpack_require__(309);
	module.exports = __webpack_require__(14).Array.from;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx         = __webpack_require__(15)
	  , $export     = __webpack_require__(12)
	  , toObject    = __webpack_require__(62)
	  , call        = __webpack_require__(43)
	  , isArrayIter = __webpack_require__(44)
	  , toLength    = __webpack_require__(45)
	  , getIterFn   = __webpack_require__(46);
	$export($export.S + $export.F * !__webpack_require__(57)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , $$      = arguments
	      , $$len   = $$.length
	      , mapfn   = $$len > 1 ? $$[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, $$len > 2 ? $$[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        result[index] = mapping ? mapfn(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 310 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.init = init;
	exports.get = get;
	//
	// Motion internals, for storing runtime related stuff
	//
	
	var internals = {};
	
	function init(name) {
	  var Internal = internals[name] = {
	    opts: window.__motionopts, // sent from runner
	    views: {},
	
	    isRendering: 0,
	    firstRender: true,
	    isDevTools: name == 'motiontools',
	
	    paths: {}, // cache hotreload paths
	    viewCache: {}, // map of views in various files
	    viewsInFile: {}, // current build up of running hot insertion
	    currentFileViews: null, // tracks views as file loads, for hot reloading
	    currentHotFile: null, // current file that is running
	    getCache: {}, // stores { path: { name: val } } for use in view.get()
	    getCacheInit: {}, // stores the vars after a view is first run
	
	    fileChanged: {},
	    changedViews: [],
	    getInitialStates: [],
	    mountedViews: {},
	    lastWorkingViews: {},
	    lastWorkingRenders: {},
	
	    // Motion.decorateView & Motion.onViewInstance
	    viewDecorator: {},
	    instanceDecorator: {},
	
	    resetViewsInFile: function resetViewsInFile(file) {
	      var views = Internal.viewsInFile[file];
	
	      if (views && views.length) {
	        views.forEach(Internal.removeView);
	      }
	    },
	    resetViewState: function resetViewState(views) {
	      Internal.views = {};
	      Internal.mountedViews = {};
	      Internal.lastWorkingViews = {};
	    },
	    removeView: function removeView(name) {
	      delete Internal.views[name];
	      delete Internal.mountedViews[name];
	      delete Internal.lastWorkingViews[name];
	    },
	    getFile: function getFile(name) {
	      return Internal.viewsInFile[name] || [];
	    },
	    isLive: function isLive() {
	      return Internal.editor && Internal.editor.live;
	    },
	    setInspector: function setInspector(path) {
	      if (Internal.inspector[path]) {
	        var props = Internal.viewsAtPath[path].props;
	        var state = Internal.getCache[path];
	        Internal.inspector[path](props, state);
	      }
	    },
	
	
	    // devtools
	    inspector: {},
	    viewsAtPath: {},
	    editor: {},
	
	    lastFileLoad: null,
	    runtimeErrors: 0,
	
	    setCache: function setCache(path, name, val) {
	      Internal.getCache[path][name] = val;
	      // when devtools inspecting
	      Internal.setInspector(path);
	    }
	  };
	
	  return Internal;
	}
	
	function get(name) {
	  return internals[name];
	}
	
	exports.default = { init: init, get: get };

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(303);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = onError;
	
	var _reportError = __webpack_require__(305);
	
	var _reportError2 = _interopRequireDefault(_reportError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Why named motion?? Because it shows in console.log a lot
	
	// fancy (someday) error handling that works with live
	// coding to be smart enough to avoid sending tons of error messages
	
	function onError(Internal, Tools) {
	  if (Internal.isDevTools) return;
	
	  var origOnError = window.onerror;
	  var sinceLastErr = Date.now();
	  var timeout = undefined;
	
	  // used to prevent tons of logs during live development
	  function onError() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    // send error to dev tools error bar
	    var motionShowError = function motionShowError() {
	      return _reportError2.default.apply(undefined, args);
	    };
	
	    Internal.runtimeErrors++; // for use in detecting if we've started up with errors
	    var isLive = Internal.editor.live;
	
	    if (isLive) {
	      var _ret = function () {
	        var now = Date.now();
	        var isFast = now - sinceLastErr < 1000;
	        sinceLastErr = now;
	
	        // hide if happening often
	        if (isFast) {
	          clearTimeout(timeout);
	          timeout = setTimeout(function () {
	            // if weve ran successfully in between this timeout, dont show err!
	            if (Internal.lastFileLoad > now) {
	              return;
	            }
	
	            motionShowError();
	
	            // DEBUGGING PERSON: open your stack trace and look @ first file to find real line #
	            // these weird logs only happen during live coding when you type quickly, to prevent
	            // *hundreds* of error logs happening.
	            console.error(args[4].stack);
	          }, 1500);
	
	          return {
	            v: true
	          };
	        }
	      }();
	
	      if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
	    } else {
	      motionShowError();
	    }
	  }
	
	  window.onerror = function () {
	    origOnError && origOnError.apply(undefined, arguments);
	    return onError.apply(undefined, arguments);
	  };
	}

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(306);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _typeof2 = __webpack_require__(303);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _assign = __webpack_require__(85);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = createComponent;
	
	var _server = __webpack_require__(313);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _reactDom = __webpack_require__(265);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _react = __webpack_require__(106);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _raf = __webpack_require__(267);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _radium = __webpack_require__(314);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _phash = __webpack_require__(315);
	
	var _phash2 = _interopRequireDefault(_phash);
	
	var _cloneError = __webpack_require__(317);
	
	var _cloneError2 = _interopRequireDefault(_cloneError);
	
	var _hotCache = __webpack_require__(321);
	
	var _hotCache2 = _interopRequireDefault(_hotCache);
	
	var _reportError = __webpack_require__(305);
	
	var _reportError2 = _interopRequireDefault(_reportError);
	
	var _createElement = __webpack_require__(323);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	var _viewOn = __webpack_require__(339);
	
	var _viewOn2 = _interopRequireDefault(_viewOn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var capitalize = function capitalize(str) {
	  return str[0].toUpperCase() + str.substring(1);
	};
	
	var pathWithoutProps = function pathWithoutProps(path) {
	  return path.replace(/\.[a-z0-9\-]+$/, '');
	};
	
	var views = {};
	var viewErrorDebouncers = {};
	
	function createComponent(Motion, Internal, name, view) {
	  var options = arguments.length <= 4 || arguments[4] === undefined ? {} : arguments[4];
	
	  var isChanged = options.changed;
	
	  // wrap decorators
	  var wrapComponent = function wrapComponent(component) {
	    if (Internal.viewDecorator[name]) component = Internal.viewDecorator[name](component);
	    if (Internal.viewDecorator.all) component = Internal.viewDecorator.all(component);
	    return component;
	  };
	
	  // production
	  if (true) return wrapComponent(createViewComponent());
	
	  // development
	  views[name] = createViewComponent();
	
	  // once rendered, isChanged is used to prevent
	  // unnecessary props hashing, for faster hot reloads
	  Motion.on('render:done', function () {
	    isChanged = false;
	  });
	
	  return wrapComponent(createProxyComponent());
	
	  // proxy components handle hot reloads
	  function createProxyComponent() {
	    return _react2.default.createClass({
	
	      displayName: name + 'Proxy',
	
	      childContextTypes: {
	        path: _react2.default.PropTypes.string,
	        displayName: _react2.default.PropTypes.string
	      },
	
	      contextTypes: {
	        path: _react2.default.PropTypes.string
	      },
	
	      getChildContext: function getChildContext() {
	        return {
	          path: this.getPath()
	        };
	      },
	      getPath: function getPath() {
	        if (!this.path) this.setPath();
	        return this.path;
	      },
	      getSep: function getSep() {
	        return name == 'Main' ? '' : ',';
	      },
	      setPathKey: function setPathKey() {
	        var motion = this.props.__motion;
	        var key = motion && motion.key || '00';
	        var index = motion && motion.index || '00';
	        var parentPath = this.context.path || '';
	        this.pathKey = '' + parentPath + this.getSep() + name + '-' + key + '/' + index;
	      },
	      setPath: function setPath() {
	        this.setPathKey();
	
	        if (!isChanged) {
	          var prevPath = Internal.paths[this.pathKey];
	          if (prevPath) {
	            this.path = prevPath;
	            return;
	          }
	        }
	
	        var propsHash = (0, _phash2.default)(this.props);
	        this.path = this.pathKey + '.' + propsHash;
	
	        // for faster retrieval hot reloading
	        Internal.paths[this.pathKey] = this.path;
	      },
	      onMount: function onMount(component) {
	        var path = this.getPath();
	        var lastRendered = component.lastRendered;
	
	        Internal.mountedViews[name] = Internal.mountedViews[name] || [];
	        Internal.mountedViews[name].push(this);
	        Internal.viewsAtPath[path] = component;
	
	        if (lastRendered) Internal.lastWorkingRenders[pathWithoutProps(path)] = lastRendered;
	
	        Internal.lastWorkingViews[name] = { component: component };
	      },
	      render: function render() {
	        var View = views[name];
	
	        var viewProps = (0, _assign2.default)({}, this.props);
	
	        viewProps.__motion = viewProps.__motion || {};
	        viewProps.__motion.onMount = this.onMount;
	        viewProps.__motion.path = this.getPath();
	
	        return _react2.default.createElement(View, viewProps);
	      }
	    });
	  }
	
	  // create view
	  function createViewComponent() {
	    var component = _react2.default.createClass({
	      displayName: name,
	      name: name,
	      Motion: Motion,
	      el: _createElement2.default,
	
	      // set() get() dec()
	      mixins: [(0, _hotCache2.default)({ Internal: Internal, options: options, name: name })],
	
	      // TODO: shouldComponentUpdate based on hot load for perf
	      shouldComponentUpdate: function shouldComponentUpdate() {
	        return !this.isPaused;
	      },
	      shouldUpdate: function shouldUpdate(fn) {
	        var _this = this;
	
	        if (this.hasShouldUpdate) {
	          (0, _reportError2.default)({ message: 'You defined shouldUpdate twice in ' + name + ', remove one!', fileName: 'view ' + name });
	          return;
	        }
	
	        this.hasShouldUpdate = true;
	
	        var motionShouldUpdate = this.shouldComponentUpdate.bind(this);
	
	        this.shouldComponentUpdate = function (nextProps) {
	          if (!motionShouldUpdate()) return false;
	          return fn(_this.props, nextProps);
	        };
	      },
	
	
	      // LIFECYCLES
	
	      getInitialState: function getInitialState() {
	        var _this2 = this;
	
	        var fprops = this.props.__motion;
	
	        Internal.getInitialStates[fprops ? fprops.path : 'Main'] = function () {
	          return _this2.getInitialState();
	        };
	
	        var u = null;
	
	        this.state = {};
	        this.propDefaults = {};
	        this.queuedUpdate = false;
	        this.firstRender = true;
	        this.styles = {};
	        this.events = { mount: u, unmount: u, change: u, props: u };
	        this.path = null;
	
	        // scope on() to view
	        this.on = (0, _viewOn2.default)(this);
	
	        // cache Motion view render() (defined below)
	        var motionRender = this.render;
	
	        this.renders = [];
	
	        // setter to capture view render
	        this.render = function (renderFn) {
	          _this2.renders.push(renderFn);
	        };
	
	        if (true) view.call(this, this, this.on, this.styles);else {
	          try {
	            view.call(this, this, this.on, this.styles);
	            this.recoveryRender = false;
	          } catch (e) {
	            Internal.caughtRuntimeErrors++;
	            (0, _reportError2.default)(e);
	            console.error(e.stack || e);
	            this.recoveryRender = true;
	          }
	        }
	
	        // reset original render
	        this.render = motionRender;
	
	        // Motion._onViewInstance
	        if (Internal.instanceDecorator[name]) Internal.instanceDecorator[name](this);
	        if (Internal.instanceDecorator.all) Internal.instanceDecorator.all(this);
	
	        return null;
	      },
	      runEvents: function runEvents(name, args) {
	        var _this3 = this;
	
	        var queue = this.events;
	
	        if (queue[name] && queue[name].length) {
	          queue[name].forEach(function (event) {
	            event.apply(_this3, args);
	          });
	        }
	      },
	      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        // set timeout becuase otherwise props is mutated before shouldUpdate is run
	        // setTimeout(() => {
	
	        // main doesnt get props
	        if (name != 'Main') {
	          this.props = nextProps;
	          this.runEvents('props', [this.props]);
	        }
	
	        if (false) {
	          var path = nextProps.__motion.path;
	          var fn = Internal.inspector[path];
	          var state = _Motion.getCache[nextProps.__motion.path];
	          // send to inspector if inspecting
	          fn && fn(nextProps, state);
	        }
	
	        // })
	      },
	      componentWillMount: function componentWillMount() {
	        // run props before mount
	        if (name != 'Main') {
	          this.runEvents('props', [this.props]);
	        } else {
	          // moved to here to fix issues where updating during first mount fails
	          //    see: https://github.com/motionjs/motion/issues/305
	          Internal.firstRender = false;
	        }
	      },
	      componentDidMount: function componentDidMount() {
	        this.isRendering = false;
	        this.mounted = true;
	
	        this.runEvents('mount');
	
	        if (this.queuedUpdate) {
	          this.queuedUpdate = false;
	          this.update();
	        }
	
	        if (false) {
	          this.props.__motion.onMount(this);
	          this.setID();
	        }
	
	        if (this.doRenderToRoot) {
	          this.handleRootRender();
	        }
	      },
	      componentWillUnmount: function componentWillUnmount() {
	        this.runEvents('unmount');
	        this.mounted = false;
	
	        // fixes unmount errors github.com/motionjs/motion/issues/60
	        if (false) this.render();
	
	        if (this.doRenderToRoot) {
	          _reactDom2.default.unmountComponentAtNode(this.node);
	          this.app.removeChild(this.node);
	        }
	      },
	      componentWillUpdate: function componentWillUpdate() {
	        this.runEvents('change');
	      },
	      setID: function setID() {
	        if (Internal.isDevTools) return;
	
	        // set motionID for state inspect
	        var node = _reactDom2.default.findDOMNode(this);
	        if (node) node.__motionID = this.props.__motion.path;
	      },
	      componentDidUpdate: function componentDidUpdate() {
	        this.isRendering = false;
	
	        if (this.queuedUpdate) {
	          this.queuedUpdate = false;
	          this.update();
	        }
	
	        if (false) {
	          this.setID();
	        }
	
	        if (this.doRenderToRoot) {
	          this.handleRootRender();
	        }
	      },
	
	
	      // MOTION HELPERS
	      // view.element('foo') -> <foo>
	      element: function element(selector) {
	        var viewNode = _reactDom2.default.findDOMNode(this);
	
	        // Returns itself if a selector is not specified
	        if (!selector) return viewNode;
	        return viewNode.querySelector(selector);
	      },
	      elements: function elements(selector) {
	        var els = _reactDom2.default.findDOMNode(this).querySelectorAll(selector);
	        return Array.prototype.slice.call(els, 0);
	      },
	
	
	      // property declarators
	      getProp: function getProp(name) {
	        return typeof this.props[name] === 'undefined' ? this.propDefaults[name] : this.props[name];
	      },
	      prop: function prop(name, defaultValue) {
	        this.propDefaults[name] = defaultValue;
	        return this.getProp(name);
	      },
	      clone: function clone(el, props) {
	        // TODO better checks and warnings, ie if they dont pass in element just props
	        if (!el) return el;
	        if ((typeof el === 'undefined' ? 'undefined' : (0, _typeof3.default)(el)) !== 'object') throw new Error('You\'re attempting to clone something that isn\'t a tag! In view ' + this.name + '. Attempted to clone: ' + el);
	
	        // move the parent styles source to the cloned view
	        if (el.props && el.props.__motion) {
	          var fprops = el.props.__motion;
	
	          fprops.parentName = this.name;
	          fprops.parentStyles = this.styles;
	        }
	
	        // ok so there was a bug with cloning a view that removes all the view root nodes classes
	        // this works around it
	        // TODO this should only be done when dealing with motion views, avoid this for tags
	        if (props.class || props.className) {
	          props.__motionAddClass = props.class || props.className;
	          delete props.class;
	          delete props.className;
	        }
	
	        return _react2.default.cloneElement(el, props);
	      },
	      mapElements: function mapElements(children, cb) {
	        return _react2.default.Children.map(children, cb);
	      },
	      getName: function getName(child) {
	        var name = child.props && child.props.__motion && child.props.__motion.tagName;
	
	        // TODO does this always work, what about with react components
	        return name;
	      },
	
	
	      // helpers for controlling re-renders
	      pause: function pause() {
	        this.isPaused = true;
	      },
	      resume: function resume() {
	        this.isPaused = false;
	      },
	
	
	      // for looping while waiting
	      delayUpdate: function delayUpdate() {
	        if (this.queuedUpdate) return;
	        this.queuedUpdate = true;
	        this.update();
	      },
	      updateSoft: function updateSoft() {
	        this.update(true);
	      },
	
	
	      // view.set()
	      update: function update(soft) {
	        // view.set respects paused
	        if (soft && this.isPaused) return;
	
	        // if during a render, wait
	        if (!this.mounted || Internal.firstRender) {
	          this.queuedUpdate = true;
	          return;
	        }
	
	        // during render, dont update
	        if (this.isRendering) return;
	
	        // tools run into weird bug where if error in app on initial render, react gets
	        // mad that you are trying to re-render tools during app render TODO: strip in prod
	        // check for isRendering so it shows if fails to render
	        if (false) return setTimeout(this.update);
	
	        this.queuedUpdate = false;
	
	        // rather than setState because we want to skip shouldUpdate calls
	        this.forceUpdate();
	      },
	
	
	      // childContextTypes: {
	      //   motionContext: React.PropTypes.object
	      // },
	      //
	      // contextTypes: {
	      //   motionContext: React.PropTypes.object
	      // },
	      //
	      // getChildContext() {
	      //   console.log(name, 'get', this)
	      //   return { motionContext: this._context || null }
	      // },
	      //
	      // // helpers for context
	      // setContext(obj) {
	      //   if (typeof obj != 'object')
	      //     throw new Error('Must pass an object to childContext!')
	      //
	      //   console.log(this, name, 'set', obj)
	      //   this.state = { _context: obj }
	      // },
	
	      // render to a "portal"
	      renderToRoot: function renderToRoot() {
	        this.doRenderToRoot = true;
	
	        this.app = document.body;
	        this.node = document.createElement('div');
	        this.node.setAttribute('data-portal', 'true');
	        this.app.appendChild(this.node);
	      },
	      inlineStyles: function inlineStyles() {
	        this.doRenderInlineStyles = true;
	      },
	      handleRootRender: function handleRootRender() {
	        _reactDom2.default.render(this.renderResult, this.node);
	      },
	      getWrapper: function getWrapper(tags, props, numRenders) {
	        var wrapperName = name.toLowerCase();
	
	        var tagProps = (0, _assign2.default)({ __motionIsWrapper: true }, props);
	
	        return this.el.apply(this, ['view.' + name, tagProps].concat((0, _toConsumableArray3.default)(tags)));
	      },
	      getRender: function getRender() {
	        var _this4 = this;
	
	        if (this.recoveryRender) return this.getLastGoodRender();
	
	        var tags = undefined,
	            props = undefined;
	        var addWrapper = true;
	        var numRenders = this.renders && this.renders.length;
	
	        // no root elements
	        if (!numRenders) {
	          tags = [];
	          props = { yield: true };
	        }
	        // one root element
	        else if (numRenders == 1) {
	            tags = this.renders[0].call(this);
	            var hasMultipleTags = Array.isArray(tags);
	            addWrapper = hasMultipleTags || !tags.props;
	
	            if (!hasMultipleTags && tags.props && !tags.props.root) {
	              // if tag name == view name
	              if (tags.props.__motion && tags.props.__motion.tagName != name.toLowerCase()) {
	                addWrapper = true;
	                tags = [tags];
	              }
	            }
	          }
	          // multiple root elements
	          else if (numRenders > 1) {
	              tags = this.renders.map(function (r) {
	                return r.call(_this4);
	              });
	            }
	
	        var wrappedTags = addWrapper ? this.getWrapper(tags, props, numRenders) : tags;
	
	        var cleanName = name.replace('.', '-');
	        var viewClassName = 'View' + cleanName;
	        var parentClassName = wrappedTags.props.className;
	        var withParentClass = parentClassName ? viewClassName + ' ' + parentClassName : viewClassName;
	
	        // view.clone (see above) avoids mutating classname until here
	        // fixes bug: if view.clone(Child, { className: xyz }), would overwrite classes in Child
	        var clonedClass = undefined;
	        if (wrappedTags.props.__motionAddClass) {
	          clonedClass = withParentClass + ' ' + wrappedTags.props.__motionAddClass;
	        }
	
	        var className = clonedClass || withParentClass;
	        var withClass = _react2.default.cloneElement(wrappedTags, { className: className });
	        return withClass;
	      },
	      getLastGoodRender: function getLastGoodRender() {
	        return Internal.lastWorkingRenders[pathWithoutProps(this.props.__motion.path)];
	      },
	
	
	      // TODO once this works better in 0.15
	      unstable_handleError: function unstable_handleError(e) {
	        console.log('ERR', e);
	        (0, _reportError2.default)(e);
	      },
	      _render: function _render() {
	        var self = this;
	
	        self.isRendering = true;
	        self.firstRender = false;
	
	        if (true) return self.getRender();else {
	          clearTimeout(viewErrorDebouncers[self.props.__motion.path]);
	        }
	
	        // try render
	        try {
	          var els = self.getRender();
	          self.lastRendered = els;
	          return els;
	        } catch (e) {
	          var _ret = function () {
	            Internal.caughtRuntimeErrors++;
	
	            var err = (0, _cloneError2.default)(e);
	            var errorDelay = Internal.isLive() ? 1000 : 200;
	
	            // console warn, with debounce
	            viewErrorDebouncers[self.props.__motion.path] = setTimeout(function () {
	              console.groupCollapsed('Render error in view ' + name + ' (' + err.message + ')');
	              console.error(err.stack || err);
	              console.groupEnd();
	
	              // if not in debouncer it shows even after fixing
	              (0, _reportError2.default)(e);
	            }, errorDelay);
	
	            var lastRender = self.getLastGoodRender();
	
	            try {
	              var inner = _react2.default.createElement(
	                'span',
	                null,
	                'Error in view ',
	                name
	              );
	
	              if (Internal.isDevTools) return {
	                  v: inner
	                };
	
	              if (lastRender) {
	                var __html = _server2.default.renderToString(lastRender);
	                __html = __html.replace(/\s*data\-react[a-z-]*\=\"[^"]*\"/g, '');
	                inner = _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: __html } });
	              }
	
	              // highlight in red and return last working render
	              return {
	                v: _react2.default.createElement(
	                  'span',
	                  { style: { display: 'block', position: 'relative' } },
	                  _react2.default.createElement('span', { className: '__motionError' }),
	                  inner
	                )
	              };
	            } catch (e) {
	              console.log("Error rendering last version of view after error");
	            }
	          }();
	
	          if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
	        }
	      },
	      render: function render() {
	        var result = this._render.call(this);
	
	        if (this.doRenderToRoot) {
	          this.renderResult = result;
	          return _react2.default.createElement('noscript', null);
	        } else {
	          return result;
	        }
	      }
	    });
	
	    return (0, _radium2.default)(component);
	  }
	}

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(256);


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ConfiguredRadium;
	
	var _motionRadium = __webpack_require__(269);
	
	var _motionRadium2 = _interopRequireDefault(_motionRadium);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ConfiguredRadium(component) {
	  return (0, _motionRadium2.default)({
	    plugins: [_motionRadium2.default.Plugins.resolveMediaQueries, _motionRadium2.default.Plugins.resolveInteractionStyles, _motionRadium2.default.Plugins.prefix]
	  })(component);
	}

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(59);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = phash;
	
	var _react = __webpack_require__(106);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hashSum = __webpack_require__(105);
	
	var _hashSum2 = _interopRequireDefault(_hashSum);
	
	var _opts = __webpack_require__(316);
	
	var _opts2 = _interopRequireDefault(_opts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function phash(_props) {
	  if ((0, _opts2.default)() && (0, _opts2.default)().config.disablePropsHashing) return '' + Math.random();
	
	  var hash = (0, _keys2.default)(_props).reduce(function (acc, key) {
	    var prop = _props[key];
	
	    if (key == '__motion') return acc + prop.key;
	    if (prop instanceof Object && prop.hashCode) return acc + prop.hashCode();
	    if (_react2.default.isValidElement(prop)) return acc + prop.key;
	
	    return acc + (0, _hashSum2.default)(prop);
	  }, '');
	
	  return hash;
	}

/***/ },
/* 316 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return window._Motion.opts;
	};

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getOwnPropertyNames = __webpack_require__(318);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	exports.default = cloneError;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function cloneError(e) {
	  var result = {};
	  var keys = (0, _getOwnPropertyNames2.default)(e);
	  keys.forEach(function (k) {
	    return result[k] = e[k];
	  });
	  return result;
	}

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(319), __esModule: true };

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(19);
	__webpack_require__(320);
	module.exports = function getOwnPropertyNames(it){
	  return $.getNames(it);
	};

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(63)('getOwnPropertyNames', function(){
	  return __webpack_require__(95).get;
	});

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(303);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = hotCache;
	
	var _deepEqual = __webpack_require__(287);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _clone = __webpack_require__(322);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hotCache(_ref) {
	  var Internal = _ref.Internal;
	  var options = _ref.options;
	  var name = _ref.name;
	
	  return {
	    // on assign, result = val after mutation, use that instead of val
	
	    set: function set(name, val, result, useResult) {
	      if (true) return val;
	
	      var path = this.props.__motion.path;
	      Internal.getCache[path] = Internal.getCache[path] || {};
	      Internal.setCache(path, name, useResult ? result : val);
	      return val;
	    },
	
	
	    // on declaration
	    dec: function dec(name, val, where) {
	      this.state[name] = val;
	      return this.get(name, val, where);
	    },
	
	
	    // on access
	    get: function get(name, val, where) {
	      if (true) return val;
	
	      var path = this.props.__motion.path;
	
	      // Inspector setting new state, prevent infinite loop
	      if (_Motion.inspectorRefreshing === path) return Internal.getCache[path][name];
	
	      // file scoped stuff always updates
	      if (options.unchanged && where == 'fromFile') return val;
	
	      var result = undefined;
	
	      // setup caches
	      if (!Internal.getCache[path]) Internal.getCache[path] = {};
	      if (!Internal.getCacheInit[path]) Internal.getCacheInit[path] = {};
	
	      var isComparable = typeof val == 'number' || typeof val == 'string' || typeof val == 'boolean' || typeof val == 'undefined' || val === null;
	
	      var checkDeep = true;
	      var cacheVal = Internal.getCache[path][name];
	      var cacheInitVal = Internal.getCacheInit[path][name];
	
	      var originalValue = undefined,
	          restore = undefined;
	
	      function onEq() {
	        restore = true;
	        originalValue = Internal.getCache[path][name];
	      }
	
	      // if edited
	      if (options.changed) {
	        // initial value not undefined
	        if (typeof cacheInitVal != 'undefined') {
	          // only hot update changed variables
	          if (isComparable) {
	            if (cacheInitVal === val) onEq();
	          } else {
	            if ((typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)) == 'object' && checkDeep && (0, _deepEqual2.default)(cacheInitVal, val)) onEq();
	          }
	        }
	
	        Internal.getCacheInit[path][name] = (0, _clone2.default)(val);
	      }
	
	      // set changed cache val
	      if (options.changed && typeof cacheVal == 'undefined') Internal.setCache(path, name, val);
	
	      // return cached
	      if (isComparable) if (options.unchanged && cacheVal !== cacheInitVal) result = cacheVal;
	
	      if (!result) result = restore ? originalValue : val;
	
	      return result;
	    }
	  };
	}

/***/ },
/* 322 */
/***/ function(module, exports) {

	var clone = (function() {
	'use strict';
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	*/
	function clone(parent, circular, depth, prototype) {
	  var filter;
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    filter = circular.filter;
	    circular = circular.circular
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth == 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      child = new Buffer(parent.length);
	      parent.copy(child);
	      return child;
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	};
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	};
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	};
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	};
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	};
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(306);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = createElement;
	
	var _react = __webpack_require__(106);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getElement = __webpack_require__(324);
	
	var _getElement2 = _interopRequireDefault(_getElement);
	
	var _styles = __webpack_require__(333);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	var _props2 = __webpack_require__(336);
	
	var _props3 = _interopRequireDefault(_props2);
	
	var _stringifyObjects = __webpack_require__(338);
	
	var _stringifyObjects2 = _interopRequireDefault(_stringifyObjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	
	  Shim around React.createElement, that adds in our:
	
	     - tag helpers (sync, yield, repeat, if, ...)
	     - styling (radium, css classes, ...)
	     - object to string
	
	*/
	
	var DIV = 'div';
	
	function createElement(identifier, _props) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  // TODO remove or document
	  if (_props && _props.__skipMotion) return _react2.default.createElement.apply(_react2.default, [identifier[1], _props].concat((0, _toConsumableArray3.default)(args)));
	
	  var view = this;
	  var Motion = view.Motion;
	
	  var el = (0, _getElement2.default)(identifier, view, _props, Motion.getView);
	  var props = (0, _props3.default)(el, view, Motion, _props);
	  props.style = (0, _styles2.default)(el, view, props);
	
	  // TODO option to disable object stringifying
	  if (false) args = (0, _stringifyObjects2.default)(el, args, view);
	
	  var tag = props.tagName || (el.whitelisted ? DIV : el.component || el.name);
	
	  return _react2.default.createElement.apply(_react2.default, [tag, props].concat((0, _toConsumableArray3.default)(args)));
	}

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(325);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	exports.default = getElement;
	
	var _constants = __webpack_require__(332);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	
	  Handles a variety of cases from:
	      'ViewName'
	      'tagname'
	      variable
	
	*/
	
	function getElement(identifier, view, props, getView) {
	  var isView = false;
	  var name = undefined,
	      tagName = undefined,
	      key = undefined,
	      index = undefined,
	      component = undefined,
	      repeatItem = undefined;
	
	  // used directly by user
	  if (typeof identifier == 'string') {
	    name = identifier;
	  }
	  // passing in a variable as the view
	  else if (typeof identifier[0] !== 'string') {
	      var _identifier = (0, _slicedToArray3.default)(identifier, 5);
	
	      component = _identifier[0];
	      name = _identifier[1];
	      key = _identifier[2];
	      repeatItem = _identifier[3];
	      index = _identifier[4];
	    }
	    // passing in string ref as view
	    else {
	        var _identifier2 = (0, _slicedToArray3.default)(identifier, 4);
	
	        name = _identifier2[0];
	        key = _identifier2[1];
	        repeatItem = _identifier2[2];
	        index = _identifier2[3];
	      }
	
	  if (!name) return React.createElement('div', null, 'No name given!');
	
	  var whitelisted = undefined;
	
	  // find element
	  if (typeof name != 'string') {
	    component = name;
	  } else {
	    var isHTMLElement = name[0].toLowerCase() == name[0];
	
	    if (isHTMLElement) {
	      tagName =
	      // yield isnt merged in at this point so we check for it
	      view.props && view.props.yield && view.props.tagName
	      // otherwise use prop tagname
	       || props && props.tagName;
	
	      // whitelist
	      whitelisted = _constants.whitelist.indexOf(name) >= 0;
	    }
	    // find a view
	    else if (!component) {
	        isView = true;
	        component = getView(name);
	      }
	  }
	
	  return {
	    name: name,
	    tagName: tagName,
	    key: key,
	    index: index,
	    repeatItem: repeatItem,
	    component: component,
	    whitelisted: whitelisted,
	    isView: isView
	  };
	}

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _isIterable2 = __webpack_require__(326);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(329);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	})();
	
	exports.__esModule = true;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(327), __esModule: true };

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(30);
	__webpack_require__(6);
	module.exports = __webpack_require__(328);

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(38)
	  , ITERATOR  = __webpack_require__(27)('iterator')
	  , Iterators = __webpack_require__(24);
	module.exports = __webpack_require__(14).isIterable = function(it){
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    || Iterators.hasOwnProperty(classof(O));
	};

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(330), __esModule: true };

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(30);
	__webpack_require__(6);
	module.exports = __webpack_require__(331);

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(40)
	  , get      = __webpack_require__(46);
	module.exports = __webpack_require__(14).getIterator = function(it){
	  var iterFn = get(it);
	  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};

/***/ },
/* 332 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// tags that shouldn't map out to real names
	var whitelist = exports.whitelist = ['title', 'meta', 'head', 'circle', 'col', 'body'];
	
	var niceAttrs = exports.niceAttrs = {
	  class: 'className',
	  for: 'htmlFor',
	  srcset: 'srcSet',
	  novalidate: 'noValidate',
	  autoplay: 'autoPlay',
	  frameborder: 'frameBorder',
	  allowfullscreen: 'allowFullScreen',
	  tabindex: 'tabIndex'
	};
	
	exports.default = {
	  whitelist: whitelist,
	  niceAttrs: niceAttrs
	};

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(59);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(85);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _typeof2 = __webpack_require__(303);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = elementStyles;
	
	var _reportError = __webpack_require__(305);
	
	var _reportError2 = _interopRequireDefault(_reportError);
	
	var _motionNiceStyles = __webpack_require__(334);
	
	var _motionNiceStyles2 = _interopRequireDefault(_motionNiceStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isLowerCase = function isLowerCase(s) {
	  return s.toLowerCase() == s;
	};
	
	var mergeStyles = function mergeStyles(obj) {
	  for (var _len = arguments.length, styles = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    styles[_key - 1] = arguments[_key];
	  }
	
	  return styles.reduce(function (acc, style) {
	    if (style && style.constructor === Array) for (var i = 0; i < style.length; i++) {
	      acc = mergeStyles(acc, style[i]);
	    } else if ((typeof style === 'undefined' ? 'undefined' : (0, _typeof3.default)(style)) === 'object' && style !== null) {
	      if (!acc) acc = {};
	      (0, _assign2.default)(acc, style);
	    }
	
	    return acc;
	  }, obj);
	};
	
	var prefix = '$';
	
	// TODO remove <name-tag />
	// originalTag || tag
	// key, index, repeatItem, name, tag
	function elementStyles(el, view, props) {
	  if (typeof el.name !== 'string') return;
	
	  var styles = undefined,
	      parentStyles = undefined,
	      parentStylesStatic = undefined,
	      parentStylesStaticView = undefined,
	      parentStylesRoot = undefined;
	
	  // attach view styles from $ to element matching view name lowercase
	  var tag = el.name;
	  var Motion = view.Motion;
	  var isRootName = view.name && view.name.toLowerCase() == el.name;
	  var hasOneRender = view.renders.length <= 1;
	  var isWrapperOrRoot = props && (props.__motionIsWrapper || props.root);
	  var deservesRootStyles = !!(isRootName && hasOneRender || isWrapperOrRoot);
	
	  function addClassName(name) {
	    props.className = props.className ? props.className + ' ' + name : name;
	  }
	
	  if (deservesRootStyles) {
	    if (view.props.__motion) {
	      var parentName = view.props.__motion.parentName;
	      parentStyles = view.props.__motion.parentStyles;
	      parentStylesStatic = Motion.styleObjects[parentName];
	      parentStylesStaticView = parentStylesStatic && parentStylesStatic['$' + view.name];
	
	      var parentRoot = Motion.viewRoots[parentName];
	
	      // parent $={} styles pass to child
	      //    view Main { <Child root />  $ = { background: 'red' }  }   <-- makes these styles work!
	      //    view Child { <child /> $ = { background: 'yellow' } }
	      if (parentRoot === view.name) {
	        parentStylesRoot = parentStylesStatic && parentStylesStatic.$;
	      }
	    }
	
	    // TODO: shouldnt be in styles
	    var viewClassName = view.props.className || view.props.class;
	    if (viewClassName) addClassName(viewClassName);
	  }
	
	  if (view.styles || parentStylesStatic || parentStylesStaticView) {
	    // if <foobar> is root, then apply both the base ($) and ($foobar)
	    var diffName = el.name !== tag;
	    var hasTag = typeof tag == 'string';
	    var tagStyle = hasTag && view.styles[tag] && view.styles[tag](el.repeatItem, el.index);
	
	    var classes = Motion.styleClasses[view.name];
	    var viewStyle = view.styles[prefix] && view.styles[prefix](el.index);
	    var nameStyle = diffName && view.styles[el.name] && view.styles[el.name](el.repeatItem, el.index);
	
	    // merge styles
	
	    var result = mergeStyles({},
	    // tag style
	    tagStyle,
	    // name dynamic styles
	    nameStyle,
	    // base style
	    deservesRootStyles && viewStyle,
	    // passed down styles
	    parentStyles && parentStyles['' + prefix + view.name],
	    // passed down styles using $
	    parentStylesRoot);
	
	    // for use in className loop
	    var viewStaticStyles = Motion.styleObjects[view.name];
	
	    if (view.doRenderToRoot || view.doRenderInlineStyles) {
	      result = mergeStyles(result, diffName && viewStaticStyles && viewStaticStyles['' + prefix + el.name], hasTag && viewStaticStyles && viewStaticStyles['' + prefix + tag], deservesRootStyles && viewStaticStyles && viewStaticStyles[prefix]);
	    }
	
	    // add class styles
	    if (props.className) {
	      var _classes = props.className.split(' ');
	
	      for (var i = 0; i < _classes.length; i++) {
	        var className = _classes[i];
	
	        if (isLowerCase(className[0])) {
	
	          if (view.styles[className]) {
	            result = mergeStyles(result, view.styles[className](el.repeatItem, el.index));
	          }
	
	          // ensure static class styles overwrite dynamic tag/name styles
	          if (viewStaticStyles) {
	            var staticClassStyles = viewStaticStyles['' + prefix + className];
	            if (staticClassStyles) {
	              var _styles = (0, _keys2.default)(staticClassStyles);
	
	              for (var j = 0; j < _styles.length; j++) {
	                var styleKey = _styles[j];
	                // check if already in styles, and rewrite to class style
	                if (typeof result[styleKey] != 'undefined') {
	                  result[styleKey] = staticClassStyles[styleKey];
	                }
	              }
	            }
	          }
	        }
	      }
	    }
	
	    // parent class styles
	    if (deservesRootStyles) {
	      var viewClassName = view.props.className || view.props.class || view.props.__motionAddClass;
	
	      if (viewClassName) {
	        var _classes2 = viewClassName.split(' ');
	
	        for (var i = 0; i < _classes2.length; i++) {
	          var className = _classes2[i];
	          if (!isLowerCase(className[0])) continue;
	          var classKey = '' + prefix + className;
	
	          // merge in styles
	          result = mergeStyles(result, parentStyles && parentStyles[className] && parentStyles[className](el.repeatItem, el.index), parentStylesStatic && parentStylesStatic[classKey]);
	        }
	      }
	    }
	
	    // merge styles [] into {}
	    if (Array.isArray(result)) result = mergeStyles({}, result);
	
	    // add view external props.style
	    if (deservesRootStyles && view.props.style) result = mergeStyles(result, view.props.style);
	
	    // add style="" prop styles
	    if (props.style) result = mergeStyles(result, props.style);
	
	    // put styles back into props.style
	    if (result) styles = result;
	  }
	
	  // HELPERS
	  (0, _motionNiceStyles2.default)(styles);
	
	  // overwrite any parent styles onto root
	  if (parentStylesStaticView) {
	    (function () {
	      var pssv = _motionNiceStyles2.default.object(parentStylesStaticView);
	
	      (0, _keys2.default)(pssv).forEach(function (key) {
	        // TODO! Get rid of forEach
	        styles[key] = pssv[key];
	      });
	    })();
	  }
	
	  // set body bg to Main view bg
	  if (view.name == 'Main' && el.name == 'view.Main' && typeof document != 'undefined') {
	    var body = document.body;
	    var bg = props.style && (props.style.background || props.style.backgroundColor);
	
	    if (!bg) body.style.background = null;
	
	    if (bg && body) {
	      body.style.background = bg;
	    }
	  }
	
	  if ((0, _keys2.default)(styles).length) return styles;else return null;
	}

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports['default'] = styleValuesToString;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _objectToColor = __webpack_require__(335);
	
	var _objectToColor2 = _interopRequireDefault(_objectToColor);
	
	var isNumerical = function isNumerical(obj, key) {
	  return ['x', 'y', 'z'].indexOf(key) >= 0 && typeof obj[key] == 'number';
	};
	
	var pseudoAbbrs = {
	  active: ':active',
	  hover: ':hover',
	  focus: ':focus',
	  link: ':link',
	  visited: ':visited',
	  checked: ':checked',
	  disabled: ':disabled',
	  empty: ':empty',
	  invalid: ':invalid'
	};
	
	var pseudos = {
	  ':active': true,
	  ':hover': true,
	  ':focus': true,
	  ':link': true,
	  ':visited': true,
	  ':checked': true,
	  ':disabled': true,
	  ':empty': true,
	  ':invalid': true
	};
	
	var transformKeysMap = {
	  x: 'translateX',
	  y: 'translateY',
	  z: 'translateZ'
	};
	
	var arrayToString = function arrayToString(val) {
	  return val.map(function (style) {
	    return typeof style == 'number' ? style + 'px' : style;
	  }).join(' ');
	};
	
	// transformers
	
	function transformColor(styles, attr) {
	  return typeof styles[attr] == 'object' ? _objectToColor2['default'](styles[attr]) : styles[attr];
	}
	
	function transformKey(styles, key) {
	  // convert pseudoAbbrs 'active' => ':active'
	  if (pseudoAbbrs[key] && typeof styles[key] == 'object') {
	    styles[pseudoAbbrs[key]] = styles[key];
	    // normalize to :active
	    key = pseudoAbbrs[key];
	  }
	
	  // when live coding we type "rc" then "rc()", but "rc" is a function and it breaks, so clear it
	  if (typeof styles[key] == 'function') {
	    styles[key] = null;
	    throw new Error('Passed a function to a style property ' + key);
	  }
	
	  // recurse into psuedos
	  if (pseudos[key]) {
	    styleValuesToString(styles[key]);
	  }
	
	  // array to string transforms
	  // @media queries
	  if (key[0] == '@') Object.keys(styles[key]).forEach(function (subKey) {
	    // TODO: make this recursive and use transformKey itself
	    if (Array.isArray(styles[key][subKey])) styles[key][subKey] = arrayToString(styles[key][subKey]);
	  });
	  // regular
	  else if (Array.isArray(styles[key])) styles[key] = arrayToString(styles[key]);
	}
	
	// { transform: { x: 10, y: 10, z: 10 } }
	function transformTransform(styles) {
	  if (typeof styles.transform !== 'object') return styles.transform;
	
	  return Object.keys(styles.transform).map(function (key) {
	    return (transformKeysMap[key] || key) + '(' + styles.transform[key] + (isNumerical(styles.transform, key) ? 'px' : '') + ')';
	  }).join(' ');
	}
	
	// mutative :(
	
	function styleValuesToString(styles) {
	  if (!styles) return styles;
	
	  if (styles.background) styles.background = transformColor(styles, 'background');
	
	  if (styles.backgroundColor) styles.backgroundColor = transformColor(styles, 'backgroundColor');
	
	  if (styles.color) styles.color = transformColor(styles, 'color');
	
	  if (styles.borderColor) styles.borderColor = transformColor(styles, 'borderColor');
	
	  if (styles.transform) styles.transform = transformTransform(styles);
	
	  // final styles
	  Object.keys(styles).forEach(function (key) {
	    return transformKey(styles, key);
	  });
	}
	
	styleValuesToString.object = function (styles) {
	  styleValuesToString(styles);
	  return styles;
	};
	module.exports = exports['default'];

/***/ },
/* 335 */
/***/ function(module, exports) {

	exports.__esModule = true;
	exports["default"] = objectToColor;
	
	function objectToColor(obj) {
	  if (Array.isArray(obj)) {
	    if (obj.length == 4) return "rgba(" + obj[0] + ", " + obj[1] + ", " + obj[2] + ", " + obj[3] + ")";else return "rgb(" + obj[0] + ", " + obj[1] + ", " + obj[2] + ")";
	  } else {
	    if (obj.a) return "rgba(" + obj.r + ", " + obj.g + ", " + obj.b + ", " + obj.a + ")";else return "rgb(" + obj.r + ", " + obj.g + ", " + obj.b + ")";
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(85);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(59);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = elementProps;
	
	var _classnames = __webpack_require__(337);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reportError = __webpack_require__(305);
	
	var _reportError2 = _interopRequireDefault(_reportError);
	
	var _constants = __webpack_require__(332);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClassName(props, name) {
	  return props.className ? props.className + ' ' + name : name;
	}
	
	function niceProps(props) {
	  (0, _keys2.default)(props).forEach(function (key) {
	    if (_constants.niceAttrs[key]) {
	      props[_constants.niceAttrs[key]] = props[key];
	      delete props[key];
	    }
	  });
	  return props;
	}
	
	function elementProps(_ref, view, Motion, props) {
	  var name = _ref.name;
	  var whitelisted = _ref.whitelisted;
	  var key = _ref.key;
	  var index = _ref.index;
	  var isView = _ref.isView;
	
	  if (props) {
	    props = niceProps(props);
	  }
	
	  if (props && props.className) {
	    props.className = (0, _classnames2.default)(props.className);
	  }
	
	  props = props || {};
	
	  if (!props.key && !props.nokey) {
	    props.key = name + key;
	    if (index) props.key += index;
	  }
	
	  if (props.onEnter) {
	    (function () {
	      var originalKeyDown = props.onKeyDown;
	
	      props.onKeyDown = function (e) {
	        if (e.keyCode === 13) props.onEnter(e.target.value);
	        originalKeyDown && originalKeyDown(e);
	      };
	    })();
	  }
	
	  if (props.yield) {
	    props = (0, _assign2.default)(props, view.props,
	    // take parent style
	    props.style && { style: props.style },
	    // merge parent classname
	    props.className && { className: (0, _classnames2.default)(props.className, view.props.className) });
	  }
	
	  if (props.onClick) {
	    (function () {
	      var originalOnClick = props.onClick;
	
	      props.onClick = function () {
	        if (_Motion.isInspecting) return false;
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return originalOnClick.call.apply(originalOnClick, [this].concat(args));
	      };
	    })();
	  }
	
	  // sync
	  if (props.__motionOnChange) {
	    (function () {
	      var userOnChange = props.onChange;
	      var type = props.type;
	      var attr = !type && name == 'input' || type == 'input' || type == 'text' || name == 'textarea' || type == 'search' ? 'value' : type == 'checkbox' || type == 'radio' ? 'checked' : false;
	
	      if (!attr) {
	        (0, _reportError2.default)({ message: 'sync attribute not supported on this input type yet', fileName: view.name + ', <' + name + '>' });
	      }
	
	      props.onChange = function (e) {
	        if (userOnChange) userOnChange.call(this, e);
	        props.__motionOnChange(e.target[attr]);
	      };
	
	      if (typeof props.__motionValue != 'undefined') {
	        props[attr] = props.__motionValue;
	      }
	    })();
	  }
	
	  // if not external component
	  if (isView || typeof component != 'function') {
	    props.__motion = {
	      parentStyles: view.styles,
	      parentStylesStatic: Motion.styleObjects[view.name],
	      parentName: view.name,
	      key: key,
	      index: index,
	      tagName: name
	    };
	
	    // only for tags
	    if (name[0] == name[0].toLowerCase()) {
	      props.className = addClassName(props, view.name.replace('.', '-'));
	    }
	  }
	
	  // ensure styles for whitelisted
	  if (whitelisted) {
	    props.className = addClassName(props, name);
	  }
	
	  if (name == 'svg') {
	    // for react 0.15
	    props.class = props.className;
	    delete props.className;
	  }
	
	  return props;
	}

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(65);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(303);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = function (el, args, view) {
	  return args.map(function (arg) {
	    var type = typeof arg === 'undefined' ? 'undefined' : (0, _typeof3.default)(arg);
	
	    if (arg && type != 'string' && !Array.isArray(arg) && !_react2.default.isValidElement(arg)) {
	      var isObj = String(arg) === '[object Object]';
	
	      if (isObj) {
	        // stringify for error
	        var str = '';
	        try {
	          str = (0, _stringify2.default)(arg);
	        } catch (e) {}
	
	        (0, _reportError2.default)({
	          message: 'You passed an object to ' + view.name + ' <' + el.name + '>. In production this will error! Object: ' + str,
	          fileName: _Motion.views[view.name] && _Motion.views[view.name].file
	        });
	
	        return str || '{}';
	      }
	    }
	
	    return arg;
	  });
	};
	
	var _react = __webpack_require__(106);

	var _react2 = _interopRequireDefault(_react);

	var _reportError = __webpack_require__(305);

	var _reportError2 = _interopRequireDefault(_reportError);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 339 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = viewOn;
	function viewOn(parentScope) {
	  var _on = new On(parentScope);
	  return _on;
	}

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _iterator = __webpack_require__(341);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(91);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof2 = __webpack_require__(303);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.default = function (val) {
	  if (Array.isArray(val) || isIterable(val)) return val;
	  if (typeof val == 'number') return Array.apply(null, Array(val)).map(function (_, i) {
	    return i + 1;
	  });else throw new Error("Must pass an Array, Number or Iterable to a repeat, you passed " + (typeof val === 'undefined' ? 'undefined' : (0, _typeof3.default)(val)));
	  // TODO: make this use view.range() and then we can throw nicer errors with view name
	};
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isIterable(obj) {
	  if (obj === undefined || obj === null) {
	    return false;
	  } else {
	    // detect iterable
	    return typeof _symbol2.default != 'undefined' && obj[_iterator2.default] !== undefined || obj['@@iterator'];
	  }
	}

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(342), __esModule: true };

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(6);
	__webpack_require__(30);
	module.exports = __webpack_require__(27)('iterator');

/***/ },
/* 343 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = iff;
	function iff(val) {
	  return !!val;
	}

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(303);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _routeParser = __webpack_require__(345);
	
	var _routeParser2 = _interopRequireDefault(_routeParser);
	
	var _history = __webpack_require__(273);
	
	var _internal = __webpack_require__(310);
	
	var _internal2 = _interopRequireDefault(_internal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Internal = undefined;
	var history = undefined,
	    render = undefined;
	var activeID = 1;
	var routes = {};
	var routesList = [];
	var params = {};
	var location = window.location.pathname;
	var listeners = [];
	
	function runListeners(location) {
	  listeners.forEach(function (listener) {
	    listener(location);
	  });
	}
	
	var router = {
	  init: function init(appName, _ref) {
	    var onChange = _ref.onChange;
	
	    Internal = _internal2.default.get(appName);
	    render = onChange;
	    history = (0, _history.createHistory)();
	
	    // router updates
	    history.listen(function (location) {
	      if (Internal.firstRender) return;
	      router.go(location.pathname, { dontPush: true });
	      runListeners(location);
	    });
	  },
	  onChange: function onChange(cb) {
	    if (typeof cb !== 'function') throw new Error('Must provide function to Motion.router.onChange');
	
	    listeners.push(cb);
	  },
	  link: function link() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return function () {
	      return router.go.apply(router, args);
	    };
	  },
	  back: function back() {
	    history.goBack();
	  },
	  forward: function forward() {
	    history.goForward();
	  },
	  go: function go(path) {
	    var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    // wait for after first render
	    if (Internal.firstRender) return setTimeout(function () {
	      return router.go(path, opts);
	    });
	    if (!render) return;
	
	    // external links
	    if (path.indexOf('http://') == 0 || path.indexOf('https://') == 0) {
	      window.location.assign(path);
	      return;
	    }
	
	    // query changes
	    if (path[0] === '?') path = location + path;
	
	    // ensure prefixed with /
	    if (path[0] !== '/') path = '/' + path;
	
	    location = path;
	
	    if (!opts.dontPush) history.push(path);
	    router.next();
	    router.recognize();
	    if (!opts.dontRender) render();
	    if (!opts.keepScroll) setTimeout(function () {
	      return window.scrollTo(0, 0);
	    });
	  },
	  isActive: function isActive(path) {
	    return routes[path] == activeID // /article/:id
	     || window.location.pathname == path // /article/123
	    ;
	  },
	  next: function next() {
	    activeID += 1; // on change route, reset matchers
	  },
	  recognize: function recognize() {
	    var matches = 0;
	
	    routesList.forEach(function (_ref2) {
	      var route = _ref2.route;
	      var path = _ref2.path;
	
	      var routeParams = route.match(location);
	      if (routeParams) {
	        matches++;
	        router.setActive(path, routeParams);
	      }
	    });
	
	    // 404
	    if (!matches && routes[404]) {
	      router.setActive(404);
	    }
	  },
	  setActive: function setActive(path, newParams) {
	    if (newParams) delete newParams._; // ??
	    routes[path] = activeID;
	    params[path] = newParams;
	    router.params = newParams;
	  },
	  add: function add(path) {
	    // this is ridiculous (at the moment, but it works)
	    // matches all sub routes, so we can show the whole tree
	    var lazy = '(/*_)(/*_)(/*_)(/*_)(/*_)(/*_)(/*_)(/*_)';
	
	    if ((typeof path === 'undefined' ? 'undefined' : (0, _typeof3.default)(path)) == 'object') {
	      var opts = path;
	      path = opts.path;
	
	      if (opts.strict) lazy = '/';
	    } else {
	      // TODO: babel needs to add unique key to routematch
	      if (routes[path]) return;
	    }
	
	    var _path = path + lazy;
	    var route = new _routeParser2.default(_path);
	
	    routesList.push({ route: route, path: path });
	    routes[path] = activeID;
	
	    router.next();
	    router.recognize();
	  },
	  getParams: function getParams(path) {
	    return { params: params[path] };
	  }
	};
	
	exports.default = router;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @module Passage
	 */
	'use strict';
	
	var Route = __webpack_require__(346);
	
	
	module.exports = Route;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var Parser = __webpack_require__(347),
	    RegexpVisitor = __webpack_require__(350),
	    ReverseVisitor = __webpack_require__(352);
	
	var RoutePrototype = Object.create(null);
	
	/**
	 * Match a path against this route, returning the matched parameters if
	 * it matches, false if not.
	 * @example
	 * var route = new Route('/this/is/my/route')
	 * route.match('/this/is/my/route') // -> {}
	 * @example
	 * var route = new Route('/:one/:two')
	 * route.match('/foo/bar/') // -> {one: 'foo', two: 'bar'}
	 * @param  {string} path the path to match this route against
	 * @return {(Object.<string,string>|false)} A map of the matched route
	 * parameters, or false if matching failed
	 */
	RoutePrototype.match = function(path) {
	  var re = RegexpVisitor.visit(this.ast),
	      matched = re.match(path);
	
	  return matched ? matched : false;
	
	};
	
	/**
	 * Reverse a route specification to a path, returning false if it can't be
	 * fulfilled
	 * @example
	 * var route = new Route('/:one/:two')
	 * route.reverse({one: 'foo', two: 'bar'}) -> '/foo/bar'
	 * @param  {Object} params The parameters to fill in
	 * @return {(String|false)} The filled in path
	 */
	RoutePrototype.reverse = function(params) {
	  return ReverseVisitor.visit(this.ast, params);
	};
	
	/**
	 * Represents a route
	 * @example
	 * var route = Route('/:foo/:bar');
	 * @example
	 * var route = Route('/:foo/:bar');
	 * @param {string} spec -  the string specification of the route.
	 *     use :param for single portion captures, *param for splat style captures,
	 *     and () for optional route branches
	 * @constructor
	 */
	
	module.exports = function(spec) {
	  var route = Object.create(RoutePrototype);
	  if( typeof spec === 'undefined' ) {
	    throw new Error('A route spec is required');
	  }
	  route.spec = spec;
	  route.ast = Parser.parse(spec);
	  return route;
	}

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @module route/parser
	 */
	'use strict';
	
	/** Wrap the compiled parser with the context to create node objects */
	var parser = __webpack_require__(348).parser;
	parser.yy = __webpack_require__(349);
	module.exports = parser;


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/* parser generated by jison 0.4.15 */
	/*
	  Returns a Parser object of the following structure:
	
	  Parser: {
	    yy: {}
	  }
	
	  Parser.prototype: {
	    yy: {},
	    trace: function(),
	    symbols_: {associative list: name ==> number},
	    terminals_: {associative list: number ==> name},
	    productions_: [...],
	    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
	    table: [...],
	    defaultActions: {...},
	    parseError: function(str, hash),
	    parse: function(input),
	
	    lexer: {
	        EOF: 1,
	        parseError: function(str, hash),
	        setInput: function(input),
	        input: function(),
	        unput: function(str),
	        more: function(),
	        less: function(n),
	        pastInput: function(),
	        upcomingInput: function(),
	        showPosition: function(),
	        test_match: function(regex_match_array, rule_index),
	        next: function(),
	        lex: function(),
	        begin: function(condition),
	        popState: function(),
	        _currentRules: function(),
	        topState: function(),
	        pushState: function(condition),
	
	        options: {
	            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
	            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
	            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
	        },
	
	        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
	        rules: [...],
	        conditions: {associative list: name ==> set},
	    }
	  }
	
	
	  token location info (@$, _$, etc.): {
	    first_line: n,
	    last_line: n,
	    first_column: n,
	    last_column: n,
	    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
	  }
	
	
	  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
	    text:        (matched text)
	    token:       (the produced terminal token, if any)
	    line:        (yylineno)
	  }
	  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
	    loc:         (yylloc)
	    expected:    (string describing the set of expected tokens)
	    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
	  }
	*/
	var parser = (function(){
	var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,9],$V1=[1,10],$V2=[1,11],$V3=[1,12],$V4=[5,11,12,13,14,15];
	var parser = {trace: function trace() { },
	yy: {},
	symbols_: {"error":2,"root":3,"expressions":4,"EOF":5,"expression":6,"optional":7,"literal":8,"splat":9,"param":10,"(":11,")":12,"LITERAL":13,"SPLAT":14,"PARAM":15,"$accept":0,"$end":1},
	terminals_: {2:"error",5:"EOF",11:"(",12:")",13:"LITERAL",14:"SPLAT",15:"PARAM"},
	productions_: [0,[3,2],[3,1],[4,2],[4,1],[6,1],[6,1],[6,1],[6,1],[7,3],[8,1],[9,1],[10,1]],
	performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
	/* this == yyval */
	
	var $0 = $$.length - 1;
	switch (yystate) {
	case 1:
	return new yy.Root({},[$$[$0-1]])
	break;
	case 2:
	return new yy.Root({},[new yy.Literal({value: ''})])
	break;
	case 3:
	this.$ = new yy.Concat({},[$$[$0-1],$$[$0]]);
	break;
	case 4: case 5:
	this.$ = $$[$0];
	break;
	case 6:
	this.$ = new yy.Literal({value: $$[$0]});
	break;
	case 7:
	this.$ = new yy.Splat({name: $$[$0]});
	break;
	case 8:
	this.$ = new yy.Param({name: $$[$0]});
	break;
	case 9:
	this.$ = new yy.Optional({},[$$[$0-1]]);
	break;
	case 10:
	this.$ = yytext;
	break;
	case 11: case 12:
	this.$ = yytext.slice(1);
	break;
	}
	},
	table: [{3:1,4:2,5:[1,3],6:4,7:5,8:6,9:7,10:8,11:$V0,13:$V1,14:$V2,15:$V3},{1:[3]},{5:[1,13],6:14,7:5,8:6,9:7,10:8,11:$V0,13:$V1,14:$V2,15:$V3},{1:[2,2]},o($V4,[2,4]),o($V4,[2,5]),o($V4,[2,6]),o($V4,[2,7]),o($V4,[2,8]),{4:15,6:4,7:5,8:6,9:7,10:8,11:$V0,13:$V1,14:$V2,15:$V3},o($V4,[2,10]),o($V4,[2,11]),o($V4,[2,12]),{1:[2,1]},o($V4,[2,3]),{6:14,7:5,8:6,9:7,10:8,11:$V0,12:[1,16],13:$V1,14:$V2,15:$V3},o($V4,[2,9])],
	defaultActions: {3:[2,2],13:[2,1]},
	parseError: function parseError(str, hash) {
	    if (hash.recoverable) {
	        this.trace(str);
	    } else {
	        throw new Error(str);
	    }
	},
	parse: function parse(input) {
	    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
	    var args = lstack.slice.call(arguments, 1);
	    var lexer = Object.create(this.lexer);
	    var sharedState = { yy: {} };
	    for (var k in this.yy) {
	        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
	            sharedState.yy[k] = this.yy[k];
	        }
	    }
	    lexer.setInput(input, sharedState.yy);
	    sharedState.yy.lexer = lexer;
	    sharedState.yy.parser = this;
	    if (typeof lexer.yylloc == 'undefined') {
	        lexer.yylloc = {};
	    }
	    var yyloc = lexer.yylloc;
	    lstack.push(yyloc);
	    var ranges = lexer.options && lexer.options.ranges;
	    if (typeof sharedState.yy.parseError === 'function') {
	        this.parseError = sharedState.yy.parseError;
	    } else {
	        this.parseError = Object.getPrototypeOf(this).parseError;
	    }
	    function popStack(n) {
	        stack.length = stack.length - 2 * n;
	        vstack.length = vstack.length - n;
	        lstack.length = lstack.length - n;
	    }
	    _token_stack:
	        function lex() {
	            var token;
	            token = lexer.lex() || EOF;
	            if (typeof token !== 'number') {
	                token = self.symbols_[token] || token;
	            }
	            return token;
	        }
	    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
	    while (true) {
	        state = stack[stack.length - 1];
	        if (this.defaultActions[state]) {
	            action = this.defaultActions[state];
	        } else {
	            if (symbol === null || typeof symbol == 'undefined') {
	                symbol = lex();
	            }
	            action = table[state] && table[state][symbol];
	        }
	                    if (typeof action === 'undefined' || !action.length || !action[0]) {
	                var errStr = '';
	                expected = [];
	                for (p in table[state]) {
	                    if (this.terminals_[p] && p > TERROR) {
	                        expected.push('\'' + this.terminals_[p] + '\'');
	                    }
	                }
	                if (lexer.showPosition) {
	                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
	                } else {
	                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
	                }
	                this.parseError(errStr, {
	                    text: lexer.match,
	                    token: this.terminals_[symbol] || symbol,
	                    line: lexer.yylineno,
	                    loc: yyloc,
	                    expected: expected
	                });
	            }
	        if (action[0] instanceof Array && action.length > 1) {
	            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
	        }
	        switch (action[0]) {
	        case 1:
	            stack.push(symbol);
	            vstack.push(lexer.yytext);
	            lstack.push(lexer.yylloc);
	            stack.push(action[1]);
	            symbol = null;
	            if (!preErrorSymbol) {
	                yyleng = lexer.yyleng;
	                yytext = lexer.yytext;
	                yylineno = lexer.yylineno;
	                yyloc = lexer.yylloc;
	                if (recovering > 0) {
	                    recovering--;
	                }
	            } else {
	                symbol = preErrorSymbol;
	                preErrorSymbol = null;
	            }
	            break;
	        case 2:
	            len = this.productions_[action[1]][1];
	            yyval.$ = vstack[vstack.length - len];
	            yyval._$ = {
	                first_line: lstack[lstack.length - (len || 1)].first_line,
	                last_line: lstack[lstack.length - 1].last_line,
	                first_column: lstack[lstack.length - (len || 1)].first_column,
	                last_column: lstack[lstack.length - 1].last_column
	            };
	            if (ranges) {
	                yyval._$.range = [
	                    lstack[lstack.length - (len || 1)].range[0],
	                    lstack[lstack.length - 1].range[1]
	                ];
	            }
	            r = this.performAction.apply(yyval, [
	                yytext,
	                yyleng,
	                yylineno,
	                sharedState.yy,
	                action[1],
	                vstack,
	                lstack
	            ].concat(args));
	            if (typeof r !== 'undefined') {
	                return r;
	            }
	            if (len) {
	                stack = stack.slice(0, -1 * len * 2);
	                vstack = vstack.slice(0, -1 * len);
	                lstack = lstack.slice(0, -1 * len);
	            }
	            stack.push(this.productions_[action[1]][0]);
	            vstack.push(yyval.$);
	            lstack.push(yyval._$);
	            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
	            stack.push(newState);
	            break;
	        case 3:
	            return true;
	        }
	    }
	    return true;
	}};
	/* generated by jison-lex 0.3.4 */
	var lexer = (function(){
	var lexer = ({
	
	EOF:1,
	
	parseError:function parseError(str, hash) {
	        if (this.yy.parser) {
	            this.yy.parser.parseError(str, hash);
	        } else {
	            throw new Error(str);
	        }
	    },
	
	// resets the lexer, sets new input
	setInput:function (input, yy) {
	        this.yy = yy || this.yy || {};
	        this._input = input;
	        this._more = this._backtrack = this.done = false;
	        this.yylineno = this.yyleng = 0;
	        this.yytext = this.matched = this.match = '';
	        this.conditionStack = ['INITIAL'];
	        this.yylloc = {
	            first_line: 1,
	            first_column: 0,
	            last_line: 1,
	            last_column: 0
	        };
	        if (this.options.ranges) {
	            this.yylloc.range = [0,0];
	        }
	        this.offset = 0;
	        return this;
	    },
	
	// consumes and returns one char from the input
	input:function () {
	        var ch = this._input[0];
	        this.yytext += ch;
	        this.yyleng++;
	        this.offset++;
	        this.match += ch;
	        this.matched += ch;
	        var lines = ch.match(/(?:\r\n?|\n).*/g);
	        if (lines) {
	            this.yylineno++;
	            this.yylloc.last_line++;
	        } else {
	            this.yylloc.last_column++;
	        }
	        if (this.options.ranges) {
	            this.yylloc.range[1]++;
	        }
	
	        this._input = this._input.slice(1);
	        return ch;
	    },
	
	// unshifts one char (or a string) into the input
	unput:function (ch) {
	        var len = ch.length;
	        var lines = ch.split(/(?:\r\n?|\n)/g);
	
	        this._input = ch + this._input;
	        this.yytext = this.yytext.substr(0, this.yytext.length - len);
	        //this.yyleng -= len;
	        this.offset -= len;
	        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
	        this.match = this.match.substr(0, this.match.length - 1);
	        this.matched = this.matched.substr(0, this.matched.length - 1);
	
	        if (lines.length - 1) {
	            this.yylineno -= lines.length - 1;
	        }
	        var r = this.yylloc.range;
	
	        this.yylloc = {
	            first_line: this.yylloc.first_line,
	            last_line: this.yylineno + 1,
	            first_column: this.yylloc.first_column,
	            last_column: lines ?
	                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
	                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
	              this.yylloc.first_column - len
	        };
	
	        if (this.options.ranges) {
	            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
	        }
	        this.yyleng = this.yytext.length;
	        return this;
	    },
	
	// When called from action, caches matched text and appends it on next action
	more:function () {
	        this._more = true;
	        return this;
	    },
	
	// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
	reject:function () {
	        if (this.options.backtrack_lexer) {
	            this._backtrack = true;
	        } else {
	            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
	                text: "",
	                token: null,
	                line: this.yylineno
	            });
	
	        }
	        return this;
	    },
	
	// retain first n characters of the match
	less:function (n) {
	        this.unput(this.match.slice(n));
	    },
	
	// displays already matched input, i.e. for error messages
	pastInput:function () {
	        var past = this.matched.substr(0, this.matched.length - this.match.length);
	        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
	    },
	
	// displays upcoming input, i.e. for error messages
	upcomingInput:function () {
	        var next = this.match;
	        if (next.length < 20) {
	            next += this._input.substr(0, 20-next.length);
	        }
	        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
	    },
	
	// displays the character position where the lexing error occurred, i.e. for error messages
	showPosition:function () {
	        var pre = this.pastInput();
	        var c = new Array(pre.length + 1).join("-");
	        return pre + this.upcomingInput() + "\n" + c + "^";
	    },
	
	// test the lexed token: return FALSE when not a match, otherwise return token
	test_match:function (match, indexed_rule) {
	        var token,
	            lines,
	            backup;
	
	        if (this.options.backtrack_lexer) {
	            // save context
	            backup = {
	                yylineno: this.yylineno,
	                yylloc: {
	                    first_line: this.yylloc.first_line,
	                    last_line: this.last_line,
	                    first_column: this.yylloc.first_column,
	                    last_column: this.yylloc.last_column
	                },
	                yytext: this.yytext,
	                match: this.match,
	                matches: this.matches,
	                matched: this.matched,
	                yyleng: this.yyleng,
	                offset: this.offset,
	                _more: this._more,
	                _input: this._input,
	                yy: this.yy,
	                conditionStack: this.conditionStack.slice(0),
	                done: this.done
	            };
	            if (this.options.ranges) {
	                backup.yylloc.range = this.yylloc.range.slice(0);
	            }
	        }
	
	        lines = match[0].match(/(?:\r\n?|\n).*/g);
	        if (lines) {
	            this.yylineno += lines.length;
	        }
	        this.yylloc = {
	            first_line: this.yylloc.last_line,
	            last_line: this.yylineno + 1,
	            first_column: this.yylloc.last_column,
	            last_column: lines ?
	                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
	                         this.yylloc.last_column + match[0].length
	        };
	        this.yytext += match[0];
	        this.match += match[0];
	        this.matches = match;
	        this.yyleng = this.yytext.length;
	        if (this.options.ranges) {
	            this.yylloc.range = [this.offset, this.offset += this.yyleng];
	        }
	        this._more = false;
	        this._backtrack = false;
	        this._input = this._input.slice(match[0].length);
	        this.matched += match[0];
	        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
	        if (this.done && this._input) {
	            this.done = false;
	        }
	        if (token) {
	            return token;
	        } else if (this._backtrack) {
	            // recover context
	            for (var k in backup) {
	                this[k] = backup[k];
	            }
	            return false; // rule action called reject() implying the next rule should be tested instead.
	        }
	        return false;
	    },
	
	// return next match in input
	next:function () {
	        if (this.done) {
	            return this.EOF;
	        }
	        if (!this._input) {
	            this.done = true;
	        }
	
	        var token,
	            match,
	            tempMatch,
	            index;
	        if (!this._more) {
	            this.yytext = '';
	            this.match = '';
	        }
	        var rules = this._currentRules();
	        for (var i = 0; i < rules.length; i++) {
	            tempMatch = this._input.match(this.rules[rules[i]]);
	            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
	                match = tempMatch;
	                index = i;
	                if (this.options.backtrack_lexer) {
	                    token = this.test_match(tempMatch, rules[i]);
	                    if (token !== false) {
	                        return token;
	                    } else if (this._backtrack) {
	                        match = false;
	                        continue; // rule action called reject() implying a rule MISmatch.
	                    } else {
	                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
	                        return false;
	                    }
	                } else if (!this.options.flex) {
	                    break;
	                }
	            }
	        }
	        if (match) {
	            token = this.test_match(match, rules[index]);
	            if (token !== false) {
	                return token;
	            }
	            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
	            return false;
	        }
	        if (this._input === "") {
	            return this.EOF;
	        } else {
	            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
	                text: "",
	                token: null,
	                line: this.yylineno
	            });
	        }
	    },
	
	// return next match that has a token
	lex:function lex() {
	        var r = this.next();
	        if (r) {
	            return r;
	        } else {
	            return this.lex();
	        }
	    },
	
	// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
	begin:function begin(condition) {
	        this.conditionStack.push(condition);
	    },
	
	// pop the previously active lexer condition state off the condition stack
	popState:function popState() {
	        var n = this.conditionStack.length - 1;
	        if (n > 0) {
	            return this.conditionStack.pop();
	        } else {
	            return this.conditionStack[0];
	        }
	    },
	
	// produce the lexer rule set which is active for the currently active lexer condition state
	_currentRules:function _currentRules() {
	        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
	            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
	        } else {
	            return this.conditions["INITIAL"].rules;
	        }
	    },
	
	// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
	topState:function topState(n) {
	        n = this.conditionStack.length - 1 - Math.abs(n || 0);
	        if (n >= 0) {
	            return this.conditionStack[n];
	        } else {
	            return "INITIAL";
	        }
	    },
	
	// alias for begin(condition)
	pushState:function pushState(condition) {
	        this.begin(condition);
	    },
	
	// return the number of states currently on the stack
	stateStackSize:function stateStackSize() {
	        return this.conditionStack.length;
	    },
	options: {},
	performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
	var YYSTATE=YY_START;
	switch($avoiding_name_collisions) {
	case 0:return "(";
	break;
	case 1:return ")";
	break;
	case 2:return "SPLAT";
	break;
	case 3:return "PARAM";
	break;
	case 4:return "LITERAL";
	break;
	case 5:return "LITERAL";
	break;
	case 6:return "EOF";
	break;
	}
	},
	rules: [/^(?:\()/,/^(?:\))/,/^(?:\*+\w+)/,/^(?::+\w+)/,/^(?:[\w%\-~\n]+)/,/^(?:.)/,/^(?:$)/],
	conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6],"inclusive":true}}
	});
	return lexer;
	})();
	parser.lexer = lexer;
	function Parser () {
	  this.yy = {};
	}
	Parser.prototype = parser;parser.Parser = Parser;
	return new Parser;
	})();
	
	
	if (true) {
	exports.parser = parser;
	exports.Parser = parser.Parser;
	exports.parse = function () { return parser.parse.apply(parser, arguments); };
	}

/***/ },
/* 349 */
/***/ function(module, exports) {

	'use strict';
	/** @module route/nodes */
	
	
	/**
	 * Create a node for use with the parser, giving it a constructor that takes
	 * props, children, and returns an object with props, children, and a
	 * displayName.
	 * @param  {String} displayName The display name for the node
	 * @return {{displayName: string, props: Object, children: Array}}
	 */
	function createNode(displayName) {
	  return function(props, children) {
	    return {
	      displayName: displayName,
	      props: props,
	      children: children || []
	    };
	  };
	}
	
	module.exports = {
	  Root: createNode('Root'),
	  Concat: createNode('Concat'),
	  Literal: createNode('Literal'),
	  Splat: createNode('Splat'),
	  Param: createNode('Param'),
	  Optional: createNode('Optional')
	};


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createVisitor  = __webpack_require__(351),
	    escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g;
	
	/**
	 * @class
	 * @private
	 */
	function Matcher(options) {
	  this.captures = options.captures;
	  this.re = options.re;
	}
	
	/**
	 * Try matching a path against the generated regular expression
	 * @param  {String} path The path to try to match
	 * @return {Object|false}      matched parameters or false
	 */
	Matcher.prototype.match = function (path) {
	  var match = this.re.exec(path),
	      matchParams = {};
	
	  if( !match ) {
	    return;
	  }
	
	  this.captures.forEach( function(capture, i) {
	    if( typeof match[i+1] === 'undefined' ) {
	      matchParams[capture] = undefined;
	    }
	    else {
	      matchParams[capture] = decodeURIComponent(match[i+1]);
	    }
	  });
	
	  return matchParams;
	};
	
	/**
	 * Visitor for the AST to create a regular expression matcher
	 * @class RegexpVisitor
	 * @borrows Visitor-visit
	 */
	var RegexpVisitor = createVisitor({
	  'Concat': function(node) {
	    return node.children
	      .reduce(
	        function(memo, child) {
	          var childResult = this.visit(child);
	          return {
	            re: memo.re + childResult.re,
	            captures: memo.captures.concat(childResult.captures)
	          };
	        }.bind(this),
	        {re: '', captures: []}
	      );
	  },
	  'Literal': function(node) {
	    return {
	      re: node.props.value.replace(escapeRegExp, '\\$&'),
	      captures: []
	    };
	  },
	
	  'Splat': function(node) {
	    return {
	      re: '([^?]*?)',
	      captures: [node.props.name]
	    };
	  },
	
	  'Param': function(node) {
	    return {
	      re: '([^\\/\\?]+)',
	      captures: [node.props.name]
	    };
	  },
	
	  'Optional': function(node) {
	    var child = this.visit(node.children[0]);
	    return {
	      re: '(?:' + child.re + ')?',
	      captures: child.captures
	    };
	  },
	
	  'Root': function(node) {
	    var childResult = this.visit(node.children[0]);
	    return new Matcher({
	      re: new RegExp('^' + childResult.re + '(?=\\?|$)' ),
	      captures: childResult.captures
	    });
	  }
	});
	
	module.exports = RegexpVisitor;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/**
	 * @module route/visitors/create_visitor
	 */
	
	var nodeTypes = Object.keys(__webpack_require__(349));
	
	/**
	 * Helper for creating visitors. Take an object of node name to handler
	 * mappings, returns an object with a "visit" method that can be called
	 * @param  {Object.<string,function(node,context)>} handlers A mapping of node
	 * type to visitor functions
	 * @return {{visit: function(node,context)}}  A visitor object with a "visit"
	 * method that can be called on a node with a context
	 */
	function createVisitor(handlers) {
	  nodeTypes.forEach(function(nodeType) {
	    if( typeof handlers[nodeType] === 'undefined') {
	      throw new Error('No handler defined for ' + nodeType.displayName);
	    }
	
	  });
	
	  return {
	    /**
	     * Call the given handler for this node type
	     * @param  {Object} node    the AST node
	     * @param  {Object} context context to pass through to handlers
	     * @return {Object}
	     */
	    visit: function(node, context) {
	      return this.handlers[node.displayName].call(this,node, context);
	    },
	    handlers: handlers
	  };
	}
	
	module.exports = createVisitor;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createVisitor  = __webpack_require__(351);
	
	/**
	 * Visitor for the AST to construct a path with filled in parameters
	 * @class ReverseVisitor
	 * @borrows Visitor-visit
	 */
	var ReverseVisitor = createVisitor({
	  'Concat': function(node, context) {
	    var childResults =  node.children
	      .map( function(child) {
	        return this.visit(child,context);
	      }.bind(this));
	
	    if( childResults.some(function(c) { return c === false; }) ) {
	      return false;
	    }
	    else {
	      return childResults.join('');
	    }
	  },
	
	  'Literal': function(node) {
	    return decodeURI(node.props.value);
	  },
	
	  'Splat': function(node, context) {
	    if( context[node.props.name] ) {
	      return context[node.props.name];
	    }
	    else {
	      return false;
	    }
	  },
	
	  'Param': function(node, context) {
	    if( context[node.props.name] ) {
	      return context[node.props.name];
	    }
	    else {
	      return false;
	    }
	  },
	
	  'Optional': function(node, context) {
	    var childResult = this.visit(node.children[0], context);
	    if( childResult ) {
	      return childResult;
	    }
	    else {
	      return '';
	    }
	  },
	
	  'Root': function(node, context) {
	    context = context || {};
	    var childResult = this.visit(node.children[0], context);
	    if( !childResult ) {
	      return false;
	    }
	    return encodeURI(childResult);
	  }
	});
	
	module.exports = ReverseVisitor;

/***/ },
/* 353 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requireFactory;
	var parentFolderMatch = function parentFolderMatch(s) {
	  return s.match(/\.\.\//g);
	};
	
	function requireFactory(root) {
	  var app = '';
	
	  function require(name, folder) {
	    if (!name) return;
	
	    if (name.charAt(0) == '.') {
	      var parentDirs = folder.split('/');
	      var upDirs = parentFolderMatch(name);
	
	      // remove from folder based on upwards ../
	      if (upDirs && upDirs.length) {
	        if (upDirs.length > parentDirs.length) {
	          throw new Error('The path ' + name + ' is looking upwards above the root!');
	        }
	
	        parentDirs.splice(-upDirs.length);
	      }
	
	      var parentPath = parentDirs.join('/');
	
	      var cleanName = (parentPath ? parentPath + '/' : '') + name.replace(/^(\.\.?\/)+/, '');
	
	      // try /index for directory shorthand
	      return getInternal(cleanName, folder);
	    }
	
	    // exports
	    if (name.indexOf('exports.') == 0) return root.exports[name.replace('exports.', '')];
	
	    // get pkg
	    var pkg = getExternal(name, folder);
	
	    // we may be waiting for packages reload
	    if (!pkg) return;
	
	    // may not export a default
	    if (!pkg.default) pkg.default = pkg;
	
	    return pkg;
	  }
	
	  function getExternal(name, folder) {
	    return safeGet(root.exports, 'externals', [name], folder);
	  }
	
	  function getInternal(name, folder) {
	    return safeGet(root.exports, 'internals', [name, name + '/index'], folder);
	  }
	
	  function safeGet(obj, _ns, names, folder) {
	    var ns = app + '-' + _ns;
	    if (!obj[ns]) {
	      console.error(_ns + ' not bundled, looking for ' + names[0]);
	      return {};
	    }
	
	    var found = undefined,
	        name = undefined,
	        i = undefined,
	        len = names.length;
	
	    for (i = 0; i < len; i++) {
	      found = names[i];
	      if (typeof obj[ns][found] != 'undefined') {
	        name = found;
	        break;
	      }
	    }
	
	    if (typeof obj[ns][name] == 'undefined') {
	      var where = folder ? ' into ' + folder : '';
	
	      console.error('Can\'t find import "' + names[0] + '"' + where + ' (using exports["' + ns + '"]["' + names[0] + '"])');
	      return {};
	    }
	
	    return obj[ns][name];
	  }
	
	  require.setApp = function (appname) {
	    app = appname;
	  };
	
	  return require;
	}

/***/ },
/* 354 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = staticStyles;
	function staticStyles(name, tagToClass, object) {
	  this.styleClasses[name] = tagToClass;
	  this.styleObjects[name] = object;
	}

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = safeRun;
	function safeRun(prefix, fn) {
	  if (true) fn();else {
	    try {
	      fn();
	    } catch (e) {
	      var name = e.name;
	      var message = e.message;
	      var stack = e.stack;
	
	      console.log('Error in', prefix);
	      reportError({ name: name, message: message, stack: stack });
	      throw e;
	    }
	  }
	}

/***/ },
/* 356 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (arr, arr2) {
	  return arr.filter(function (i) {
	    return arr2.indexOf(i) < 0;
	  });
	};

/***/ },
/* 357 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ErrorDefinedTwice = function ErrorDefinedTwice(name) {
	  return function () {
	    return React.createElement(
	      'p',
	      { style: { color: 'red', fontWeight: 'bold' } },
	      'Error! You\'ve defined the view ',
	      name,
	      ' twice in your codebase.'
	    );
	  };
	};
	
	exports.default = ErrorDefinedTwice;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NotFound = function NotFound(name) {
	  return function () {
	    return React.createElement(
	      'div',
	      { style: { display: 'block' } },
	       true ? '' : 'Motion: View "' + name + '" not found'
	    );
	  };
	};
	
	exports.default = NotFound;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LastWorkingMainFactory;
	
	var _react = __webpack_require__(106);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LastWorkingMainFactory(Internal) {
	  return _react2.default.createClass({
	    render: function render() {
	      return Internal.lastWorkingRenders.Main;
	    }
	  });
	}

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(106);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createClass({
	  displayName: 'Main',
	  render: function render() {
	    var errorStyle = {
	      position: 'fixed',
	      top: 0, left: 0, right: 0, bottom: 0,
	      padding: '10% 0',
	      color: '#999',
	      zIndex: 10000,
	      textAlign: 'center'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { style: errorStyle },
	      'There was an error compiling your Main view.'
	    );
	  }
	});

/***/ }
]);


/** WEBPACK FOOTER **
 ** motion.prod.js
 **/